var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path2, _path3, _g14, _g15, _path4, _g16, _g17, _g18, _g19, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g20, _g21, _g22, _g23, _g24, _g25, _path21, _path22, _path23, _path24, _path25, _path26, _g26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g27, _g28, _g29, _g30, _g31, _g32, _path51, _g33, _g34, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g35, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g36, _path72, _path73, _g37, _g38, _g39, _g40, _path74, _path75, _path76, _g41, _g42, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _g53, _g54, _path113, _path114, _g55, _g56, _g57, _g58, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _g59, _path128, _path129, _g60, _g61, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _g62, _g63, _g64, _g65, _g66, _g67, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _g68, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _g69, _g70, _g71, _g72, _g73, _path166, _path167, _g74, _g75, _g76, _g77, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_499",
    "data-name": "Group 499",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198.191,
    height: 97.826,
    viewBox: "0 0 198.191 97.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 198.191,
    height: 97.826,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 198.191,
    height: 97.827,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 16.032,
    height: 16.775,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 14.073,
    height: 20.204,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 14.263,
    height: 23.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 9.543,
    height: 7.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 17.848,
    height: 19.765,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 69.829,
    height: 76.082,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 6.788,
    height: 7.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 28.042,
    height: 9.038,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 18.288,
    height: 23.684,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 5.8,
    height: 9.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 8.129,
    height: 2.849,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 3.464,
    height: 5.434,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 2.986,
    height: 5.734,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 13.509,
    height: 15.039,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 12.685,
    height: 17.101,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 12.498,
    height: 6.932,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 65.286,
    height: 43.733,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 6.488,
    height: 4.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 3.387,
    height: 2.037,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 3.229,
    height: 4.727,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 1.689,
    height: 1.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 3.361,
    height: 3.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 1.69,
    height: 1.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 1.352,
    height: 2.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.352,
    height: 2.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 33.035,
    height: 13.072,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 51.695,
    height: 54.181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 27.199,
    height: 43.367,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 26.285,
    height: 27.208,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 4.378,
    height: 11.99,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 1.736,
    height: 12.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 7.792,
    height: 6.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 2.591,
    height: 4.487,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 1.508,
    height: 5.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 13.355,
    height: 17.487,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 16.486,
    height: 18.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 11.563,
    height: 5.219,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 13.269,
    height: 7.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 15.054,
    height: 10.774,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 13.993,
    height: 5.93,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 65.836,
    height: 40.337,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 50.542,
    height: 31.101,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 65.159,
    height: 36.206,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 16.127,
    height: 11.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 16.574,
    height: 12.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 13.674,
    height: 14.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 14.406,
    height: 6.075,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 19.118,
    height: 4.945,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 11.75,
    height: 3.099,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 4.701,
    height: 12.976,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 24.735,
    height: 9.605,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 15.722,
    height: 9.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 9.994,
    height: 12.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 6.751,
    height: 11.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 8.137,
    height: 11.961,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 10.438,
    height: 7.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 8.135,
    height: 3.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 8.35,
    height: 5.157,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 6.945,
    height: 2.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 38.234,
    height: 17.271,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 22.306,
    height: 9.501,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 33.801,
    height: 13.465,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 2.633,
    height: 3.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 2.509,
    height: 3.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 2.515,
    height: 3.785,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 2.342,
    height: 4.21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 2.14,
    height: 4.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 1.26,
    height: 5.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 12.099,
    height: 5.396,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 5.003,
    height: 8.093,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 6.087,
    height: 9.971,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 3.103,
    height: 4.436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 4.044,
    height: 5.968,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 26.8,
    height: 20.28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 0.649,
    height: 1.544,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 0.52,
    height: 1.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.91,
    height: 2.07,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 0.742,
    height: 1.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 0.671,
    height: 1.658,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 0.943,
    height: 1.431,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M129.3,30.581c-.049-.134-.1-.264-.153-.39-.042-1.29-.212-2.61-.316-3.888a19.7,19.7,0,0,0-.8-4.1c-.439-1.457-1.1-3.451-2.415-4.444a9.4,9.4,0,0,0,2.8-.545c.046.008.091.02.137.026a.085.085,0,0,0,.093-.087c.018,0,.038-.011.055-.014a.091.091,0,0,0,0-.179c-.155-.021-.305-.036-.454-.046a34.508,34.508,0,0,1-4.955-2.928,5.8,5.8,0,0,0-3.4-1.187,32.012,32.012,0,0,0,6-3.945.078.078,0,0,0-.079-.132l-.527.246a.111.111,0,0,0-.1-.068,33.513,33.513,0,0,0-6.135.671,3.641,3.641,0,0,0-1.7.829,7.893,7.893,0,0,0-1.061-2.677,9.845,9.845,0,0,1-1.369-4.057c-.008-.117-.167-.091-.191,0a4.017,4.017,0,0,0-.083.442.072.072,0,0,0-.106.009c-.669.873-1.947,2.172-2.269,3.439a8.974,8.974,0,0,0-4.21-3.081A41.934,41.934,0,0,0,100.671,2.2a54,54,0,0,0-7.519-.991C91.93,1.126,90.711,1.028,89.5.862A14.246,14.246,0,0,1,85.691.006c-.062-.03-.1.058-.053.1a3.486,3.486,0,0,0,.5.379.108.108,0,0,0,0,.082,3.622,3.622,0,0,0,1.15,1.31c.093.077.184.155.273.234a26.484,26.484,0,0,0-10.031.143A39.4,39.4,0,0,0,71.84,3.6c-1.625.524-4.087.574-5.054,2.163,1.509-.322,4.019.659,5.314.09a11.974,11.974,0,0,0-1.49.777A33.65,33.65,0,0,0,66.1,10.369c-.055.029-.117.049-.168.08a.2.2,0,0,0-.083.14c-.131.114-.264.229-.4.345a.084.084,0,0,0,.087.143,6.031,6.031,0,0,0,.616-.314,12.911,12.911,0,0,0,2.658-.624,2.023,2.023,0,0,1,.243-.044,18.789,18.789,0,0,0-3.275,2.852,10.25,10.25,0,0,0-1.619,2.427,15.2,15.2,0,0,0-1.375,2.976,2.141,2.141,0,0,0-.455,1.009c-.014.079.093.091.127.03.841-1.513,2.844-2,4.468-2.682A12.646,12.646,0,0,0,65.1,21.2a24.455,24.455,0,0,0-.813,5.728,4.827,4.827,0,0,0-.689-.275c-2.128-.644-3.38,1.3-3.829,3.087a9.291,9.291,0,0,0,.7,6.642,3.179,3.179,0,0,0,4.169,1.185,15.7,15.7,0,0,0-.011,4.168,15.221,15.221,0,0,0,3.421,7.628,11.534,11.534,0,0,0,3.359,2.811q.241.13.51.26c0,.011-.006.018,0,.029-.25,1.844-.7,3.659-.99,5.5-1.275,1.194-2.97,1.888-4.069,3.256-1.217,1.512-.228,3.52.59,4.943a25.616,25.616,0,0,1,2.811,5.717c.36,1.284.662,3.363,2.041,4,1.4.647,2.733-.3,3.767-1.211a39.585,39.585,0,0,0,4.272-5.043c1.214-1.486,3.6-2.618,4.152-4.541.448-1.557-1.008-3.123-2.008-4.1a.3.3,0,0,0-.053-.036c.029-.114.056-.225.09-.331a16.669,16.669,0,0,1,.782-2.356,14.447,14.447,0,0,0,2.957.115c2.1.436,4.136,1.132,6.245,1.536a16.506,16.506,0,0,0,6.323-.1,14.382,14.382,0,0,0,9.308-6.438q.212-.321.407-.65a1.594,1.594,0,0,0,.789,1.164,3.963,3.963,0,0,0,3.017.381,8.9,8.9,0,0,0,4.94-4.184,4.612,4.612,0,0,0-.842-5.786,2.954,2.954,0,0,0-.431-.308,6.985,6.985,0,0,0,2.433-2.266,14.261,14.261,0,0,0,1.843-2.8,2.092,2.092,0,0,0,.345-.475c.052-.068.1-.138.152-.208a3.743,3.743,0,0,0,.354.4,15.22,15.22,0,0,1,1.445,1.606.07.07,0,0,0,.124-.035.864.864,0,0,0,0-.108.126.126,0,0,0,.138-.1,19.364,19.364,0,0,0,.395-5.543,10.908,10.908,0,0,0-.436-2.849,5.726,5.726,0,0,1,.724,1.213c.366.918.946,1.741,1.305,2.655.047.124.206.073.231-.035.009-.041.006-.085.015-.134a15.818,15.818,0,0,0,1.395-5.511,9.2,9.2,0,0,0-.483-3.86c.428.653.821,1.33,1.223,2,.364.6.842,1.1,1.173,1.73a5.819,5.819,0,0,0,.475.841c.027.1.05.193.08.287a.112.112,0,0,0,.208-.011.145.145,0,0,0,.146-.19",
    transform: "translate(30.789 0)",
    fill: "#cbc38c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(103.365 22.463)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M75.677,15.4s-9.757,4.584-7.12,11.738,9.1,3.646,10.346,3.11c2.044-.879,7.364-9.645,4.306-13.382-2.383-2.916-5.368-2.069-7.532-1.466",
    transform: "translate(-68.105 -14.801)",
    fill: "#903e8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(125.854 26.158)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M89.924,17.25c-3.256-.26-6.843,2.727-7,10.978s4.028,9.352,8.121,9.2S99.31,29.3,95.485,21.436a7.147,7.147,0,0,0-5.561-4.186",
    transform: "translate(-82.923 -17.235)",
    fill: "#903e8c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(125.586 23.592)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M92.019,36.707a3.153,3.153,0,0,1-.99.216c2.289-.581,4-3.3,4.456-4.148a11.884,11.884,0,0,0,1.378-5.511c-.015-4.011-2.365-8.167-6.355-9.422-.2-.064-1.961-.168.074-.642,1.337-.311,2.832,1.131,3.931,1.78a8.583,8.583,0,0,0-1.082-1.759,5.889,5.889,0,0,0-1.591-1.3c-2.094-1.12-4.691.464-6,1.9a11.194,11.194,0,0,0-2.492,6.056c-.566,3.342-1.075,7.206.153,10.46,1.293,3.432,5,6.115,8.645,4.278a9.122,9.122,0,0,0,4.863-7.736c-.023,1.07-1.489,2.859-2.154,3.649a7.669,7.669,0,0,1-2.837,2.182",
    transform: "translate(-82.746 -15.544)",
    fill: "#cbc38c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(114.953 39.273)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M81.8,25.876c-2-.03-3.7,1.286-4.94,2.721-.724.833-1.829,2.049-.484,2.9a14.1,14.1,0,0,0,6.414,1.877c1.389.038,2.521-.37,2.5-1.944a7.992,7.992,0,0,0-.765-3.143c-.511-1.123-1.32-2.387-2.72-2.412",
    transform: "translate(-75.74 -25.876)",
    fill: "#cbc38c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(102.398 20.614)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M69.482,21.732c-2.213,2.451-2.843,6.449-.659,9.15,2.984,3.69,8.129,2.873,11.324-.056A16.387,16.387,0,0,0,85.2,20.607c.152-1.717.419-4.253-1.109-5.4a8.436,8.436,0,0,0-3.307-1.54c-.041.047-.454-.021-.534-.032-2.9-.4-4.843,1.554-6.523,2.818,2.469-1.34,6.2-2.835,8.029-.381.141.19-.134.068-.34-.012-3.286-1.263-7.247.871-9.525,3.808s-2.362,7.035-.833,9.023c.121.158-.269-.214-.416-.331-2.178-1.729-1.411-4.359-1.155-6.828",
    transform: "translate(-67.468 -13.582)",
    fill: "#cbc38c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(90.265 0)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M129.3,30.582c-.049-.135-.1-.264-.153-.39-.042-1.29-.212-2.61-.316-3.888a19.737,19.737,0,0,0-.8-4.105c-.439-1.456-1.1-3.451-2.415-4.442a9.447,9.447,0,0,0,2.8-.545c.046.006.091.018.137.026a.085.085,0,0,0,.093-.087l.055-.015a.09.09,0,0,0,0-.178c-.155-.021-.305-.038-.454-.046a34.508,34.508,0,0,1-4.955-2.928,5.788,5.788,0,0,0-3.4-1.187,32.012,32.012,0,0,0,6-3.945.079.079,0,0,0-.079-.134c-.181.087-.354.167-.527.246a.113.113,0,0,0-.1-.068,33.811,33.811,0,0,0-6.136.671,3.672,3.672,0,0,0-1.7.829,7.9,7.9,0,0,0-1.061-2.677,9.83,9.83,0,0,1-1.369-4.057c-.008-.115-.167-.09-.191,0a4.017,4.017,0,0,0-.083.442.073.073,0,0,0-.106.011c-.669.871-1.947,2.17-2.269,3.439a8.964,8.964,0,0,0-4.21-3.081,41.934,41.934,0,0,0-7.382-2.272,53.552,53.552,0,0,0-7.519-.991c-1.222-.088-2.441-.185-3.653-.351A14.249,14.249,0,0,1,85.688.006c-.062-.029-.1.058-.053.1a3.387,3.387,0,0,0,.5.381.1.1,0,0,0,0,.08,3.6,3.6,0,0,0,1.15,1.31c.093.079.184.156.273.235a26.484,26.484,0,0,0-10.031.141A39.406,39.406,0,0,0,71.837,3.6c-1.625.524-4.087.572-5.054,2.163,1.509-.323,4.019.659,5.314.09a11.578,11.578,0,0,0-1.49.777A33.422,33.422,0,0,0,66.1,10.371c-.055.027-.117.049-.168.079a.2.2,0,0,0-.083.14c-.131.115-.264.231-.4.345a.085.085,0,0,0,.087.144,6.031,6.031,0,0,0,.616-.314,12.911,12.911,0,0,0,2.658-.624,1.762,1.762,0,0,1,.243-.044,18.845,18.845,0,0,0-3.275,2.85,10.312,10.312,0,0,0-1.619,2.427,15.174,15.174,0,0,0-1.375,2.978,2.136,2.136,0,0,0-.455,1.008c-.014.08.093.093.127.032.841-1.513,2.844-2,4.468-2.683A12.654,12.654,0,0,0,65.1,21.2a26.413,26.413,0,0,0-.788,4.872,2.733,2.733,0,0,1,.454.37.214.214,0,0,1,.149.123c.017.036.038.079.056.117a1.9,1.9,0,0,1,.3.577c.68,1.246,1.575,2.759.549,3.943a.235.235,0,0,1-.358,0c-.982-1.015-3.222-3.448-4.2-.876a8.7,8.7,0,0,0-.27,3.691.227.227,0,0,1-.4.175,4.834,4.834,0,0,1-1.1-2.5,8.4,8.4,0,0,0,.982,4.681,3.182,3.182,0,0,0,4.169,1.185,15.683,15.683,0,0,0-.011,4.166,15.215,15.215,0,0,0,3.421,7.628,11.51,11.51,0,0,0,3.359,2.811c.161.088.331.173.51.26,0,.012-.006.02,0,.029-.25,1.846-.7,3.661-.99,5.5-1.275,1.193-2.97,1.887-4.069,3.256-1.217,1.51-.228,3.52.59,4.942a25.68,25.68,0,0,1,2.811,5.717c.36,1.284.66,3.363,2.041,4,1.4.647,2.733-.305,3.767-1.211a39.689,39.689,0,0,0,4.272-5.043c1.214-1.486,3.6-2.618,4.152-4.541.448-1.559-1.008-3.123-2.008-4.1a.3.3,0,0,0-.053-.036c.029-.114.056-.226.09-.332A16.651,16.651,0,0,1,83.3,58.25a14.555,14.555,0,0,0,2.957.115c2.1.436,4.136,1.131,6.245,1.536a16.536,16.536,0,0,0,6.323-.1,14.379,14.379,0,0,0,9.308-6.44q.212-.321.407-.648a1.589,1.589,0,0,0,.789,1.163,3.963,3.963,0,0,0,3.017.382,7.266,7.266,0,0,0,2.812-1.585,2.149,2.149,0,0,1-1.04.1.224.224,0,0,1-.182-.305,17.181,17.181,0,0,0,1.589-3.621,1.762,1.762,0,0,0-.505-1.975c-.742-.458-1.348-.2-2.111-.325-1.065-.178-.876-1.179-.147-1.7a4.71,4.71,0,0,1,3.321-.824l-.07-.044a6.985,6.985,0,0,0,2.433-2.266,14.227,14.227,0,0,0,1.843-2.8,2.084,2.084,0,0,0,.345-.474c.052-.068.1-.138.152-.209a3.451,3.451,0,0,0,.354.4,15.388,15.388,0,0,1,1.445,1.607.071.071,0,0,0,.124-.035.848.848,0,0,0,0-.108.127.127,0,0,0,.138-.1,19.368,19.368,0,0,0,.395-5.543,10.909,10.909,0,0,0-.436-2.85,5.775,5.775,0,0,1,.724,1.214c.366.918.946,1.739,1.305,2.655.047.123.206.073.229-.035.011-.041.008-.087.017-.135a15.81,15.81,0,0,0,1.395-5.509,9.206,9.206,0,0,0-.483-3.861c.428.654.821,1.33,1.223,2,.364.6.842,1.1,1.173,1.73a5.882,5.882,0,0,0,.475.839c.027.1.05.194.08.288a.112.112,0,0,0,.208-.011.145.145,0,0,0,.146-.19m-46.1,25.962a9.277,9.277,0,0,1-4.538-2.3c-.926-.888-2.345-2.489-1.973-3.92.285-1.1,1.539-1.164,2.492-1.093a21.946,21.946,0,0,1,4.773.83,7.176,7.176,0,0,1,4.23,1.519c.894.733,2.145,2,2.131,3.252-.026,2.8-5.509,2.047-7.115,1.707m33.056-27.3c-.586,3.894-3.341,8.13-4.91,11.667-1.487,3.351-2.334,7.27-4.966,9.973-1.865,1.918-4.866,3.388-7.349,1.63a9.994,9.994,0,0,0-4.706-2.264,23.175,23.175,0,0,1-4.116-.59,29.076,29.076,0,0,1-4.259-2.149,8,8,0,0,0-4.128-.847,6.978,6.978,0,0,1-3.506-.674c-1.172-.546-2.436-1.305-3.782-1.17-2.451.243-5.212.759-7.071-1.346-2.774-3.143-1.034-8.14.141-11.6.715-2.105,1.158-4.5,2.283-6.425,1.585-2.714,4.465-4.278,6.909-6.106.176-.131-.806,1.833-1.082,2.661,3.315-1.968,6.314-4.407,9.528-6.526.193-.124-.8,3.195-1.05,4.75,2.65-1.374,4.417-3.995,7.126-5.3.223-.108-1.562,3.4-2,5.113,3.656-2.316,6.9-5.371,11.092-6.713.193-.062-.637,3.3-.936,4.849,3.028-1,5.808-2.653,8.965-3.275a11.535,11.535,0,0,1,.759,3.319,19.386,19.386,0,0,1,4.429-.864c.129,0,.229.87.073,1.34.323-.071,1.075-.738,1.085-.586.3,3.668,2.032,7.423,1.472,11.128",
    transform: "translate(-59.474 0)",
    fill: "#cbc38c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(139.235 47.231)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M97.133,37.058c-.844,0-2.677-.073-2.923-1.187-.472-2.125,2.474-3.794,4.316-3.07a2.627,2.627,0,0,0-2.817-1.659A3.141,3.141,0,0,0,93.1,33.256c-.458,1.017-1.27,2.029-1.351,3.16-.008.114,0,.228-.009.341.032-.053.067-.1.1-.153a1.594,1.594,0,0,0,.789,1.164,3.964,3.964,0,0,0,3.017.381,6.7,6.7,0,0,0,2.284-1.161,5.143,5.143,0,0,1-.794.07",
    transform: "translate(-91.739 -31.119)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(102.565 45.73)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M89.936,35.54c-2.53-.688-5.06-.95-7.449-2.1-2.545-1.226-5.418-1.12-8.041-2.075-1.36-.495-2.8-1.416-4.312-1.2a12.731,12.731,0,0,0-2.556.671,6.144,6.144,0,0,1,3.123.41c1.61.651,3.051,1.706,4.8,1.984a31.408,31.408,0,0,1,4.987.8,13.89,13.89,0,0,1,4.069,2c1.27.964,2.51,2.245,4.072,2.726a10.607,10.607,0,0,0,3.665.162,9.435,9.435,0,0,1,3.327.252C93.9,37.7,92.162,36.144,89.936,35.54",
    transform: "translate(-67.578 -30.13)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(97.077 52.398)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M80.159,43.1a.3.3,0,0,0-.053-.036c.029-.114.056-.225.09-.332a16.649,16.649,0,0,1,.782-2.354c.123.017.247.03.372.044a2.45,2.45,0,0,0-.389-.2c-.75-.293-1.528-.477-2.287-.736a11.113,11.113,0,0,1-3.954-2.371c-.559-.508-.993-1.3-1.63-1.7a4.073,4.073,0,0,0-1.815-.469,7.845,7.845,0,0,1-1.742-.426c.023.012.041.023.064.033,0,.011-.006.018,0,.027-.162,1.2-.407,2.384-.639,3.571a1.365,1.365,0,0,1,1.326-.722,1.719,1.719,0,0,1,1.194.763,4.788,4.788,0,0,0,2.289,1.463c1.006.442,1.847,1.026,1.906,2.2a7.421,7.421,0,0,1-.894,2.891c-.018.05-.038.1-.055.147-.088.631-.131,1.478.4,1.345s1-.452,1.525-.634c.232-.079.443.217.231.382a31.908,31.908,0,0,0-3.142,2.884c-.97.987-1.688,2.187-2.7,3.131a.228.228,0,0,1-.316-.036,5.552,5.552,0,0,1-.823-2.862,12.5,12.5,0,0,0-.615-2.767,7.4,7.4,0,0,1-.537-1.09c-.055-.09-.109-.181-.17-.267a.218.218,0,0,1,.017-.281,3,3,0,0,1-.055-.389c-.006-.112.058-.252.187-.258a2.724,2.724,0,0,1,1.389.357c-.565-1.592-1.384-3.029-1.446-4.7-.021.121-.044.243-.064.366-1.275,1.193-2.97,1.888-4.069,3.256-1.217,1.512-.228,3.52.59,4.943A25.617,25.617,0,0,1,67.934,54c.36,1.282.662,3.363,2.041,4,1.4.647,2.733-.305,3.767-1.211a39.586,39.586,0,0,0,4.272-5.043c1.214-1.486,3.6-2.618,4.152-4.541.448-1.557-1.008-3.123-2.008-4.1",
    transform: "translate(-63.962 -34.524)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(90.749 30.564)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M65.12,25.693a11.136,11.136,0,0,0,.466-1.808,3.408,3.408,0,0,0-.861-2.331c-.308-.392-1.9-2.064-2.478-1.144a2.531,2.531,0,0,0-.323,1.319c1.442.052,1.1,2.211.589,3.123-.681,1.229-1.843.791-2.72.006a6.073,6.073,0,0,0,.513,1.094,3.181,3.181,0,0,0,4.169,1.187,16.33,16.33,0,0,0-.14,2.219c.2-1.228.481-2.448.785-3.665",
    transform: "translate(-59.793 -20.137)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(120.607 50.79)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M86.936,36.193c-1.374-.132-3.045.194-4.244-.549-1.109-.689-2.16-1.446-3.227-2.179,1.1.379,2.242.653,3.413.938a16.218,16.218,0,0,1,4.716,1.912,3.768,3.768,0,0,0-.659-.121",
    transform: "translate(-79.466 -33.465)",
    fill: "#9b9e85"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(115.616 40.119)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M79.089,31.475a.439.439,0,0,0,.027-.067,21.006,21.006,0,0,0,.521-4.335c-.018-.68-.244-.715-.542-.571a.053.053,0,0,0-.083-.02c-.1.079-.19.159-.282.238-.064.039-.126.079-.19.115a.036.036,0,0,0-.011.05,11.97,11.97,0,0,0-1.607,1.671c-.332.425-.871,1.076-.718,1.654-.073.527.369.914.824,1.157s1.569.7,2.069.4c.077-.046.14-.165.059-.246-.02-.018-.044-.032-.067-.05",
    transform: "translate(-76.177 -26.433)",
    fill: "#9b9e85"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(120.659 40.728)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M82.452,31.56a8.746,8.746,0,0,0-.165-2.682c-.1-.463-.437-2.427-1.246-1.978a.081.081,0,0,0-.021.118c-.962,1-1.169,2.609-1.468,3.907-.346,1.5,1.116,1.8,2.378,1.574a.126.126,0,0,0,.079-.05.251.251,0,0,0,.109-.018c.322-.134.313-.578.334-.871",
    transform: "translate(-79.5 -26.835)",
    fill: "#9b9e85"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M82.975,19.11c.006-3.453-4.347-4.576-7.054-3.665a10.664,10.664,0,0,0-5.1,4.282C68.63,23,68.979,27.709,72.749,29.6c3.8,1.911,7.4-1.269,8.851-4.574a15.32,15.32,0,0,0,1.375-5.921",
    transform: "translate(35.965 7.84)",
    fill: "#fcf6b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M83.36,25.27c-.566,3.813.851,8.727,5.3,9.152,4.415.422,7.37-3.636,7.264-7.835a11.46,11.46,0,0,0-2.135-6.765c-1.9-2.356-6.393-3.806-8.329-.684a16.583,16.583,0,0,0-2.1,6.132",
    transform: "translate(43.097 8.984)",
    fill: "#fcf6b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(105.43 22.982)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M82.976,19.109c.006-3.451-4.348-4.576-7.054-3.665a10.683,10.683,0,0,0-5.1,4.282C68.629,23,68.978,27.709,72.748,29.6c3.8,1.911,7.4-1.267,8.853-4.574a15.32,15.32,0,0,0,1.375-5.921m-2.5,2.714c-.924,2.387-3.573,5.679-6.569,4.4-2.633-1.126-2.025-4.474-.993-6.532s2.994-4.512,5.588-3.752l0,0A2.181,2.181,0,0,1,80.666,17.2a5.8,5.8,0,0,1-.193,4.623",
    transform: "translate(-69.466 -15.142)",
    fill: "#e5dfac"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(126.338 26.335)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M95.923,26.586a11.451,11.451,0,0,0-2.134-6.763c-1.9-2.356-6.394-3.808-8.329-.684a16.6,16.6,0,0,0-2.1,6.132c-.566,3.811.851,8.727,5.3,9.152,4.417.42,7.37-3.638,7.264-7.836M88.545,30.6c-2.809-1.131-3.043-4.638-2.762-7.218.2-1.838.78-5.452,3.334-5.212a.2.2,0,0,1,.188.178,2.972,2.972,0,0,1,2.89,1.374,8.773,8.773,0,0,1,1.293,5.493C93.37,27.761,92.016,32,88.545,30.6",
    transform: "translate(-83.242 -17.352)",
    fill: "#e5dfac"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M126.313,27.378c.335.467.644.9.921,1.358-.294-1.829-.288-3.74-.756-5.528-.557-2.134-1.484-5.142-3.665-6.1a.1.1,0,0,1,.049-.193,2.9,2.9,0,0,1,.826.214.24.24,0,0,1,.126-.093c.613-.158,1.276-.188,1.9-.3.108-.018.206-.029.308-.042a13.782,13.782,0,0,1-3.108-1.616c-1.565-1.021-3.319-2.369-5.3-2.192a.044.044,0,0,1-.024-.083,3.121,3.121,0,0,1,.442-.155.122.122,0,0,1,.032-.126,33.41,33.41,0,0,1,3.721-2.579A11.873,11.873,0,0,1,123.429,9c-1.342.322-2.726.355-4.09.58-1,.165-2.894.337-3.347,1.418a.1.1,0,0,1-.19-.021,1.092,1.092,0,0,1-.011-.184.161.161,0,0,1-.09-.094c-.552-1.342-1.178-2.623-1.762-3.951a5.359,5.359,0,0,1-.6-2.735c-.364.671-.786,1.3-1.161,1.959-.43.756-.615,1.612-1.032,2.351-.053.1-.193.036-.211-.052a1.9,1.9,0,0,1-.036-.345,14.868,14.868,0,0,0-6.371-3.806,44.791,44.791,0,0,0-7.309-1.9c-2.477-.414-4.969-.545-7.46-.829a14.521,14.521,0,0,1-4.5-.923A16.654,16.654,0,0,0,87.911,2.34a.137.137,0,0,0,.032.012.174.174,0,0,1,.111.12A.154.154,0,0,1,88,2.678a.177.177,0,0,1-.152.056c-1.034-.12-2-.349-3.048-.4-.987-.044-1.972-.127-2.96-.111a38.332,38.332,0,0,0-6.326.656,45.624,45.624,0,0,0-6.226,1.6c-.341.115-.688.211-1.035.308.505.061,1.011.144,1.519.191.782.076,1.6.124,2.41.132A16.235,16.235,0,0,1,74.7,4.978c.138-.006.231.206.073.252-1.009.3-2.094.319-3.079.71a14.383,14.383,0,0,0-2.931,1.583c-.915.64-1.776,1.462-2.688,2.173.32-.073.64-.132.938-.185.469-.079.964-.033,1.434-.094.032-.017.061-.036.091-.055a4.011,4.011,0,0,0,1.049-.137c-1.6,1.407-3.489,2.428-4.881,4.086a16.147,16.147,0,0,0-1.653,2.412c-.361.628-.782,1.251-1.1,1.911a5.167,5.167,0,0,1,.879-.6A10.561,10.561,0,0,1,66.558,15.6a.167.167,0,0,1,.047,0c-.1.181-.2.364-.285.549-.033.017-.068.035-.1.05a39.335,39.335,0,0,0-1.94,5.582c-.354,1.709-.375,3.5-.748,5.2a4.945,4.945,0,0,1,2.132,2.793c.938-2.407,1.867-4.805,2.671-7.265l-.041.032c.178-.279.357-.559.542-.823.141-.2.3-.384.452-.569a30.342,30.342,0,0,1,2.485-1.789c1.935-1.226,3.919-2.348,5.925-3.447.452-.131.9-.319,1.358-.4l.014,0A12.667,12.667,0,0,1,77.9,18.12c.991-.677,2.019-1.3,3-2,1.583-1.125,3.148-2.269,4.678-3.463l-.171,1.5a16.09,16.09,0,0,1-.709,2.993c.141-.138.287-.275.428-.419A16.754,16.754,0,0,1,87.9,14.652,42.735,42.735,0,0,1,92.018,12.2c-.108.416-.323.841-.436,1.231a11.8,11.8,0,0,1-.681,1.912.192.192,0,0,0,.059.246c-.077.155-.153.31-.232.46.1-.074.2-.147.307-.217.829-.542,1.645-1.128,2.5-1.622a18.32,18.32,0,0,1,7.047-2.609c.015.472.073.956.061,1.41a7.521,7.521,0,0,0,.017,2.023c-.015.083-.032.168-.049.253l.146-.064a.136.136,0,0,0,.179-.07l0-.012c.42-.187.82-.361,1.216-.515a36.3,36.3,0,0,1,4.008-.8,10.065,10.065,0,0,1,1.7-.006,7.333,7.333,0,0,1,.425.879c.175.422.314,1.325.744,1.651a4.039,4.039,0,0,1,.017.487c.261-.091.489-.165.721-.232a14.947,14.947,0,0,0,2.431,0c.258-.014.537-.029.82-.053,0,.287,0,.574.006.861a2.957,2.957,0,0,1,.668-.557,18.369,18.369,0,0,1,1.04,1.97,15.077,15.077,0,0,1,1.3,3.313c.263,1.094.463,2.213.656,3.321.167.967.077,1.958.26,2.906a.409.409,0,0,0,.027.058c-.809,2.427-1.317,4.934-1.962,7.4-1.035,1.744-2.057,3.492-2.938,5.315-.483,1-.9,2.026-1.3,3.063a4,4,0,0,1,3.1-.782.347.347,0,0,0,.467.366,10.161,10.161,0,0,0,2.8-2.943,34.571,34.571,0,0,0,2.3-3.4c.4.367.812.733,1.2,1.122a3.049,3.049,0,0,1,.677.856c.041-1.715.249-3.4.134-5.13-.055-.809-.073-1.648-.164-2.451a1.064,1.064,0,0,0-.021-.1,11.4,11.4,0,0,0-.044-1.248,5.567,5.567,0,0,1,.735.839c.279.455.562.906.826,1.372a10.09,10.09,0,0,1,.908,1.7,37.4,37.4,0,0,0,.868-4.524,12.306,12.306,0,0,0,.07-3.089,4.683,4.683,0,0,0-.131-.592c0-.106,0-.214,0-.322,0-.287,0-.571-.006-.847a22.565,22.565,0,0,1,1.814,2.354",
    transform: "translate(32.073 0.242)",
    fill: "#564942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(133.213 4.856)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M94.444,4.993a50.776,50.776,0,0,0-6.673-.068,30.293,30.293,0,0,1,6.777.647c.173.039.293.273.115.4a23.6,23.6,0,0,0-2.48,1.955c1.65-.076,3.3-.167,4.949-.235a.258.258,0,0,1,.252.141.192.192,0,0,1,.217.182,10.579,10.579,0,0,0,.5,2.12,6.752,6.752,0,0,1,2.172-.419c-.76-.888-.862-2.5-.985-3.536a12.547,12.547,0,0,1-.108-2.23c-.121.2-.247.4-.363.609-.43.756-.615,1.61-1.032,2.349-.053.1-.193.036-.211-.052a1.746,1.746,0,0,1-.035-.345A13.628,13.628,0,0,0,92.477,3.2a24.584,24.584,0,0,1,2.128,1.389.228.228,0,0,1-.161.405",
    transform: "translate(-87.772 -3.199)",
    fill: "#453a34"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(94.022 0.709)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M126.313,27.378c.335.467.644.9.921,1.358-.294-1.829-.288-3.74-.756-5.528-.557-2.134-1.484-5.142-3.665-6.1a.1.1,0,0,1,.049-.193,2.9,2.9,0,0,1,.826.214.24.24,0,0,1,.126-.093c.613-.158,1.276-.188,1.9-.3l.121-.017a25.019,25.019,0,0,0-5.556-.551,13.07,13.07,0,0,1,3.881,3.154.227.227,0,0,1-.313.32,15.153,15.153,0,0,0-3.559-1.879c.469,1.1.864,2.222,1.266,3.345a.225.225,0,0,1-.379.231c-.659-.754-1.231-1.574-1.836-2.369a13.694,13.694,0,0,1,.311,3.345,8.453,8.453,0,0,1-1,3.447c-.123.212-.411.036-.405-.161a13.392,13.392,0,0,0-1.5-6.563,10.5,10.5,0,0,1-1.449-3.979c-.328.173-.64.37-.959.571-.152.1-.4.011-.364-.2a14.888,14.888,0,0,0,.264-1.49,19.924,19.924,0,0,1-4.341,1.524.229.229,0,0,1-.243-.129,8.851,8.851,0,0,1-1.185-4.652,51.6,51.6,0,0,0-6.381,2.223c-.17.077-.387-.111-.3-.29a42.286,42.286,0,0,0,1.885-4.139A26.989,26.989,0,0,0,93.131,13.06a.227.227,0,0,1-.322-.311c1.021-1.586,2.222-3.035,3.372-4.526a17.911,17.911,0,0,0-3.837,2.063,41.616,41.616,0,0,0-5.157,3.227c-.2.153-.483-.108-.319-.311A33.8,33.8,0,0,0,90.83,7.687c-1.635,1.141-3.13,2.469-4.805,3.547-1.964,1.263-3.949,2.5-5.884,3.811-.2.135-.5-.108-.319-.311,1.3-1.452,2.629-2.878,3.858-4.386-3.122,2.233-6.044,4.757-9.46,6.546-.234.124-.42-.222-.231-.382A13.968,13.968,0,0,0,77.4,13.187a70.136,70.136,0,0,1-6.414,3.564c-.2.079-.433-.165-.272-.341a37.2,37.2,0,0,1,8.089-6.086A58.118,58.118,0,0,0,71.3,12.029a.225.225,0,0,1-.181-.413,38.411,38.411,0,0,1,10.04-4.171c-3.7.109-7.382.521-11.069.844-.244.021-.376-.334-.126-.428A56.478,56.478,0,0,1,82.138,5c-2.624-.26-5.259-.37-7.883-.6a.225.225,0,0,1-.011-.445c4.336-.929,8.885-1.676,13.3-.9a.214.214,0,0,1,.153.1c1.3.1,2.6.2,3.894.316a10.8,10.8,0,0,1-3.718-2.293,9.109,9.109,0,0,1-2.612-.7A16.654,16.654,0,0,0,87.911,2.34a.137.137,0,0,0,.032.012.174.174,0,0,1,.111.12A.154.154,0,0,1,88,2.678a.177.177,0,0,1-.152.056c-1.034-.12-2-.349-3.048-.4-.987-.044-1.972-.127-2.96-.111a38.332,38.332,0,0,0-6.326.656,45.624,45.624,0,0,0-6.226,1.6c-.341.115-.688.211-1.035.308.505.061,1.011.144,1.519.191.782.076,1.6.124,2.41.132A16.235,16.235,0,0,1,74.7,4.978c.138-.006.231.206.073.252-1.009.3-2.094.319-3.079.71a14.383,14.383,0,0,0-2.931,1.583c-.915.64-1.776,1.462-2.688,2.173.32-.073.64-.132.938-.185.469-.079.964-.033,1.434-.094.032-.017.061-.036.091-.055a4.011,4.011,0,0,0,1.049-.137c-1.6,1.407-3.489,2.428-4.881,4.086a16.147,16.147,0,0,0-1.653,2.412c-.361.628-.782,1.251-1.1,1.911a5.167,5.167,0,0,1,.879-.6A10.561,10.561,0,0,1,66.558,15.6a.167.167,0,0,1,.047,0c-.1.181-.2.364-.285.549-.033.017-.068.035-.1.05a39.335,39.335,0,0,0-1.94,5.582c-.354,1.709-.375,3.5-.748,5.2a4.945,4.945,0,0,1,2.132,2.793c.938-2.407,1.867-4.805,2.671-7.265l-.041.032c.178-.279.357-.559.542-.823.141-.2.3-.384.452-.569a30.342,30.342,0,0,1,2.485-1.789c1.935-1.226,3.919-2.348,5.925-3.447.452-.131.9-.319,1.358-.4l.014,0A12.667,12.667,0,0,1,77.9,18.12c.991-.677,2.019-1.3,3-2,1.583-1.125,3.148-2.269,4.678-3.463l-.171,1.5a16.09,16.09,0,0,1-.709,2.993c.141-.138.287-.275.428-.419A16.754,16.754,0,0,1,87.9,14.652,42.735,42.735,0,0,1,92.018,12.2c-.108.416-.323.841-.436,1.231a11.8,11.8,0,0,1-.681,1.912.192.192,0,0,0,.059.246c-.077.155-.153.31-.232.46.1-.074.2-.147.307-.217.829-.542,1.645-1.128,2.5-1.622a18.32,18.32,0,0,1,7.047-2.609c.015.472.073.956.061,1.41a7.521,7.521,0,0,0,.017,2.023c-.015.083-.032.168-.049.253l.146-.064a.136.136,0,0,0,.179-.07l0-.012c.42-.187.82-.361,1.216-.515a36.3,36.3,0,0,1,4.008-.8,10.065,10.065,0,0,1,1.7-.006,7.333,7.333,0,0,1,.425.879c.175.422.314,1.325.744,1.651a4.039,4.039,0,0,1,.017.487c.261-.091.489-.165.721-.232a14.947,14.947,0,0,0,2.431,0c.258-.014.537-.029.82-.053,0,.287,0,.574.006.861a2.957,2.957,0,0,1,.668-.557,18.369,18.369,0,0,1,1.04,1.97,15.077,15.077,0,0,1,1.3,3.313c.263,1.094.463,2.213.656,3.321.167.967.077,1.958.26,2.906a.409.409,0,0,0,.027.058c-.809,2.427-1.317,4.934-1.962,7.4-1.035,1.744-2.057,3.492-2.938,5.315-.483,1-.9,2.026-1.3,3.063a4,4,0,0,1,3.1-.782.347.347,0,0,0,.467.366,10.161,10.161,0,0,0,2.8-2.943,34.571,34.571,0,0,0,2.3-3.4c.4.367.812.733,1.2,1.122a3.049,3.049,0,0,1,.677.856c.041-1.715.249-3.4.134-5.13-.055-.809-.073-1.648-.164-2.451a1.064,1.064,0,0,0-.021-.1,11.4,11.4,0,0,0-.044-1.248,5.567,5.567,0,0,1,.735.839c.279.455.562.906.826,1.372a10.09,10.09,0,0,1,.908,1.7,37.4,37.4,0,0,0,.868-4.524,12.306,12.306,0,0,0,.07-3.089,4.683,4.683,0,0,0-.131-.592c0-.106,0-.214,0-.322,0-.287,0-.571-.006-.847a22.565,22.565,0,0,1,1.814,2.354",
    transform: "translate(-61.95 -0.466)",
    fill: "#453a34"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(148.39 9.564)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M97.771,10.6a8.815,8.815,0,0,1,3.067-.51,4.454,4.454,0,0,0-1.77-.219.044.044,0,0,1-.024-.083,3.19,3.19,0,0,1,.442-.155.122.122,0,0,1,.032-.126,33.41,33.41,0,0,1,3.721-2.579,11.089,11.089,0,0,1,1.02-.63c-.47.053-.939.1-1.405.175A12.378,12.378,0,0,0,97.771,10.6",
    transform: "translate(-97.771 -6.301)",
    fill: "#453a34"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(147.906 9.838)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M97.676,8.519a6.842,6.842,0,0,1,3.164-2.037c-1.027.161-2.793.357-3.23,1.4a.1.1,0,0,1-.158.035,6.031,6.031,0,0,0,.223.6",
    transform: "translate(-97.452 -6.481)",
    fill: "#453a34"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M129.3,30.581c-.047-.134-.1-.264-.153-.39-.041-1.29-.211-2.61-.314-3.888a19.609,19.609,0,0,0-.8-4.1c-.439-1.457-1.1-3.451-2.415-4.442a9.411,9.411,0,0,0,2.8-.546c.044.008.09.02.137.026a.085.085,0,0,0,.093-.087l.053-.014a.09.09,0,0,0,0-.178c-.155-.023-.305-.038-.452-.047a34.442,34.442,0,0,1-4.957-2.928,5.781,5.781,0,0,0-3.4-1.185,32.126,32.126,0,0,0,6-3.945.078.078,0,0,0-.077-.134c-.182.085-.355.167-.527.246a.113.113,0,0,0-.1-.068,33.529,33.529,0,0,0-6.136.671,3.643,3.643,0,0,0-1.7.829,7.927,7.927,0,0,0-1.062-2.677,9.865,9.865,0,0,1-1.367-4.057c-.009-.117-.168-.091-.193,0a4.008,4.008,0,0,0-.082.442.076.076,0,0,0-.108.009c-.669.873-1.946,2.172-2.267,3.439a8.978,8.978,0,0,0-4.212-3.081A41.878,41.878,0,0,0,100.671,2.2a54.034,54.034,0,0,0-7.519-.991C91.93,1.126,90.712,1.027,89.5.862A14.271,14.271,0,0,1,85.689.006c-.061-.029-.1.058-.052.1a3.4,3.4,0,0,0,.5.379.1.1,0,0,0,0,.082,3.618,3.618,0,0,0,1.149,1.31c.094.077.184.156.275.234a26.492,26.492,0,0,0-10.032.143A39.381,39.381,0,0,0,71.84,3.6c-1.627.524-4.089.574-5.056,2.163,1.51-.322,4.019.659,5.315.091a11.782,11.782,0,0,0-1.492.776A33.636,33.636,0,0,0,66.1,10.369c-.055.029-.118.049-.17.08a.2.2,0,0,0-.082.14c-.132.114-.266.231-.4.345a.084.084,0,0,0,.085.143,6.056,6.056,0,0,0,.618-.314,12.822,12.822,0,0,0,2.656-.624,1.825,1.825,0,0,1,.244-.042,18.792,18.792,0,0,0-3.277,2.85,10.275,10.275,0,0,0-1.618,2.427,15.114,15.114,0,0,0-1.375,2.976,2.143,2.143,0,0,0-.457,1.009c-.014.079.093.091.127.03.842-1.513,2.846-2,4.47-2.682A12.587,12.587,0,0,0,65.1,21.2a24.526,24.526,0,0,0-.815,5.728,4.6,4.6,0,0,0-.689-.276c-2.126-.642-3.38,1.3-3.828,3.087a9.282,9.282,0,0,0,.7,6.642,3.179,3.179,0,0,0,4.168,1.187,15.621,15.621,0,0,0-.009,4.166,15.2,15.2,0,0,0,3.419,7.628,11.53,11.53,0,0,0,3.359,2.811q.241.13.51.26a.187.187,0,0,0,0,.029c-.252,1.846-.7,3.659-.991,5.5-1.275,1.194-2.97,1.888-4.069,3.256-1.217,1.512-.228,3.52.592,4.943A25.681,25.681,0,0,1,70.26,71.87c.36,1.284.66,3.363,2.041,4,1.4.645,2.732-.305,3.765-1.213a39.473,39.473,0,0,0,4.274-5.043c1.214-1.486,3.6-2.618,4.151-4.54.449-1.559-1.008-3.123-2.008-4.1a.22.22,0,0,0-.053-.036c.03-.114.058-.225.091-.331a16.578,16.578,0,0,1,.78-2.354,14.559,14.559,0,0,0,2.957.114c2.1.436,4.136,1.132,6.247,1.536a16.528,16.528,0,0,0,6.321-.1,14.391,14.391,0,0,0,9.31-6.44c.14-.214.275-.431.407-.648a1.583,1.583,0,0,0,.789,1.163,3.959,3.959,0,0,0,3.016.381,8.907,8.907,0,0,0,4.942-4.184,4.612,4.612,0,0,0-.844-5.786,2.8,2.8,0,0,0-.431-.308,6.972,6.972,0,0,0,2.433-2.266,14.338,14.338,0,0,0,1.844-2.8,2.063,2.063,0,0,0,.343-.474c.052-.07.1-.14.153-.209a3.434,3.434,0,0,0,.354.4,15.252,15.252,0,0,1,1.445,1.607.07.07,0,0,0,.124-.036c0-.036,0-.07,0-.108a.125.125,0,0,0,.137-.1,19.31,19.31,0,0,0,.395-5.543,10.909,10.909,0,0,0-.434-2.849,5.72,5.72,0,0,1,.722,1.213c.367.918.946,1.741,1.305,2.655.049.124.208.073.231-.035.011-.041.008-.085.015-.134a15.777,15.777,0,0,0,1.395-5.511,9.224,9.224,0,0,0-.481-3.86c.426.653.821,1.33,1.223,2,.364.6.842,1.1,1.173,1.73a5.675,5.675,0,0,0,.474.841c.029.1.05.193.08.287a.112.112,0,0,0,.208-.011.144.144,0,0,0,.146-.19m-64.868.668c-.372-.338-.92-.943-1.486-.854s-.824.806-1.061,1.238c-.039.071.076.134.121.07.364-.522.9-1.135,1.5-.518a10.513,10.513,0,0,1,.961,1.018,4.7,4.7,0,0,1,.841,2.269,20.051,20.051,0,0,0-.6,2.6c-1.586,1.024-3.485-.12-4.2-1.735a9.806,9.806,0,0,1-.3-5.192c.305-1.877,1.612-3.585,3.641-2.82a3.655,3.655,0,0,1,.505.238l.011.009A6.55,6.55,0,0,1,66.8,30.382c-.266.681-.531,1.36-.8,2.043-.1.266-.2.53-.291.8a4.891,4.891,0,0,0-1.289-1.972M81.971,61.322a13.273,13.273,0,0,1-.34,1.449c-.027.093.09.172.152.087a3.294,3.294,0,0,0,.483-1.2c1.073,1.207,2.233,2.7.971,4.2-1.029,1.223-2.428,2.081-3.468,3.318-1.261,1.509-5.846,8.772-7.967,5.127a23.786,23.786,0,0,1-1.272-3.793,30.244,30.244,0,0,0-2.292-4.306c-.979-1.718-2.031-3.618-.294-5.247.952-.891,2.009-1.493,2.891-2.412a19.545,19.545,0,0,0-.187,2.192.086.086,0,0,0,.172.02c.323-1.339.671-2.655.938-4.005a28.567,28.567,0,0,0,.81-4.042,8.759,8.759,0,0,0,3.127.736,10.029,10.029,0,0,0,5.048,4.16,11.7,11.7,0,0,0,1.9.525,4.959,4.959,0,0,0-.463,1.835c-.042.319-.094.645-.149.973a.263.263,0,0,0-.064.375m26.478-9.794a14.274,14.274,0,0,1-9.724,7.614,16.529,16.529,0,0,1-6.144.1C91,59,89.453,58.5,87.884,58.165a11.379,11.379,0,0,0,2.167-.613c.077-.03.036-.137-.038-.131-2.947.261-5.787.537-8.666-.349s-5.121-3.316-6.572-5.881a.044.044,0,0,0-.08.035,9.571,9.571,0,0,0,.668,1.642c-1.049-.507-2.315-.691-3.375-1.15a10.263,10.263,0,0,1-3.671-2.994,14.541,14.541,0,0,1-3.181-8.079,15.188,15.188,0,0,1,.718-5.566.262.262,0,0,0,.1-.187c0-.046,0-.094,0-.141.337-1.082.741-2.148,1.152-3.195.61-1.548,1.19-3.108,1.773-4.669a17.616,17.616,0,0,0,1.21-4.477c.223-.156.448-.31.668-.467,1-.721,2-1.425,3.042-2.088,1.862-1.184,4.192-2.186,5.846-3.7-.1.19-.2.378-.3.572-.243.493-.48.98-.765,1.451a14.4,14.4,0,0,0-.864,1.194.169.169,0,0,0-.017.1c-.181.149-.36.3-.531.46a.079.079,0,0,0,.08.135,15.25,15.25,0,0,0,2.527-1.336c.97-.555,1.888-1.225,2.806-1.859a29.01,29.01,0,0,0,3.926-3.072,15.967,15.967,0,0,0-1.128,4.184.154.154,0,0,0,.024.1,1.767,1.767,0,0,0-.231.554c-.018.082.1.1.131.033a6.673,6.673,0,0,1,1.94-1.812c.82-.651,1.759-1.164,2.638-1.735s1.789-1.081,2.7-1.612c-.17.346-.308.713-.46,1.053-.516,1.147-.835,2.365-1.381,3.506-.029.064.065.112.106.059.112-.149.223-.3.343-.467a5.046,5.046,0,0,1,2.152-1.585c.832-.437,1.586-1,2.421-1.439a51.987,51.987,0,0,1,5.776-2.427,35.812,35.812,0,0,1-.128,3.8c2.475-.826,5.012-1,7.517-1.666a6.073,6.073,0,0,1,.618,1.205,8.253,8.253,0,0,1,.642,1.762.069.069,0,0,0,.137,0v-.015a10.912,10.912,0,0,0,3.6-.407c.011.4.006.809.011,1.213,0,.144.175.308.31.173.61-.609.688-.862,1.149-.047a9.317,9.317,0,0,1,.715,1.833,31.031,31.031,0,0,1,1.377,5.45,14.147,14.147,0,0,1,.41,2.371,20.18,20.18,0,0,1-.533,2.453c-.285,1.542-1,3.017-1.157,4.587q-1.375,2.349-2.685,4.726a68.706,68.706,0,0,0-3.418,8.185.713.713,0,0,0-.3.66.32.32,0,0,0,.021.047c-.413,1.015-.861,2.022-1.374,3m7.605-6.714c1.645,1.194,1.48,3.432.736,5.062a8.667,8.667,0,0,1-3.676,3.526,3.572,3.572,0,0,1-2.255.467,3.61,3.61,0,0,1-1.26-.466c-.516-.3-.467-1.038-.56-1.572a32.556,32.556,0,0,0,1.6-3.568c1.3-.83,3-1.217,4.272-.027.053.05.117-.033.083-.085a3.1,3.1,0,0,0-2.957-1,5.567,5.567,0,0,0-1.064.235c.284-.763.563-1.53.848-2.293a3.544,3.544,0,0,1,4.23-.276M127.6,27.619a21.744,21.744,0,0,0-1.827-2.368c-.032-.094-.064-.187-.1-.284a.105.105,0,0,0-.193-.008c-.067-.062-.131-.126-.2-.188-.038-.035-.091.024-.061.062.088.114.17.234.257.349.076.618.358,1.208.445,1.843a12.306,12.306,0,0,1-.07,3.089,37.4,37.4,0,0,1-.868,4.524,10.09,10.09,0,0,0-.908-1.7c-.264-.466-.546-.917-.826-1.372a8.393,8.393,0,0,0-.874-.99c-.094-.178-.2-.358-.313-.537-.064-.1-.2,0-.165.1a8.99,8.99,0,0,1,.683,1.941c.091.8.109,1.642.164,2.451.115,1.729-.093,3.415-.134,5.13a3.049,3.049,0,0,0-.677-.856c-.631-.631-1.326-1.19-1.955-1.824-.032-.032-.085.008-.056.044.184.235.335.469.492.7a.2.2,0,0,0-.073.049c-.827.98-1.484,2.186-2.223,3.242a18.724,18.724,0,0,1-2.53,2.767,3.843,3.843,0,0,0-3.52.66c.4-1.037.815-2.066,1.3-3.063,2.186-4.517,5.233-8.589,7.191-13.221.029-.07-.076-.132-.12-.067-1.072,1.616-2.1,3.268-3.11,4.936.2-.75.463-1.483.648-2.237a8.3,8.3,0,0,0,.423-4.124,46.91,46.91,0,0,0-1.081-4.995,40.374,40.374,0,0,0-2.044-4.5.2.2,0,0,0-.258-.1,2.827,2.827,0,0,0-.7.583c-.006-.341-.011-.681-.008-1.023,0-.111-.091-.253-.225-.214a14.761,14.761,0,0,1-2.123.243,7.535,7.535,0,0,0-1.622.419,5.2,5.2,0,0,0-.936-3.022.224.224,0,0,0-.209-.29c-.009,0-.018,0-.027,0a.24.24,0,0,0-.264-.011,15.029,15.029,0,0,0-4.468.78,17.576,17.576,0,0,0-2.532.994,8.951,8.951,0,0,0,.2-3.407.254.254,0,0,0-.074-.143.115.115,0,0,0-.12-.143,18.3,18.3,0,0,0-7.083,2.615c-.858.495-1.674,1.081-2.5,1.622-.1.07-.206.143-.307.217a20.769,20.769,0,0,0,1.372-3.257c.062-.035.123-.07.182-.106a9.668,9.668,0,0,1,.683-.974,40.217,40.217,0,0,0-5.065,2.944,16.754,16.754,0,0,0-2.776,2.081c-.141.144-.287.281-.428.419A16.09,16.09,0,0,0,86.69,14.4l.171-1.5c-1.53,1.194-3.095,2.339-4.678,3.463-.985.7-2.012,1.32-3,2,.858-1.31,1.187-2.973,1.9-4.371.032-.065-.073-.126-.112-.064-.361.58-.716,1.15-1.053,1.736a.074.074,0,0,0-.05,0c-2.305,1.257-4.588,2.525-6.809,3.932a33.868,33.868,0,0,0-2.963,2.164.14.14,0,0,0-.065-.036c.354-.543.7-1.1,1.072-1.621a28.33,28.33,0,0,0,2.161-3.163c.035-.062-.062-.1-.1-.058-.175.194-.349.384-.524.572a.124.124,0,0,0-.129-.008,23.984,23.984,0,0,0-3.687,2.3,6.709,6.709,0,0,0-.885.776,36.624,36.624,0,0,1,6.761-7.68c.07-.061,0-.2-.088-.146-.138.085-.273.162-.41.243a.084.084,0,0,0-.077-.055,17.612,17.612,0,0,0-5.043.672c1.091-.639,2.108-1.433,3.2-2.064,1.471-.85,3.052-1.492,4.532-2.321.1-.058.068-.234-.061-.208a17.064,17.064,0,0,0-4.74,1.92,11.348,11.348,0,0,0-3.819,2.881.118.118,0,0,0-.011.114,8.952,8.952,0,0,0-1.07.507.086.086,0,0,0,.068.158c2.132-.659,4.4-.732,6.555-1.328a9.362,9.362,0,0,0-1.307.908,20.181,20.181,0,0,0-2.173,2.31A25.65,25.65,0,0,0,68.1,19.366,8.779,8.779,0,0,0,66.8,21.851a.1.1,0,0,0,.015.079c-.12.17-.241.343-.37.524-.047.068.041.158.106.1.909-.754,1.662-1.636,2.623-2.349.829-.615,1.729-1.143,2.56-1.758a16.157,16.157,0,0,0-1.079,1.328,25.045,25.045,0,0,0-1.915,3.184,2.521,2.521,0,0,0-.571,1.088.084.084,0,0,0,.15.059,4.688,4.688,0,0,1,1.3-1.358c-.8,2.46-1.733,4.858-2.671,7.265a4.945,4.945,0,0,0-2.132-2.793c.373-1.7.395-3.488.748-5.2a39.335,39.335,0,0,1,1.94-5.582c.033-.015.068-.033.1-.05.09-.185.182-.369.285-.549a.167.167,0,0,0-.047,0,10.561,10.561,0,0,0-3.731,1.433,5.167,5.167,0,0,0-.879.6c.32-.66.741-1.282,1.1-1.911a16.146,16.146,0,0,1,1.653-2.412c1.392-1.657,3.281-2.679,4.881-4.086A4.011,4.011,0,0,1,69.82,9.6c-.03.018-.059.038-.091.055-.471.061-.965.015-1.434.094-.3.053-.618.112-.938.185.912-.712,1.773-1.533,2.688-2.173a14.383,14.383,0,0,1,2.931-1.583c.985-.392,2.07-.414,3.079-.71.158-.046.065-.258-.073-.252a16.235,16.235,0,0,0-2.515.134c-.809-.008-1.629-.056-2.41-.132-.508-.047-1.014-.131-1.519-.191.348-.1.694-.193,1.035-.308a45.624,45.624,0,0,1,6.226-1.6,38.332,38.332,0,0,1,6.326-.656c.988-.017,1.973.067,2.96.111,1.046.049,2.014.278,3.048.4a.177.177,0,0,0,.152-.056.154.154,0,0,0,.055-.206.174.174,0,0,0-.111-.12.137.137,0,0,1-.032-.012A16.654,16.654,0,0,1,86.548.709a14.521,14.521,0,0,0,4.5.923c2.491.284,4.983.414,7.46.829a44.791,44.791,0,0,1,7.309,1.9,14.868,14.868,0,0,1,6.371,3.806,1.9,1.9,0,0,0,.036.345c.018.088.158.149.211.052.417-.739.6-1.6,1.032-2.351.375-.66.8-1.289,1.161-1.959a5.359,5.359,0,0,0,.6,2.735c.584,1.328,1.21,2.609,1.762,3.951a.161.161,0,0,0,.09.094,1.092,1.092,0,0,0,.011.184.1.1,0,0,0,.19.021c.452-1.081,2.342-1.252,3.347-1.418,1.364-.225,2.749-.258,4.09-.58a11.873,11.873,0,0,0-1.644.955,33.41,33.41,0,0,0-3.721,2.579.122.122,0,0,0-.032.126,3.121,3.121,0,0,0-.442.155.044.044,0,0,0,.024.083c1.982-.178,3.737,1.17,5.3,2.192a13.782,13.782,0,0,0,3.108,1.616c-.1.014-.2.024-.308.042-.627.108-1.29.138-1.9.3a.24.24,0,0,0-.126.093,2.9,2.9,0,0,0-.826-.214.1.1,0,0,0-.049.193c2.181.955,3.108,3.963,3.665,6.1.467,1.788.461,3.7.756,5.528-.278-.455-.586-.891-.921-1.358",
    transform: "translate(30.789 0.001)",
    fill: "#2e0d4b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M103.725,18.105c-.53-1.7-.572-3.63-2.09-4.82a.163.163,0,0,0-.244.2c.36.779.939,1.418,1.275,2.217a13.282,13.282,0,0,1,.569,1.947c-.276-.244-.555-.481-.851-.7a14.29,14.29,0,0,1-1.67-1.109.093.093,0,0,0-.071-.021,7.59,7.59,0,0,0-.49-1.073.057.057,0,0,0-.1.047,17.165,17.165,0,0,1,.7,4.992,8.373,8.373,0,0,0-.741-1.082.083.083,0,0,0-.141.085,5.305,5.305,0,0,1,.906,2.327.183.183,0,0,0,.363.041,10.69,10.69,0,0,0-.311-4.811,3.124,3.124,0,0,0,.65.443,13.557,13.557,0,0,1,1.976,1.542c.149.134.319-.062.272-.216",
    transform: "translate(51.701 6.862)",
    fill: "#2e0d4b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M108.643,13.672c-.422-.079-.848-.153-1.272-.232a1.957,1.957,0,0,0,0-1.184.082.082,0,0,0-.156.023,5.585,5.585,0,0,1-.226,1.09c-.917-.164-1.835-.326-2.758-.478a3.476,3.476,0,0,0,0-1.366c-.033-.14-.269-.158-.27,0a5.352,5.352,0,0,1-.179,1.292c-1.075-.168-2.152-.323-3.231-.439a5.581,5.581,0,0,0-.053-1.431.112.112,0,0,0-.222.006c-.074.455-.124.918-.193,1.377-1.108-.108-2.219-.182-3.331-.2-.024-.619-.184-1.153-.264-1.759a.114.114,0,0,0-.217-.024,5.282,5.282,0,0,0-.023,1.622c0,.052-.006.1-.008.156-.171,0-.345-.006-.516,0-1.194.023-2.389.1-3.577.211a4.8,4.8,0,0,0-.26-1.622c-.041-.121-.261-.094-.258.039.008.549,0,1.091-.029,1.632q-1.985.2-3.957.536a3.772,3.772,0,0,0-.149-1.263.115.115,0,0,0-.219.032c-.033.434-.077.871-.118,1.311q-1.66.285-3.3.634a10.57,10.57,0,0,0-.147-1.176.11.11,0,0,0-.208-.023,3.619,3.619,0,0,0-.229,1.319c-1.16.244-2.324.452-3.479.706a12.119,12.119,0,0,0-.352-1.419c-.038-.127-.206-.05-.2.059.012.486-.015.99-.029,1.489-.442.1-.882.22-1.32.352-.586.173-1.16.382-1.73.606a2.862,2.862,0,0,0-.328-.958.11.11,0,0,0-.208.061,6.2,6.2,0,0,1,.035,1.1c-1.044.433-2.067.923-3.066,1.454a.243.243,0,0,1-.029.017c-.1-.358-.225-.707-.325-1.035-.035-.112-.185-.044-.181.053.012.4.068.8.094,1.2-1.011.525-2.082,1.055-3.1,1.662a5.888,5.888,0,0,0-.03-1.287.079.079,0,0,0-.155,0c-.052.5-.12.994-.146,1.486a8.535,8.535,0,0,0-3.872,4.335c-.08.234.249.448.392.222a11.5,11.5,0,0,1,3.169-3.568c.1-.073.216-.135.322-.206a3.764,3.764,0,0,0,.212,1c.061.156.341.126.34-.053a7.258,7.258,0,0,0-.17-1.194c.976-.615,2.006-1.161,3.037-1.692a4.517,4.517,0,0,0,.039,1.163.216.216,0,0,0,.41.047,2.55,2.55,0,0,0,.111-1.5c.276-.143.555-.285.83-.43.681-.354,1.381-.674,2.09-.973a4.792,4.792,0,0,0,.056.933.145.145,0,0,0,.276.032,3.31,3.31,0,0,0,.238-1.205,27.258,27.258,0,0,1,2.591-.883c.135-.039.275-.067.411-.1a6.661,6.661,0,0,0,.058.821.239.239,0,0,0,.455.052,2.82,2.82,0,0,0,.135-1.032c1.108-.26,2.236-.454,3.354-.671a10.426,10.426,0,0,0-.07,1.123.155.155,0,0,0,.275.111,2.339,2.339,0,0,0,.442-1.363c.181-.038.363-.071.542-.111q1.348-.3,2.711-.542c-.033.407-.058.815-.059,1.22a.135.135,0,0,0,.24.1,1.914,1.914,0,0,0,.329-1.326c0-.026,0-.052,0-.08q1.967-.341,3.951-.566c-.03.49-.068.979-.115,1.477a.155.155,0,0,0,.276.109,3.221,3.221,0,0,0,.392-1.645c1.342-.143,2.688-.244,4.036-.291h.035a3.739,3.739,0,0,0-.017,1.583c.042.138.258.117.3-.008a5.37,5.37,0,0,0,.275-1.585,29.04,29.04,0,0,1,3.257.182c-.1.516-.252,1.021-.338,1.539a.144.144,0,0,0,.257.1,4.431,4.431,0,0,0,.565-1.588c1.061.126,2.119.285,3.175.443a10.169,10.169,0,0,0-.287,1.355.137.137,0,0,0,.263.065,7.945,7.945,0,0,0,.492-1.351c.915.135,1.836.26,2.759.358a5.115,5.115,0,0,0-.246,1.3c0,.1.135.184.2.08a5.1,5.1,0,0,0,.452-1.339c.442.044.883.08,1.328.1a.091.091,0,0,0,.021-.181",
    transform: "translate(33.566 5.325)",
    fill: "#2e0d4b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M96.346,39.526c-.85-1.855-3.2-2.929-5.016-3.574A35.217,35.217,0,0,0,87.465,35a24.552,24.552,0,0,1-3.547-1.128A17.892,17.892,0,0,0,82.229,33a13.573,13.573,0,0,0-3.492-.968,13.78,13.78,0,0,1-4.564-.987,7.469,7.469,0,0,0-3.647-.944,18.706,18.706,0,0,0-3.641.944c-.083.021-.093.162,0,.161,1.111-.011,2.17-.378,3.275-.49a7.647,7.647,0,0,1,4.09,1.2,9.523,9.523,0,0,0,3.6.774A13.877,13.877,0,0,1,81.946,33.7c2.486,1.032,4.6,2.829,6.831,4.3a2.95,2.95,0,0,0,2.475.505,8.041,8.041,0,0,1,2.169-.032,4.227,4.227,0,0,1,2.187.689c.176.161.352.323.515.5.1.106.29.008.223-.135m-2.862-1.591c-1.374-.132-3.045.194-4.244-.549-1.109-.689-2.16-1.446-3.227-2.179,1.1.379,2.242.653,3.413.938a16.218,16.218,0,0,1,4.716,1.912,3.768,3.768,0,0,0-.659-.121",
    transform: "translate(34.594 15.583)",
    fill: "#2e0d4b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M69.889,33.054a5.793,5.793,0,0,1,.035-1.411,20.019,20.019,0,0,0,.053-2.506.156.156,0,0,0-.3-.035c-.469,1.367-.889,3.351,0,4.594a.11.11,0,0,0,.188-.027.77.77,0,0,0,.02-.615",
    transform: "translate(35.806 15.019)",
    fill: "#2e0d4b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M72.559,32.109c.073-.824.178-1.642.2-2.469a.141.141,0,0,0-.27-.068,6.305,6.305,0,0,0-.351,4.33c.023.091.176.14.209.023a11.522,11.522,0,0,0,.209-1.815",
    transform: "translate(37.232 15.266)",
    fill: "#2e0d4b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M75.241,30.545a.1.1,0,0,0-.188-.021c-.2.66-.581,1.205-.748,1.887a2.823,2.823,0,0,0,.012,1.808.145.145,0,0,0,.275-.039,15.287,15.287,0,0,1,.345-1.938,5.773,5.773,0,0,0,.305-1.7",
    transform: "translate(38.396 15.772)",
    fill: "#2e0d4b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M78.1,31.164c-.706,1.241-1.525,2.582-1.383,4.075a.167.167,0,0,0,.317.035c.269-.68.442-1.39.642-2.094.185-.656.474-1.27.619-1.94.023-.1-.144-.17-.2-.076",
    transform: "translate(39.71 16.112)",
    fill: "#2e0d4b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M80.374,32.037c-.367.774-.7,1.565-1.076,2.333-.238.48-.647,1.015-.551,1.571A.126.126,0,0,0,78.97,36,8.651,8.651,0,0,0,80.633,32.1a.136.136,0,0,0-.26-.065",
    transform: "translate(40.762 16.545)",
    fill: "#2e0d4b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M82.718,32.622c-.338.9-1.082,1.572-1.493,2.439a5.216,5.216,0,0,0-.616,2.612.184.184,0,0,0,.351.039,23.859,23.859,0,0,1,1.032-2.9,4.865,4.865,0,0,0,.962-2.132.123.123,0,0,0-.235-.059",
    transform: "translate(41.725 16.85)",
    fill: "#2e0d4b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M84.933,33.073c-.036-.087-.2-.077-.194.029a5.649,5.649,0,0,1-.9,2.57,9.28,9.28,0,0,0-.477,1.261c-.209.612-.56,1.12-.777,1.715-.049.131.12.293.235.178a9.456,9.456,0,0,0,1.685-3.186,3.341,3.341,0,0,0,.426-2.566",
    transform: "translate(42.753 17.093)",
    fill: "#2e0d4b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M86.669,33.791a.1.1,0,0,0-.191-.021,18.37,18.37,0,0,1-2.525,5.019.141.141,0,0,0,.2.193,6.9,6.9,0,0,0,2.516-5.191",
    transform: "translate(43.452 17.441)",
    fill: "#2e0d4b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M79.089,31.475a.4.4,0,0,0,.027-.068,20.979,20.979,0,0,0,.521-4.333c-.018-.68-.244-.715-.542-.572a.054.054,0,0,0-.083-.018c-.1.079-.19.158-.282.238-.065.039-.126.079-.19.115a.035.035,0,0,0-.011.05,11.887,11.887,0,0,0-1.607,1.671c-.332.425-.871,1.075-.718,1.654-.073.527.369.914.824,1.157s1.569.7,2.069.4c.076-.046.14-.167.059-.246a.765.765,0,0,0-.067-.05m-1.3-.4c-.469-.141-1.072-.381-1.234-.877.316-.49.525-1.043.892-1.521.495-.644,1.026-1.251,1.5-1.909a1.67,1.67,0,0,0,.272-.12c.2.343-.018,1.053-.067,1.425-.141,1.075-.4,2.113-.584,3.174-.272-.068-.565-.106-.779-.172",
    transform: "translate(39.439 13.686)",
    fill: "#2e0d4b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M82.452,31.561a8.755,8.755,0,0,0-.165-2.683c-.1-.463-.437-2.425-1.246-1.976a.08.08,0,0,0-.021.117c-.962,1-1.169,2.61-1.468,3.908-.346,1.5,1.116,1.8,2.378,1.574a.126.126,0,0,0,.079-.05.253.253,0,0,0,.109-.02c.322-.132.313-.577.334-.87m-2.465-.167a10.232,10.232,0,0,1,.2-1.1,10.4,10.4,0,0,1,.993-3.146c.487.4.493,1.6.61,2.131a7.264,7.264,0,0,1,.088,1.987c-.009.12.052.64-.041.709a.226.226,0,0,0-.1.191c-.6-.046-1.773-.108-1.75-.766",
    transform: "translate(41.159 13.894)",
    fill: "#2e0d4b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M91.9,17.172A4.013,4.013,0,0,0,88.7,15.653c-1.474-.056-2.269.691-3.337,1.534a.072.072,0,0,0,.073.123,8.215,8.215,0,0,1,2.96-1.12,4.946,4.946,0,0,1,3.345,1.138.111.111,0,0,0,.153-.156",
    transform: "translate(44.181 8.103)",
    fill: "#2e0d4b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M81.522,16.07a4.767,4.767,0,0,0-4.367-2.577c-2.148-.071-3.594,1.525-5.268,2.547-.044.027,0,.1.049.079.713-.314,1.264-.844,1.947-1.216A8.4,8.4,0,0,1,76.471,14a5.083,5.083,0,0,1,2.928.581c.845.405,1.178,1.155,1.865,1.694a.17.17,0,0,0,.258-.2",
    transform: "translate(37.209 6.985)",
    fill: "#2e0d4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(142.836 25.245)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M97.279,17.143a.921.921,0,0,0-.413-.389.64.64,0,0,0-.437-.12,1.912,1.912,0,0,0-1.5.953,3.748,3.748,0,0,0-.815,2.264c.015.545.43,1.648,1.17,1.493.786-.164,1.179-.936,1.462-1.616a7.848,7.848,0,0,0,.5-1.685c.039-.261.173-.645.035-.9",
    transform: "translate(-94.112 -16.633)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(143.992 31.416)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M96.265,22.07c-.355.493-.888.718-1.19.5s-.261-.794.1-1.289.888-.716,1.19-.5.26.8-.1,1.289",
    transform: "translate(-94.874 -20.699)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(120.967 19.926)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M82.471,15.855c-.706.982-1.765,1.428-2.368.994s-.516-1.581.188-2.562,1.768-1.427,2.371-.994.518,1.581-.191,2.562",
    transform: "translate(-79.703 -13.128)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(141.387 37.347)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M94.549,25.979c-.355.493-.888.718-1.191.5s-.26-.794.1-1.289.888-.716,1.191-.5.26.8-.1,1.289",
    transform: "translate(-93.157 -24.607)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(101.424 39.787)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M68.177,27.281c.03.609-.244,1.117-.618,1.135s-.7-.458-.73-1.065.247-1.116.619-1.135.7.46.729,1.065",
    transform: "translate(-66.826 -26.214)",
    fill: "#ada471"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(121.724 26.709)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M81.552,18.662c.029.609-.246,1.117-.619,1.134s-.7-.457-.729-1.064.247-1.114.619-1.134.7.458.729,1.064",
    transform: "translate(-80.201 -17.598)",
    fill: "#ada471"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M78.295,27.778a11.367,11.367,0,0,1-3.762.747,6.956,6.956,0,0,1-3.471-1.167,5.776,5.776,0,0,1-2.084-2.685c-.234-.534-.414-1.094-.613-1.642a6.3,6.3,0,0,1-.052-2.583.025.025,0,0,0-.05-.006,7.594,7.594,0,0,0-.328,1.949,9.314,9.314,0,0,0,.48,2.138A6.136,6.136,0,0,0,70.732,27.8c2.346,1.707,5.2,1.411,7.605.07a.05.05,0,0,0-.042-.091",
    transform: "translate(35.169 10.573)",
    fill: "#2e0d4b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M96.073,27.191a7.254,7.254,0,0,1-2.151,3.336c-1.348,1.147-2.638,1.973-4.473,1.817a7.607,7.607,0,0,1-4.189-1.63c-1.346-1.05-1.7-2.563-2.193-4.107-.026-.074-.141-.036-.131.038A6.516,6.516,0,0,0,84.69,30.9a8.265,8.265,0,0,0,5.084,2.008c3.01.26,6.147-2.782,6.532-5.657a.122.122,0,0,0-.234-.059",
    transform: "translate(42.939 13.755)",
    fill: "#2e0d4b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M82.975,19.11c.006-3.453-4.348-4.576-7.054-3.665a10.666,10.666,0,0,0-5.1,4.282C68.63,23,68.977,27.707,72.747,29.6c3.8,1.911,7.4-1.269,8.853-4.574a15.32,15.32,0,0,0,1.375-5.921M81.159,24.5c-1.251,3.212-4.3,6-7.927,4.652A5.214,5.214,0,0,1,70.138,25.4a7.336,7.336,0,0,1,1.308-5.64,10.663,10.663,0,0,1,4.019-3.624,6.158,6.158,0,0,1,5.107-.08,3.657,3.657,0,0,1,1.773,3.814A16.559,16.559,0,0,1,81.159,24.5",
    transform: "translate(35.964 7.84)",
    fill: "#2e0d4b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M77.325,16.014a2,2,0,0,0-2.342-.046c-2.195,1.585-1.087,5.144,1.4,4.42a2.725,2.725,0,0,0,1.824-2.037,2.205,2.205,0,0,0-.886-2.337",
    transform: "translate(38.212 8.083)",
    fill: "#2e0d4b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M83.36,25.27c-.566,3.811.851,8.727,5.3,9.152,4.417.422,7.37-3.636,7.264-7.835a11.456,11.456,0,0,0-2.135-6.765c-1.9-2.356-6.393-3.806-8.328-.684a16.586,16.586,0,0,0-2.1,6.132m2.234-5.086a3.864,3.864,0,0,1,3.717-2.444A6.439,6.439,0,0,1,93.8,20.709a11.493,11.493,0,0,1,1.539,5.553,7.915,7.915,0,0,1-2,5.839,5.444,5.444,0,0,1-4.855,1.639c-3.979-.839-5.125-5.084-4.435-8.7a17.839,17.839,0,0,1,1.547-4.86",
    transform: "translate(43.097 8.984)",
    fill: "#2e0d4b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M86.294,20.088a2.938,2.938,0,0,0,.956,2.752c2.129,1.732,4.635-1.32,3.139-3.782a2.1,2.1,0,0,0-2.295-.912,2.334,2.334,0,0,0-1.8,1.943",
    transform: "translate(44.653 9.365)",
    fill: "#2e0d4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(105.652 29.663)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M73.424,22.406a4.523,4.523,0,0,1-1.877.953,5.948,5.948,0,0,1,.688-.735c.477-.457.226-1.486.256-2.044,0-.041-.062-.05-.067-.008-.035.389-.049.779-.082,1.166-.053.607-.592.794-1.017,1.085-.627.431-.527,1.34-.829,1.931-.106.206.243.4.355.2a4.928,4.928,0,0,0,.3-.839,2.471,2.471,0,0,1,.1-.258c.75-.505,1.712-.578,2.23-1.407a.037.037,0,0,0-.059-.044",
    transform: "translate(-69.165 -19.026)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M74.87,25.677c-.094-.6.1-1.056-.231-1.613a5.649,5.649,0,0,1-.484-.677,7.335,7.335,0,0,1-.217-1.179.078.078,0,0,0-.153.024,3.425,3.425,0,0,0,.278,1.622,1.859,1.859,0,0,1,.4,1.094,2.717,2.717,0,0,0,0,.792c.062.25.446.2.4-.064",
    transform: "translate(-67.452 -18.198)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M73.327,24.665h0l0,.011,0-.011",
    transform: "translate(-67.689 -16.893)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M73.443,25.123a2.033,2.033,0,0,1-.073-.443,3.055,3.055,0,0,0-.094-1.026.063.063,0,0,0-.115.05c.1.278-.332,1.612.134,1.645a.151.151,0,0,0,.137-.059.148.148,0,0,0,.027-.083.278.278,0,0,0-.015-.083",
    transform: "translate(-67.82 -17.434)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M73.33,24.681a.039.039,0,0,0,0-.018c-.012-.046-.012-.033,0,.018",
    transform: "translate(-67.692 -16.909)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M74.708,22.467c0-.029-.05-.027-.055,0a1.492,1.492,0,0,1-.425.739,1.06,1.06,0,0,0-.222.622c0,.179.275.211.279.032.011-.5.442-.87.422-1.395",
    transform: "translate(-67.337 -18.042)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M76.978,23.663c-.065-1.041-.839-1.814-1.2-2.749-.021-.052-.093-.015-.079.033a9.229,9.229,0,0,0,.584,1.305c.238.495.062,1.05.314,1.522a.2.2,0,0,0,.382-.112",
    transform: "translate(-66.463 -18.848)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M72.342,19.58c-.253.492-1.018.48-1.483.633-.56.184-.923.92-1.213,1.384a.209.209,0,0,0,.3.287c.546-.4.656-1.2,1.331-1.449.505-.185.985-.256,1.179-.81a.06.06,0,0,0-.111-.044",
    transform: "translate(-69.612 -19.544)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M85.392,23.57a1.821,1.821,0,0,1-.848.549,1.993,1.993,0,0,0,.554-1.084c.006-.049-.074-.073-.088-.021-.164.581-.715.856-1.009,1.354-.127.217-.146.478-.272.7a2.359,2.359,0,0,0-.326.609c-.042.173.208.284.264.1a4.475,4.475,0,0,1,.382-.712,1.7,1.7,0,0,0,.124-.3c.014-.009.03-.011.044-.024a2.78,2.78,0,0,1,.76-.569,1.017,1.017,0,0,0,.516-.545c.018-.061-.064-.115-.1-.056",
    transform: "translate(-62.475 -17.762)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M85.345,26.174c-.014.009-.03.021-.046.03.049-.085.09-.17.146-.256.291-.439.61-.856.864-1.322.029-.055-.064-.108-.1-.055A19.652,19.652,0,0,1,85,26.159a4.661,4.661,0,0,0-.662,1.774c-.053.217.294.256.346.039a10.5,10.5,0,0,1,.346-1.191c.184-.08.317-.281.469-.408.19-.158.36-.334.551-.492a.025.025,0,0,0-.026-.041,3.783,3.783,0,0,0-.681.334",
    transform: "translate(-61.99 -16.953)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M86.329,26.562a.048.048,0,0,0-.1-.011c-.118.744-.153,1.492-.267,2.236-.023.155.194.2.258.065a5.888,5.888,0,0,0,.1-2.29",
    transform: "translate(-61.146 -15.937)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M85.722,26.832a1.984,1.984,0,0,1-.369.581c-.108.152-.276.288-.279.49a.187.187,0,0,0,.073.175l.021.012a.171.171,0,0,0,.231-.033c.059-.065.047-.141.062-.223a1.066,1.066,0,0,1,.158-.373,1.5,1.5,0,0,0,.237-.613.067.067,0,0,0-.134-.015",
    transform: "translate(-61.607 -15.8)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M89.281,26.017c.036-.082-.093-.156-.14-.077a2.851,2.851,0,0,0-.19,2.05,1.6,1.6,0,0,0-.413-.3,3.016,3.016,0,0,1-.858-.458,2.12,2.12,0,0,1-.5-.9c-.02-.061-.123-.032-.106.03a2.017,2.017,0,0,0,.675,1.214c.231.184.548.231.789.407s.325.484.492.722c0,.008.012.008.017.014a3.534,3.534,0,0,1,.011.422.167.167,0,0,0,.331.038c.115-1.119-.595-2.047-.1-3.161",
    transform: "translate(-60.574 -16.25)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M89.9,27.2c-.1-.355-.434-.593-.449-.982,0-.09-.144-.082-.155,0-.039.4.2.656.349,1,.1.243.055.7.325.832.074.036.134-.039.132-.106a3.347,3.347,0,0,0-.2-.747",
    transform: "translate(-59.424 -16.119)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M91.252,25.807a4.854,4.854,0,0,1-.093-1.163,5.27,5.27,0,0,0-.464-1.287c-.027-.079-.152-.038-.138.041A7.152,7.152,0,0,1,90.88,25c-.008.12-.017.247-.014.373-.521-.437-1.226-.612-1.657-1.2-.033-.042-.094.009-.065.053a3.1,3.1,0,0,0,.613.729c.322.288.751.32,1.029.688a5.012,5.012,0,0,1,.514.958,2.955,2.955,0,0,0,.357.779c.074.08.243.061.247-.071a3.05,3.05,0,0,0-.653-1.5",
    transform: "translate(-59.504 -17.592)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M91.369,23.756c-.2-.181-.565-.372-.645-.637-.023-.07-.129-.033-.121.036a.975.975,0,0,0,.382.539,3.313,3.313,0,0,1,.36.37c.137.173.05.417.146.61a.152.152,0,0,0,.288-.082,1.275,1.275,0,0,0-.41-.836",
    transform: "translate(-58.745 -17.713)",
    fill: "#b76c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M76.745,20.628c-.018-.032-.077-.021-.065.018a3.2,3.2,0,0,0,.273.672,1.172,1.172,0,0,1,.228.833c-.074.281.34.378.378.1.085-.639-.536-1.119-.814-1.621",
    transform: "translate(-65.954 -18.992)",
    fill: "#b76c6e"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M89.322,3.926a29.438,29.438,0,0,0-3.743-.821,39.279,39.279,0,0,0-4.113-.648c-2.648-.208-5.292.1-7.933.044a.066.066,0,0,0-.015.132,74.3,74.3,0,0,0,7.467.436,59.35,59.35,0,0,1,8.3,1,.074.074,0,0,0,.036-.143",
    transform: "translate(38.032 1.234)",
    fill: "#84746d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M93.19,3.906a13.377,13.377,0,0,0-5.107-1.847,44.21,44.21,0,0,0-7.108-.735.064.064,0,0,0-.015.127c2.1.363,4.187.742,6.3.993A16.356,16.356,0,0,1,93.09,4.083c.106.059.191-.109.1-.178",
    transform: "translate(41.886 0.686)",
    fill: "#84746d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M94.019,4.621c-2.146.094-4.239-.182-6.333.436-1.524.451-2.7,1.923-3.64,3.127-.053.068.044.167.111.106,1.184-1.058,2.134-2.324,3.7-2.843C89.83,4.79,92,5,94.039,4.749c.085-.011.062-.132-.02-.127",
    transform: "translate(43.505 2.393)",
    fill: "#84746d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M98.208,10.116c-.425.123-.847.256-1.267.4s-.854.386-1.293.527c.206-1.14-.6-2.413-.111-3.538a.105.105,0,0,0-.173-.111.074.074,0,0,0-.077-.1,18.6,18.6,0,0,0-3.189.613,16.953,16.953,0,0,0-2.3.876,24.282,24.282,0,0,1,2.837-3.4c.067-.065-.012-.173-.09-.114a15.665,15.665,0,0,0-3.427,3.785c-.088.132.008.375.194.322.789-.22,1.462-.7,2.234-.983a24.239,24.239,0,0,1,3.765-.946.05.05,0,0,0,.03-.017c-.66,1.122-.008,2.6-.015,3.8a.138.138,0,0,0,.19.143,10.244,10.244,0,0,1,1.226-.627c.507-.162,1.021-.267,1.513-.467.087-.033.046-.184-.046-.156",
    transform: "translate(46.12 2.718)",
    fill: "#84746d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M99.269,12.53A7.821,7.821,0,0,1,98.032,9.5a.125.125,0,0,0-.2-.079,13.056,13.056,0,0,1-1.169.918c-.03.021,0,.062.035.044.405-.256,1-.929,1.073-.179a4.824,4.824,0,0,0,.606,1.544c.627,1.272,1.293,2.521,1.891,3.808.023.052.114.03.1-.03a13.646,13.646,0,0,0-1.1-3",
    transform: "translate(50.039 4.865)",
    fill: "#84746d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M101.249,14.907a6.871,6.871,0,0,1-.5-2.553,6.861,6.861,0,0,0-.894-2.509.089.089,0,0,0-.17.049,20.428,20.428,0,0,0,.636,2.507,9.6,9.6,0,0,0-1.436-2.222.074.074,0,0,0-.115.091c.143.229.273.463.4.7v0a13.057,13.057,0,0,1,.528,3.456c-.039,1.252-.222,2.488-.171,3.746,0,.064.111.062.117,0,.088-1.753.647-3.547.434-5.257.161.352.331.7.513,1.041a3.413,3.413,0,0,0,.493,1.055.1.1,0,0,0,.168-.1",
    transform: "translate(51.129 5.07)",
    fill: "#84746d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M105.541,11.59a22.389,22.389,0,0,1-3.6-2.067,4.441,4.441,0,0,0-3.19-.159c-.068.011-.05.106.017.1a11.139,11.139,0,0,1,1.653.058,5.9,5.9,0,0,1,2.016.85,14.784,14.784,0,0,0,3.089,1.289c.041.011.059-.061.017-.073",
    transform: "translate(51.104 4.736)",
    fill: "#84746d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M100.149,6.946a4.141,4.141,0,0,0-1.642,1.04,10,10,0,0,0-1.024,1.638c-.046.062.041.155.1.1a14.075,14.075,0,0,0,1.055-1.34,12.7,12.7,0,0,1,1.6-1.292.085.085,0,0,0-.087-.143",
    transform: "translate(50.463 3.594)",
    fill: "#84746d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M95.846,3.989a.076.076,0,0,0-.152-.018c-.475,2.516,2.169,4.089,2.192,6.519a.083.083,0,0,0,.165.018c.369-2.539-2.286-4.039-2.205-6.519",
    transform: "translate(49.514 2.022)",
    fill: "#84746d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M87.448,3.78A14.961,14.961,0,0,0,80.2,6.175c-2.356,1.474-3.873,3.816-5.658,5.858-.05.056.039.143.094.093.851-.774,1.544-1.7,2.363-2.5a37.028,37.028,0,0,1,2.931-2.589,21.032,21.032,0,0,1,3.406-1.979A20.631,20.631,0,0,1,87.478,3.98a.1.1,0,0,0-.03-.2",
    transform: "translate(38.584 1.957)",
    fill: "#84746d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M83.308,3.568a39.582,39.582,0,0,0-7.353.4,56.015,56.015,0,0,0-7.132,1.88c-.059.02-.029.114.03.1,2.258-.386,4.508-.98,6.768-1.4,2.556-.478,5.118-.555,7.689-.862.071-.008.07-.124,0-.124",
    transform: "translate(35.615 1.843)",
    fill: "#84746d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M88.952,3.54a20.385,20.385,0,0,0-5.338,1.692C81.9,6.253,81.16,8.243,79.775,9.586c-.052.05.011.134.07.088,1.422-1.1,2.33-2.738,3.746-3.854,1.556-1.228,3.573-1.533,5.385-2.2.044-.018.023-.093-.023-.079",
    transform: "translate(41.291 1.832)",
    fill: "#84746d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M76.8,5.456c-2.506.484-4.746,1.858-7.17,2.6-.029.009-.015.058.017.052,2.466-.505,4.788-1.773,7.18-2.562.052-.015.024-.1-.027-.09",
    transform: "translate(36.042 2.825)",
    fill: "#84746d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M83.7,27.6c-1.311-1.754-.329-3.227-.976-5.154-.534,1.407-.707,2.418-1.926,3.463-1.245,1.065-2.906,1.748-3.89,3.227a.053.053,0,0,0,.085.064,5.416,5.416,0,0,1,4.933-1.654c1.99.562,2.454,2.847,2.906,4.514a.1.1,0,0,0,.19-.03A9.258,9.258,0,0,0,83.7,27.6",
    transform: "translate(39.811 11.622)",
    fill: "#f9efb9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M68.723,17.954a13.817,13.817,0,0,0-3.878,6.636c-.511,2.2-1.147,5.154.3,7.135a.176.176,0,0,0,.311-.135c-1-4.385,1.232-9.718,3.441-13.465.065-.111-.064-.275-.175-.17",
    transform: "translate(33.267 9.279)",
    fill: "#f9efb9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M65.635,27.68a.413.413,0,0,0-.162-.1.259.259,0,0,0-.235.455s.006.011.026.032c.24.3.668-.117.372-.384",
    transform: "translate(33.717 14.271)",
    fill: "#f9efb9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M94.062,27.835c-.656,2.811-2.529,4.908-3.65,7.476-.062.143.126.222.22.124a13.935,13.935,0,0,0,3.673-7.573.122.122,0,0,0-.243-.027",
    transform: "translate(46.802 14.358)",
    fill: "#f9efb9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M93.313,17.145c-1.3-3.975-6.019-2.6-8.267-.422a.126.126,0,0,0,.158.2,6.853,6.853,0,0,1,4.247-1.457,6.17,6.17,0,0,1,3.608,1.885c.141.12.305-.058.255-.2",
    transform: "translate(44.007 7.567)",
    fill: "#f9efb9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M74.385,34.554c-.663-.449-2.4-1.134-2.428.285-.014.836.938,1.38,1.729,1.747a2.591,2.591,0,0,0,.338.152l.231.1a.447.447,0,0,0,.457-.039,1.017,1.017,0,0,0,.112-.029c1.1-.454.168-1.8-.439-2.217",
    transform: "translate(37.254 17.597)",
    fill: "#f9efb9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M75.09,35.534l-.009.011a.541.541,0,0,0-.181.2.677.677,0,0,0,.187.823.67.67,0,0,0,.941-.176c.505-.583-.4-1.3-.938-.856",
    transform: "translate(38.741 18.326)",
    fill: "#f9efb9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M63.738,19.235a1.847,1.847,0,0,0-2.506-.615c-1.059.6-1.232,2.146-1.213,3.225,0,.093.15.156.178.044a4.978,4.978,0,0,1,1.049-2.576c.7-.675,1.571.035,2.307.173a.181.181,0,0,0,.185-.252",
    transform: "translate(31.073 9.512)",
    fill: "#f9efb9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M98.154,31.646c-.056-1.4-1.146-1.887-2.371-1.914-.073,0-.115.114-.033.135,2.718.769,1.724,3.79.583,5.49-.114.173.1.411.272.263a4.916,4.916,0,0,0,1.55-3.973",
    transform: "translate(49.549 15.394)",
    fill: "#f9efb9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M83.65,39.424c-.231-.748-.5-1.487-.788-2.216-.867-2.161-1.718-4.327-2.679-6.44a42.081,42.081,0,0,0-2.717-5.113c-1.422-2.236-2.79-5.8-5.018-7.678-.032-.041-.068-.085-.1-.126-1.525-1.811-4.283-2.56-6.415-3.331A27.848,27.848,0,0,0,58.673,12.7,23.784,23.784,0,0,0,45.1,15.906c-1.3.756-3.62,2.655-4.329,4.585a26.392,26.392,0,0,0-3.293,6.634A101.685,101.685,0,0,0,34.3,37.867q-.025.091-.046.182a41.508,41.508,0,0,0-1.425,8.64,26.082,26.082,0,0,0,.05,3.04c.272,3.5,2.175,6.493,4.5,8.971,5.28,5.637,13.646,6.639,20.722,8.008a5.685,5.685,0,0,0,2.782-.159,7.091,7.091,0,0,0,1.238-.42c1.964-.882,3.948-1.7,5.915-2.585a37.034,37.034,0,0,0,10.028-6.66,20.16,20.16,0,0,0,5.994-9.07,14.591,14.591,0,0,0-.4-8.39",
    transform: "translate(16.984 6.54)",
    fill: "#8ea2d1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M60.251,67.316h0a6.043,6.043,0,0,1-2.09-.039c-.739-.143-1.492-.281-2.251-.42-6.5-1.2-13.88-2.562-18.7-7.716-2.856-3.049-4.363-6.069-4.609-9.229a26.035,26.035,0,0,1-.052-3.092,41.783,41.783,0,0,1,1.437-8.731l.29-1.116a93.708,93.708,0,0,1,2.944-9.855,26.74,26.74,0,0,1,3.315-6.689c.774-2.016,3.1-3.939,4.5-4.749a24.444,24.444,0,0,1,13.828-3.265,28.633,28.633,0,0,1,7.369,1.849c.29.1.592.208.9.314,2.019.7,4.3,1.49,5.7,3.14l.082.1A18.764,18.764,0,0,1,76.7,23.3c.443.832.861,1.615,1.279,2.277a41.463,41.463,0,0,1,2.749,5.165c.856,1.88,1.636,3.831,2.39,5.72l.3.739c.307.766.575,1.521.8,2.246a14.886,14.886,0,0,1,.4,8.636A20.47,20.47,0,0,1,78.5,57.345a37.387,37.387,0,0,1-10.144,6.739c-.98.44-1.967.867-2.953,1.292s-1.976.85-2.958,1.29a7.348,7.348,0,0,1-1.316.449,6.078,6.078,0,0,1-.873.2M53.793,13.472a24.1,24.1,0,0,0-8.332,2.952c-1.249.727-3.48,2.554-4.145,4.362l-.059.112a25.884,25.884,0,0,0-3.236,6.526,93.625,93.625,0,0,0-2.916,9.761l-.29,1.122a40.742,40.742,0,0,0-1.41,8.549,25.6,25.6,0,0,0,.049,2.988c.231,2.957,1.663,5.807,4.379,8.709,4.634,4.946,11.858,6.28,18.234,7.457.763.141,1.518.281,2.257.423a5.247,5.247,0,0,0,1.8.032,5.383,5.383,0,0,0,.777-.181,6.736,6.736,0,0,0,1.191-.4c.988-.443,1.978-.87,2.969-1.3S67.022,63.736,68,63.3a36.622,36.622,0,0,0,9.911-6.584,19.672,19.672,0,0,0,5.872-8.873,14.066,14.066,0,0,0-.4-8.146c-.217-.7-.478-1.434-.777-2.179l-.3-.742c-.751-1.877-1.527-3.82-2.375-5.682a41.213,41.213,0,0,0-2.689-5.059c-.437-.688-.862-1.486-1.314-2.333a18.033,18.033,0,0,0-3.614-5.247l-.158-.179c-1.24-1.472-3.407-2.22-5.321-2.885-.314-.106-.616-.211-.911-.317a27.972,27.972,0,0,0-7.145-1.8,21.423,21.423,0,0,0-4.993.2",
    transform: "translate(16.837 6.394)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(49.677 19.324)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M83.578,39.524c-.231-.747-.5-1.486-.789-2.213-.865-2.164-1.715-4.33-2.679-6.44a41.677,41.677,0,0,0-2.718-5.115c-1.419-2.236-2.787-5.8-5.015-7.678-.035-.041-.068-.083-.1-.124-1.527-1.811-4.285-2.562-6.415-3.333A28.029,28.029,0,0,0,58.6,12.8a23.766,23.766,0,0,0-13.576,3.208c-1.3.754-3.62,2.653-4.33,4.585A26.5,26.5,0,0,0,37.4,27.226a102.757,102.757,0,0,0-3.172,10.742c-.015.061-.032.121-.046.181a41.522,41.522,0,0,0-1.425,8.642,25.09,25.09,0,0,0,.052,3.038c.272,3.5,2.173,6.494,4.494,8.971,5.28,5.64,13.644,6.639,20.722,8.011a5.7,5.7,0,0,0,2.78-.161,6.922,6.922,0,0,0,1.241-.422c1.962-.879,3.946-1.7,5.912-2.58a37.074,37.074,0,0,0,10.028-6.664,20.171,20.171,0,0,0,6-9.068,14.583,14.583,0,0,0-.4-8.392m-2.43,10.308a14.711,14.711,0,0,1-3.263,4.332,29.042,29.042,0,0,1-3.318,2.614,23.394,23.394,0,0,1-2.33,1.363,7.672,7.672,0,0,1-1.987,1c1.106-1.293,2.243-2.486,3.435-3.7a5.173,5.173,0,0,0,1.1-2.219c-.076.266.689-.176.763-.272a3.083,3.083,0,0,0,.372-1.325c-.032.2.551-.26.6-.358.153-.3.014-.792-.006-1.1.484.613.911-.386.927-.794.135.449.593.865,1,.42.622-.677-.222-2.858-.378-3.594-.126-.589-.137-1.789-.747-2.123-.788-.43-.953.738-1,1.251.021-.216-.709-.115-.8-.09-.144-.408-.407-1.27-1.017-.953-.542.285-.554,1.75-.625,2.254.055-.393-.589-1.323-.8-1.625s-1.472-1.305-1.43-.185c.082,2.24-2.246,2.055-3.828,2.357-.657.127-1.323.426-1.972.516a24.062,24.062,0,0,1-2.736-.127,17.764,17.764,0,0,0-2.984.332,31.151,31.151,0,0,0-5.5,1.654c-2.668,1.049-5.441,2.6-8.325,2.937-.777.09-.847-.238-1.237-.666-.314-.346-.768-.8-1.2-.314-.225-.3-.267-.865-.733-.826-.443.035-.559.733-.674,1.067-.343-.369-.748-.949-1.3-1.006-.408-.046-.867.137-.651.642-.5-.381-1.607-1.035-1.6.021a6.2,6.2,0,0,0,.791,2.085c.367.9.675,1.817,1.065,2.708.369.85.952,1.944,1.452.574-.052.143,1.371,1.217,1.352.068,1.111,1.131,1.3.208,1.258-1a21.02,21.02,0,0,0,5.4,4.845c1.868,1.184,3.888,1.586,5.858,2.475a12.579,12.579,0,0,0,1.89.8,19.387,19.387,0,0,1-10.395-1.809c-2.97-1.434-6.426-3.189-8.663-5.669a14.472,14.472,0,0,1-3.64-9.284,16.779,16.779,0,0,1,1.068-5.028c.325,1.636,1.522,3.281,3.084,3.381,5.051,2.475,11.709-2.4,11.91-7.88.121-3.331-1.534-6.519-1.765-9.821-.167-2.442,1.387-3.9,3.09-5.33a32.065,32.065,0,0,1,4.908-3.564c.032-.009.061-.023.091-.03-.619,1.386-1.569,2.8.549,3.36,1.4.372-.175,3.811-.381,4.652a16.6,16.6,0,0,0-.4,4.949c.272,4.459,3.216,7.388,6.9,9.038a9,9,0,0,0,5.274,1.519c5.042,1.5,10.234-4.407,8.545-9.378,1.126.949,3.136,4.716,3.725,6.934a13.977,13.977,0,0,1-.73,9.932",
    transform: "translate(-32.731 -12.732)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(49.534 23.149)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M59.823,15.252c-3.382.835-6.59,1.55-9.7,3.287a.476.476,0,0,1-.228.332c-.783.507-1.7.883-2.48,1.419-.341.657-.671,1.225-1.513,1.384a.574.574,0,0,1-.546-.9,4.332,4.332,0,0,1,1.205-1.251,2.545,2.545,0,0,1,.188-.37,5.1,5.1,0,0,1,.3-.42,24.211,24.211,0,0,0-7.029,5.655c-2.688,3.154-3.636,7.226-4.98,11.043-1.512,4.282-2.823,9.053-2.272,13.635a15.252,15.252,0,0,0,3.553,7.49.875.875,0,0,1,.686.39,10.125,10.125,0,0,0,1.908,1.592c.032.026.062.049.093.076a56.033,56.033,0,0,1-3.894-5.807c-.436-1.6-1.084-3.019-1.374-4.6a17.862,17.862,0,0,1,.091-3.791,40.932,40.932,0,0,1,1.832-6.748,3.13,3.13,0,0,0,.1.709c.929,3.491,4.937,5.32,8.273,4.638,3.617-.738,5.872-4.142,6.628-7.5,1.014-4.5-1.043-8.053-3.668-11.433a1.535,1.535,0,0,1,0-.323c.12-1.065,1.431-1.771,2.243-2.271,2.057-1.269,3.872-2.873,5.88-4.216a15.006,15.006,0,0,1,4.72-2.025l-.012,0",
    transform: "translate(-32.637 -15.253)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(75.317 24.002)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M72.81,31.992a.733.733,0,0,1-.358-.431c-.9-2.522-2.518-4.679-3.643-7.094a.919.919,0,0,1-.077-.249.266.266,0,0,1-.042-.059c-1.812-3.081-3.351-6.394-7.007-7.692a11.361,11.361,0,0,0-4.1-.653,22.247,22.247,0,0,1-6.112,1.754.8.8,0,0,1-.627-.143l0,0,.033.032a.342.342,0,0,0,.212.209,3.4,3.4,0,0,0,2.111.87c-.015.015-.032.023-.047.038-3.066,3.932-4.682,8.942-2.586,13.673C52.16,35.834,56,39.026,60.031,39.2a8.241,8.241,0,0,0,4.45-.994c1.961-.423,3.057-1.694,3.735-3.723a11.349,11.349,0,0,0,.24-5.632c-.024-.32-.053-.64-.1-.959a12,12,0,0,1-.153-2.047,86.023,86.023,0,0,1,5.471,10.909,31.959,31.959,0,0,1,1.71,6.033.253.253,0,0,0,.505-.02,10.5,10.5,0,0,0-.02-1.431c.011,0,.015-.011.023-.015a.129.129,0,0,1-.006-.035C75.562,38,74.055,35,72.81,31.992",
    transform: "translate(-49.625 -15.814)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(52.416 52.049)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M38.913,46.282a18.12,18.12,0,0,1-2.481-4.332,9.357,9.357,0,0,1-.616-2.195c-.073-.555-1.2-4.672-1.279-5.453-.02-.209.346,3.383.386,4.107A10.636,10.636,0,0,0,36.06,42.6a20.405,20.405,0,0,0,2.853,3.687",
    transform: "translate(-34.536 -34.294)",
    fill: "#86cfca"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(97.627 44.873)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M64.324,42.318a18.363,18.363,0,0,0,1.05-4.879,9.477,9.477,0,0,0-.077-2.281c-.1-.549-.273-4.814-.437-5.584-.041-.2.7,3.33.879,4.033a10.621,10.621,0,0,1,.182,4.336,20.534,20.534,0,0,1-1.6,4.376",
    transform: "translate(-64.324 -29.566)",
    fill: "#86cfca"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(69.855 46.027)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M48.776,32.261c-.842-1.342-1.747-3.215-2.29-.684s-.943,5.013.851,4.808c.707-.079,1.606-.219,1.973.319.739,1.081.495-.492,1.729-.581s3.418-.426,2.6-2.016-3.277-5.368-3.315-2.919-.7,2.436-1.55,1.073",
    transform: "translate(-46.026 -30.326)",
    fill: "#8ea2d1"
  }))))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M46.252,32.233s.874-1.034,1.7-.1,1.352,1.343,1.868.282,1.773-.329,1.773-.329-.618-.542-1.411-1.2c-1-.826-1.838-6.576-2.123-2.993s-1.317,3.283-1.806,4.338",
    transform: "translate(23.946 13.84)",
    fill: "#deeaf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(74.498 46.877)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M49.167,31.375c-.056,1.287-.261,4.21.314,3.986s.555-.8,1.389-.454,1.134-.108.358-1.615-2-3.283-2.061-1.917",
    transform: "translate(-49.085 -30.885)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(70.84 46.633)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M46.71,32.637c-.021.993-.17,3.251.355,2.961s.8.759,1.084-.065-1.33-8.218-1.439-2.9",
    transform: "translate(-46.675 -30.725)",
    fill: "#8ea2d1"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M50.748,28.643s.22.27.644.71c.206.219.469.478.785.76s.677.584,1.085.9a14.028,14.028,0,0,0,1.374.924,11.882,11.882,0,0,0,1.65.8,9.259,9.259,0,0,0,1.874.5,8.132,8.132,0,0,0,1.988.061c.328-.049.671-.076.987-.137q.505-.121,1-.237c.317-.1.631-.193.943-.288.3-.12.61-.222.9-.355a8.934,8.934,0,0,0,.824-.425l.387-.229.351-.261a6.432,6.432,0,0,0,.634-.548,5.558,5.558,0,0,0,.495-.6,4.615,4.615,0,0,0,.622-1.223,4.718,4.718,0,0,0,.2-1.754c-.012-.164-.018-.25-.018-.25s.02.085.055.244c.02.08.036.181.053.3a2.671,2.671,0,0,1,.032.408,4.42,4.42,0,0,1-.1,1.116,4.254,4.254,0,0,1-.542,1.361,5.306,5.306,0,0,1-.487.691,5.957,5.957,0,0,1-.648.633l-.364.3-.4.27a7.761,7.761,0,0,1-.862.486c-.3.152-.619.27-.936.408-.325.117-.662.22-1,.326-.332.082-.668.165-1.006.247-.363.076-.713.108-1.076.164a8.6,8.6,0,0,1-4.133-.683A11.177,11.177,0,0,1,53.026,31.3a11.939,11.939,0,0,1-1.02-1.017c-.288-.316-.525-.6-.71-.85a7.027,7.027,0,0,1-.411-.575l-.137-.212",
    transform: "translate(26.274 13.974)",
    fill: "#2d154a"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M54.341,32.321s.172.061.484.14c.152.046.343.082.555.14.217.039.458.1.727.137s.552.082.858.111c.307.046.628.029.958.055.334-.018.674,0,1.02-.052.172-.018.345-.039.519-.059s.341-.071.515-.108a5.859,5.859,0,0,0,1-.282,2.544,2.544,0,0,0,.48-.184c.155-.068.307-.137.46-.2a3.108,3.108,0,0,0,.426-.229c.14-.08.273-.161.4-.238a5.879,5.879,0,0,0,.71-.492,5.7,5.7,0,0,0,.583-.451c.164-.149.31-.278.428-.386l.382-.329s-.1.152-.288.414q-.143.2-.346.474a4.271,4.271,0,0,1-.516.559,4.658,4.658,0,0,1-.675.607,7.054,7.054,0,0,1-.842.574l-.48.25-.246.127-.261.094a6.875,6.875,0,0,1-1.085.326c-.188.035-.373.082-.562.1s-.375.033-.56.052a3.553,3.553,0,0,1-.552.015c-.182-.006-.363-.014-.54-.017a8.636,8.636,0,0,1-1-.147c-.155-.033-.311-.064-.457-.1l-.419-.126a7.541,7.541,0,0,1-.715-.263c-.206-.093-.384-.173-.527-.252a3.48,3.48,0,0,1-.436-.26",
    transform: "translate(28.134 15.475)",
    fill: "#2d154a"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M64.438,28.455a2.659,2.659,0,0,1,.035.426c.008.138,0,.3-.011.5a5.44,5.44,0,0,1-.09.636c-.026.117-.052.238-.077.363s-.077.249-.12.379a5.219,5.219,0,0,1-.343.8,4.781,4.781,0,0,1-.516.776,4.867,4.867,0,0,1-.672.7,7.587,7.587,0,0,1-.794.555c-.282.144-.574.261-.848.381-.288.083-.574.152-.835.219-.267.05-.527.059-.76.083l-.335.027c-.109,0-.211-.009-.307-.014-.188-.014-.354-.027-.492-.035-.267-.026-.422-.046-.422-.046s.155-.033.419-.085c.132-.021.293-.049.477-.08a3.964,3.964,0,0,0,.6-.135c.219-.062.455-.109.7-.185.235-.093.484-.191.744-.279q.364-.189.744-.39a7.061,7.061,0,0,0,.692-.51,4.48,4.48,0,0,0,.61-.6,6.556,6.556,0,0,0,.507-.668c.134-.235.281-.46.385-.691s.211-.448.287-.659.138-.408.2-.583c.044-.178.1-.332.126-.463a4.163,4.163,0,0,0,.091-.413",
    transform: "translate(29.951 14.732)",
    fill: "#2d154a"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M34.607,30.108s.029.067.079.2.144.31.253.539.267.5.458.8a10.492,10.492,0,0,0,.709.947,5.974,5.974,0,0,0,.458.492l.25.247c.093.076.184.153.276.231a7.077,7.077,0,0,0,1.281.833c.231.124.49.208.738.316.258.087.525.147.791.231.272.047.548.094.826.14.261.024.577.039.864.061l.838,0c.281-.032.565-.047.839-.094a7.381,7.381,0,0,0,1.568-.425A6.09,6.09,0,0,0,47.2,32.983c.073-.079.141-.159.211-.234l.181-.241a4.487,4.487,0,0,0,.317-.461,4.072,4.072,0,0,0,.241-.431,3.343,3.343,0,0,0,.178-.381,5.238,5.238,0,0,0,.206-.557c.041-.134.065-.2.065-.2s-.009.073-.032.209a3.326,3.326,0,0,1-.121.59,2.741,2.741,0,0,1-.134.411,5.713,5.713,0,0,1-.824,1.533,6.093,6.093,0,0,1-1.023,1.064,6.415,6.415,0,0,1-1.413.856,7.019,7.019,0,0,1-1.688.519c-.294.052-.6.073-.9.111-.308.006-.621.018-.924.012-.3-.023-.572-.039-.892-.071-.3-.055-.6-.1-.9-.165-.288-.09-.58-.168-.854-.273-.267-.129-.543-.232-.789-.375a6.676,6.676,0,0,1-1.334-.976c-.094-.09-.187-.179-.279-.266s-.167-.19-.247-.282a5.478,5.478,0,0,1-.433-.559,7.98,7.98,0,0,1-.991-1.921c-.088-.246-.138-.442-.173-.577s-.046-.206-.046-.206",
    transform: "translate(17.917 15.588)",
    fill: "#2d154a"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M49.8,30.028a5.971,5.971,0,0,1-.231.712,10.905,10.905,0,0,1-.879,1.777,9.534,9.534,0,0,1-1.809,2.173,8.361,8.361,0,0,1-1.317.939,7.517,7.517,0,0,1-1.542.66,8.245,8.245,0,0,1-1.653.293c-.275.009-.551.017-.821.006s-.537-.035-.794-.071-.511-.077-.757-.134l-.706-.187a10.963,10.963,0,0,1-1.249-.463c-.188-.085-.367-.164-.54-.24l-.464-.255c-.294-.158-.543-.3-.742-.431-.4-.257-.625-.408-.625-.408s.25.1.683.3c.212.1.478.209.785.323l.487.188.548.178c.376.138.8.226,1.24.346.223.041.452.083.684.129.235.03.477.059.721.091s.495.021.747.035c.25,0,.5-.018.76-.027a7.311,7.311,0,0,0,1.512-.293,6.776,6.776,0,0,0,1.427-.584,8.789,8.789,0,0,0,1.254-.829,11.271,11.271,0,0,0,1.871-1.949,12.989,12.989,0,0,0,1.065-1.619c.234-.413.346-.659.346-.659",
    transform: "translate(18.465 15.547)",
    fill: "#2d154a"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M35.982,33.721s.126.049.341.14.525.2.892.337l.6.2c.211.074.44.129.669.2s.48.117.722.181c.247.042.495.115.748.138a6.2,6.2,0,0,0,.756.1c.123.009.25.021.372.035s.244,0,.364.006a5.469,5.469,0,0,0,.691-.011A4.652,4.652,0,0,0,42.76,35l.53-.064c.156-.032.294-.061.407-.082.229-.042.364-.062.364-.062s-.111.068-.319.182c-.106.055-.232.126-.382.2s-.326.124-.521.19a3.374,3.374,0,0,1-.64.165l-.358.068c-.123.018-.249.02-.378.032l-.392.026c-.132,0-.266-.008-.4-.014a7.445,7.445,0,0,1-.815-.08c-.273-.033-.536-.117-.8-.172-.26-.07-.511-.156-.748-.246a8,8,0,0,1-1.249-.607,5.565,5.565,0,0,1-1.078-.81",
    transform: "translate(18.629 17.459)",
    fill: "#2d154a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M47.906,25.114c.457,1.445,2.034,8.888-3.072,12.13s-10.542-.212-9.581-7.006,4.726-9.175,7.655-9.248,4.571,2.776,5,4.124",
    transform: "translate(18.194 10.867)",
    fill: "#ece6e2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M43.673,28.351c0,2.576-1.346,4.662-3,4.658s-2.982-2.093-2.975-4.672,1.345-4.664,2.993-4.659,2.982,2.1,2.978,4.673",
    transform: "translate(19.519 12.259)",
    fill: "#3f0f23"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M42.938,28.059c0,2.1-1.1,3.806-2.447,3.8s-2.434-1.712-2.428-3.816,1.1-3.808,2.444-3.806,2.436,1.71,2.431,3.817",
    transform: "translate(19.706 12.551)",
    fill: "#991c24"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M42.066,27.708c0,1.544-.806,2.791-1.792,2.79s-1.785-1.255-1.782-2.8.806-2.79,1.792-2.788,1.783,1.252,1.782,2.794",
    transform: "translate(19.928 12.899)",
    fill: "#6a0d23"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M41.586,27.518c0,1.232-.644,2.233-1.436,2.231s-1.425-1-1.422-2.237.642-2.233,1.433-2.23,1.427,1,1.425,2.236",
    transform: "translate(20.051 13.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(53.335 31.856)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M47.906,25.114c-.426-1.348-2.069-4.2-5-4.124s-6.7,2.457-7.657,9.248,4.476,10.251,9.581,7.006,3.529-10.685,3.072-12.13M46.813,27.9c.229,2.522-1.46,4.961-5.4,5.192s-5.222-1.367-4.625-4.889,3.978-4.251,5.433-4.272c3.151-.056,4.365,1.445,4.591,3.969",
    transform: "translate(-35.142 -20.989)",
    fill: "#cac0bb"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M47.486,25.067c-.449-1.366-2.082-4.149-4.98-4.077-2.251.058-5,1.48-6.584,5.218,1.656-2.529,6.761-4.518,11.564-1.141",
    transform: "translate(18.598 10.867)",
    fill: "#8ea2d1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M41.648,30.253a10.023,10.023,0,0,1-6.494-1.3c.3,5.392,5.118,7.841,9.674,4.945a8.229,8.229,0,0,0,3.6-6.44,11.592,11.592,0,0,1-6.775,2.8",
    transform: "translate(18.2 14.216)",
    fill: "#8ea2d1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M87.371,17.712a14.226,14.226,0,0,0-2.107-1.387,13.177,13.177,0,0,1,5.324.6c.405.124.559-.39.351-.651-1.439-1.788-3.834-2.53-5.971-3.086a17.593,17.593,0,0,0-2.588-.477,19.6,19.6,0,0,1,3.448-.433.369.369,0,0,0,.24-.628C83.414,9.293,79.785,8.5,76.313,8.46a15.342,15.342,0,0,0-5.194.715,9.433,9.433,0,0,1,4.927-2.3c.373-.062.293-.612-.024-.691-2.079-.528-4.335.108-6.374.563A15.171,15.171,0,0,0,65.722,8.1l.015-.033A5.385,5.385,0,0,1,68.61,5.329c.282-.106.328-.572-.02-.627A13.051,13.051,0,0,0,61.582,5.83,12.088,12.088,0,0,0,58.7,7.515,7.018,7.018,0,0,1,62.709,3.45a.307.307,0,0,0-.176-.587A20.479,20.479,0,0,0,50.742,9.97a8.957,8.957,0,0,1-.557-1.342,10.7,10.7,0,0,1-.264-6.377c.115-.329-.32-.449-.525-.285-3.7,3-5,8.543-3.706,13.086A11.235,11.235,0,0,0,44,14.158a13.267,13.267,0,0,0-4.652-.8,19.173,19.173,0,0,0-7.441.812.178.178,0,0,0,.1.341c.129-.027.258-.046.387-.071A14.527,14.527,0,0,1,35.5,15.521a12.38,12.38,0,0,1,3.272,1.66c.093.073.185.152.275.229-.3,0-.56.008-.706,0a17.282,17.282,0,0,0-4.758.345c-3.073.622-5.538,2.38-7.921,4.333-.263.216.039.609.326.531a23.71,23.71,0,0,1,4.527-.891,7.381,7.381,0,0,1,1.229.056A13.752,13.752,0,0,0,29.7,23.513c-1.238,1.32-2.135,2.919-3.409,4.218-.229.234.087.637.363.451,1.12-.754,2.166-2.085,3.539-2.351a15.019,15.019,0,0,1-1.242,1.627c-.587.817-1.014,1.736-1.6,2.56-.19.273.244.566.464.338a22.1,22.1,0,0,1,3.289-2.979,15.71,15.71,0,0,1,2.172-1.421c-1.859,2.582-4.033,5.049-4.69,8.25-.049.237.281.464.448.241a15.026,15.026,0,0,1,2.938-2.884c.408-.31.9-.606,1.352-.933A19.208,19.208,0,0,0,31,39.123c0,.273.425.39.534.127A19.54,19.54,0,0,1,32.853,36.7,14.516,14.516,0,0,1,34,34.816a19.38,19.38,0,0,0-.549,2.756,16.5,16.5,0,0,0,.263,4.045,28.15,28.15,0,0,0,3.014,7.924,78.4,78.4,0,0,1,2-7.76,38.307,38.307,0,0,1,2.532-7.259,20.626,20.626,0,0,1,5-5.9c1.056-.888,2.223-1.613,3.35-2.4.467-.326.935-.654,1.413-.968a31.732,31.732,0,0,0-2.225,3.466c-.108.19.093.469.31.378a18.955,18.955,0,0,0,3.767-2.421A37.587,37.587,0,0,1,57.548,23.9a23.954,23.954,0,0,1,5.112-1.932,8.722,8.722,0,0,1,2.724-.206,7.378,7.378,0,0,1-.287.826,2.592,2.592,0,0,1-1.788,1.732.121.121,0,0,0-.088.194.11.11,0,0,0,.08.162c1.94.439,3.813-1.123,5.635-1.43a9.857,9.857,0,0,1,5.582.862c3.073,1.463,4.711,4.058,6.18,7,1.21,2.428,2.82,4.625,3.926,7.108a55.392,55.392,0,0,1,3.133,7.935.157.157,0,0,0,.191.106.261.261,0,0,0,.389-.027,9.051,9.051,0,0,0,1.574-5.289A31.379,31.379,0,0,0,89.361,34a12.309,12.309,0,0,0-2.712-5.643c-.144-.173-.3-.357-.458-.542.226.073.448.155.665.24a8.488,8.488,0,0,1,3.908,3.579c.161.235.631.161.58-.175a14.457,14.457,0,0,0-3.485-7.467c-.367-.42-.821-.947-1.339-1.46a11.968,11.968,0,0,1,5.139,2.076c.232.178.689.009.549-.332a16.1,16.1,0,0,0-4.837-6.563",
    transform: "translate(13.236 0.98)",
    fill: "#eb008b"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M88.392,46.9a.7.7,0,0,1-.423-.07.567.567,0,0,1-.478-.416,47.608,47.608,0,0,0-2.7-6.963l-.408-.914a38.2,38.2,0,0,0-2.134-3.916c-.609-1.021-1.24-2.078-1.785-3.172-1.554-3.117-3.164-5.467-5.98-6.807a9.48,9.48,0,0,0-5.235-.842l-.091.014a9.331,9.331,0,0,0-1.99.683,10.135,10.135,0,0,1-2.351.78,3.882,3.882,0,0,1-1.462-.036.539.539,0,0,1-.364-.275.5.5,0,0,1-.062-.263.573.573,0,0,1,.029-.331.554.554,0,0,1,.436-.331c.58-.09,1.055-.575,1.46-1.483.035-.079.068-.162.1-.252a8.694,8.694,0,0,0-1.439.1c-.22.033-.426.074-.6.118a23.721,23.721,0,0,0-5.019,1.9,37.456,37.456,0,0,0-4.629,2.743q-.376.269-.744.545a14.377,14.377,0,0,1-3.111,1.923.67.67,0,0,1-.806-.255.692.692,0,0,1-.039-.736c.284-.49.6-1.034.944-1.594-.155.1-.307.209-.461.313A28.139,28.139,0,0,0,46.676,29.1a19.986,19.986,0,0,0-4.9,5.769,26.691,26.691,0,0,0-2,5.482c-.159.566-.322,1.132-.495,1.7a58.041,58.041,0,0,0-1.9,7.423c-.056.338-.1.606-.426.657l-.31.047-.158-.3a28.367,28.367,0,0,1-3.055-8.044,16.735,16.735,0,0,1-.266-4.151c.009-.112.02-.222.032-.334a18.839,18.839,0,0,0-1.12,2.21.666.666,0,0,1-.518.405.755.755,0,0,1-.6-.173.683.683,0,0,1-.244-.521,18.091,18.091,0,0,1,1.7-7.246.208.208,0,0,1-.035.026,14.667,14.667,0,0,0-2.856,2.8.681.681,0,0,1-1.026.033.694.694,0,0,1-.185-.622,16.753,16.753,0,0,1,3.354-6.506c-.056.038-.114.079-.172.117A21.981,21.981,0,0,0,28.272,30.8a.759.759,0,0,1-1.149-.147.663.663,0,0,1,.024-.738c.273-.386.508-.791.757-1.217a15.8,15.8,0,0,1,.841-1.348c.029-.041.059-.082.09-.121-.231.181-.46.378-.683.569a12.553,12.553,0,0,1-1.111.885.721.721,0,0,1-1.034-.284.712.712,0,0,1,.12-.827,19.629,19.629,0,0,0,1.75-2.152,23.139,23.139,0,0,1,1.653-2.058A11.287,11.287,0,0,1,30.685,22.3c-.393.029-.788.074-1.21.141a28.887,28.887,0,0,0-3.224.733l-.079.018a.8.8,0,0,1-.827-.467.69.69,0,0,1,.193-.83c2.7-2.214,5.115-3.817,8.111-4.421a18.66,18.66,0,0,1,4.136-.392A17.431,17.431,0,0,0,35.5,16.069c-.273-.1-.552-.222-.833-.341a8.99,8.99,0,0,0-2.111-.7l-.108.02c-.067.011-.134.021-.2.035l0,0a.619.619,0,0,1-.716-.442.6.6,0,0,1,.381-.721,13.149,13.149,0,0,1,2.574-.657,25.281,25.281,0,0,1,5.037-.185,13.7,13.7,0,0,1,4.795.832c.279.115.572.253.868.408-.956-4.711.651-9.745,4.092-12.536a.827.827,0,0,1,1.094.094.665.665,0,0,1,.108.666,10.151,10.151,0,0,0,.27,6.106c.067.219.15.439.246.668A21.169,21.169,0,0,1,62.584,2.588l.056-.012A.737.737,0,0,1,63,4,5.982,5.982,0,0,0,60.07,6.313a11.686,11.686,0,0,1,1.5-.736A17.366,17.366,0,0,1,65.46,4.438,10.809,10.809,0,0,1,68.8,4.42a.7.7,0,0,1,.606.636.8.8,0,0,1-.5.823,4.589,4.589,0,0,0-1.9,1.375,19.314,19.314,0,0,1,2.688-.78c.216-.05.431-.1.65-.147.748-.173,1.525-.351,2.31-.474a8.9,8.9,0,0,1,3.617.061.818.818,0,0,1,.593.838.716.716,0,0,1-.61.7,9.984,9.984,0,0,0-2.852.912,20.024,20.024,0,0,1,3.055-.184c4.247.046,7.624,1.157,10.038,3.3a.745.745,0,0,1,.228.788.83.83,0,0,1-.668.587l-.041,0c-.263.027-.524.049-.785.067,2.2.569,4.667,1.34,6.185,3.231a.9.9,0,0,1,.129.877.75.75,0,0,1-.941.451,13.707,13.707,0,0,0-3.756-.644c.307.209.618.436.93.681a16.471,16.471,0,0,1,4.972,6.74.7.7,0,0,1-.032.619.774.774,0,0,1-.559.367.809.809,0,0,1-.619-.149,10.239,10.239,0,0,0-3.606-1.689l.36.411.032.036a14.864,14.864,0,0,1,3.583,7.683.686.686,0,0,1-.6.8.774.774,0,0,1-.76-.314,9.38,9.38,0,0,0-2.791-2.967,12.382,12.382,0,0,1,2.166,5.012,32.025,32.025,0,0,1,.559,7.044,9.5,9.5,0,0,1-1.662,5.531.668.668,0,0,1-.434.266M69.114,22.953a10.4,10.4,0,0,1,5.735.917c3.038,1.445,4.749,3.923,6.381,7.2.53,1.064,1.153,2.108,1.758,3.116a39.24,39.24,0,0,1,2.176,4l.408.912a50.308,50.308,0,0,1,2.683,6.859,8.661,8.661,0,0,0,1.374-4.883,31.436,31.436,0,0,0-.543-6.856,11.834,11.834,0,0,0-2.623-5.447c-.143-.168-.294-.351-.454-.534L85,27.066l1.474.484c.232.077.463.161.686.249a8.384,8.384,0,0,1,3.8,3.3,14.025,14.025,0,0,0-3.283-6.675l-.035-.039c-.352-.405-.792-.914-1.282-1.4l-1.008-1,1.393.272A12.856,12.856,0,0,1,91.8,24.22,15.531,15.531,0,0,0,87.253,18.2a13.99,13.99,0,0,0-2.04-1.345L83.977,16.2l1.387-.158a13.5,13.5,0,0,1,5.276.551c-1.364-1.629-3.62-2.318-5.634-2.841a17.033,17.033,0,0,0-2.525-.463L80.3,13.056l2.113-.609A13.243,13.243,0,0,1,85,12.074c.269-.018.537-.039.809-.064-2.246-1.932-5.392-2.931-9.352-2.975a14.663,14.663,0,0,0-5.042.688l-2.014.736L70.974,9a9.745,9.745,0,0,1,4.74-2.333,8.582,8.582,0,0,0-2.922.033c-.756.117-1.516.291-2.248.461-.222.05-.44.1-.656.147a15.153,15.153,0,0,0-3.814,1.313l-1.24.672.654-1.249a5.929,5.929,0,0,1,2.774-2.834,12.793,12.793,0,0,0-6.371,1.16A11.681,11.681,0,0,0,59.106,8L57.766,9.04l.68-1.553A7.81,7.81,0,0,1,61.58,3.727a19.815,19.815,0,0,0-10.351,6.655l-.417.533-.307-.6A9.178,9.178,0,0,1,49.923,8.9a11.7,11.7,0,0,1-.4-6.212c-3.166,2.8-4.544,7.936-3.275,12.389l.313,1.1-.959-.619a10.58,10.58,0,0,0-1.618-.856,12.845,12.845,0,0,0-4.508-.771,21.081,21.081,0,0,0-6.034.413A13.26,13.26,0,0,1,35,14.936c.272.114.539.228.8.329a12.614,12.614,0,0,1,3.386,1.723c.1.079.2.159.293.246l.848.753H38.927c-.194,0-.36,0-.464,0a17.054,17.054,0,0,0-4.643.337,17.036,17.036,0,0,0-7.3,3.894,27.366,27.366,0,0,1,2.829-.624c.448-.068.871-.117,1.292-.147a7.559,7.559,0,0,1,1.3.056l1.119.12-.911.657a13.4,13.4,0,0,0-1.99,1.674,22.285,22.285,0,0,0-1.586,1.982c-.26.352-.522.707-.8,1.058a5.622,5.622,0,0,1,2.481-1.439l.877-.17-.413.792a5.927,5.927,0,0,1-.8,1.1c-.168.2-.329.384-.47.583a14.429,14.429,0,0,0-.8,1.278c-.027.044-.053.088-.079.134a17.732,17.732,0,0,1,2.437-2.1c.175-.121.349-.247.525-.376a10.854,10.854,0,0,1,1.71-1.079l1.5-.706-.971,1.346c-.3.423-.613.841-.927,1.258a19.789,19.789,0,0,0-3.514,6.109,16.162,16.162,0,0,1,2.529-2.354c.234-.178.492-.351.757-.527.2-.135.4-.269.6-.413l1.392-1-.754,1.542a19.919,19.919,0,0,0-2.26,7.567,21.672,21.672,0,0,1,1.032-1.906c.111-.184.216-.382.325-.581a8.287,8.287,0,0,1,.858-1.36l1.144-1.375-.39,1.745c-.055.223-.109.446-.161.672a12.592,12.592,0,0,0-.379,2.022,15.791,15.791,0,0,0,.255,3.942A24.436,24.436,0,0,0,36.708,48.4c.228-1.128.7-3.167,1.75-6.6.173-.562.332-1.123.49-1.682a27.543,27.543,0,0,1,2.075-5.657,20.872,20.872,0,0,1,5.1-6.019,28.848,28.848,0,0,1,2.442-1.783c.316-.216.627-.426.938-.645.47-.328.941-.662,1.422-.976l2.148-1.416L51.5,25.662a27.683,27.683,0,0,0-1.926,2.961,16.349,16.349,0,0,0,2.43-1.6c.25-.185.5-.372.756-.555A38.6,38.6,0,0,1,57.5,23.666,24.435,24.435,0,0,1,62.7,21.7c.2-.05.433-.1.678-.134a9.113,9.113,0,0,1,2.192-.083l.527.056-.2.625a6.63,6.63,0,0,1-.266.75,4,4,0,0,1-1.094,1.536,8.877,8.877,0,0,0,2.286-.741,9.927,9.927,0,0,1,2.183-.739Z",
    transform: "translate(13.089 0.836)",
    fill: "#2d154a"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M55.959,17.625c-2.547.443-5.91,2.987-5.327,8.83s4.628,10.881,11.647,9.791,4.533-10.069,3.435-12.24-4.139-7.362-9.754-6.381",
    transform: "translate(26.179 9.062)",
    fill: "#ece6e2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M59.816,24.669c.76,2.462.1,4.852-1.478,5.341s-3.47-1.112-4.23-3.576-.1-4.854,1.474-5.339,3.471,1.111,4.234,3.574",
    transform: "translate(27.849 10.876)",
    fill: "#3f0f23"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M59.091,24.547c.622,2.011.085,3.964-1.2,4.36S55.054,28,54.433,25.989s-.082-3.964,1.2-4.362,2.835.909,3.457,2.92",
    transform: "translate(28.048 11.16)",
    fill: "#991c24"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M58.234,24.4c.457,1.472.059,2.9-.882,3.193s-2.078-.665-2.533-2.138-.061-2.9.882-3.195,2.076.666,2.533,2.14",
    transform: "translate(28.284 11.499)",
    fill: "#6a0d23"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M57.762,24.322c.364,1.176.049,2.322-.7,2.554s-1.662-.534-2.025-1.709-.05-2.325.7-2.557,1.662.534,2.025,1.712",
    transform: "translate(28.413 11.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(76.743 26.564)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M65.712,24.005c-1.1-2.172-4.139-7.362-9.754-6.381-2.545.443-5.91,2.985-5.327,8.83s4.628,10.881,11.649,9.791,4.533-10.07,3.433-12.24m-6.886,6.1c-6.365,1.893-6.519-2.437-6.7-4.074-.291-2.563,1.194-4.658,4.805-5.057s5.54,1.375,6.387,3.055,1.873,4.181-4.488,6.075",
    transform: "translate(-50.565 -17.502)",
    fill: "#cac0bb"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M59.494,27.461a12.407,12.407,0,0,1-7.985.968A9.3,9.3,0,0,0,61.79,33.476c5.834-.906,5.1-7.259,4.058-10.624-.6,1.3-2.3,2.911-6.355,4.609",
    transform: "translate(26.668 11.832)",
    fill: "#728ac3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M64.649,22.227c-1.547-2.381-4.36-5.368-8.738-4.6a6.669,6.669,0,0,0-5.254,5.808,7.678,7.678,0,0,1,4.326-3,12.443,12.443,0,0,1,9.666,1.792",
    transform: "translate(26.227 9.061)",
    fill: "#728ac3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(54.519 31.856)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M47.486,25.067c-.449-1.366-2.082-4.149-4.98-4.077-2.251.058-5,1.48-6.584,5.218,1.656-2.529,6.761-4.518,11.564-1.141",
    transform: "translate(-35.922 -20.989)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(53.354 41.671)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M41.648,30.253a10.023,10.023,0,0,1-6.494-1.3c.3,5.392,5.118,7.841,9.674,4.945a8.229,8.229,0,0,0,3.6-6.44,11.592,11.592,0,0,1-6.775,2.8",
    transform: "translate(-35.154 -27.456)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(78.176 34.682)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M59.494,27.461a12.407,12.407,0,0,1-7.985.968A9.3,9.3,0,0,0,61.79,33.476c5.834-.906,5.1-7.259,4.058-10.624-.6,1.3-2.3,2.911-6.355,4.609",
    transform: "translate(-51.509 -22.851)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(76.883 26.564)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M64.649,22.227c-1.547-2.381-4.36-5.368-8.738-4.6a6.669,6.669,0,0,0-5.254,5.808,7.678,7.678,0,0,1,4.326-3,12.443,12.443,0,0,1,9.666,1.792",
    transform: "translate(-50.656 -17.502)",
    fill: "#8ea2d1"
  }))))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M42.038,38.633h0a5.739,5.739,0,0,1-5.509-2.013c-.091-.115-.17-.22-.247-.332s-.164-.241-.235-.363a8.571,8.571,0,0,1-.933-5.66A16.3,16.3,0,0,1,36.2,26.184a10.034,10.034,0,0,1,2.236-3.35,7.761,7.761,0,0,1,.874-.727,6.363,6.363,0,0,1,4.063-1.216,5.67,5.67,0,0,1,3.7,1.987c1.533,1.949,1.789,5.015,1.732,7.241a9.791,9.791,0,0,1-1.46,4.89,8.056,8.056,0,0,1-2.7,2.677,7.33,7.33,0,0,1-2.6.946m.155-17.267a6.286,6.286,0,0,0-2.621,1.085,8.254,8.254,0,0,0-.839.7A9.657,9.657,0,0,0,36.6,26.351a15.9,15.9,0,0,0-1.059,3.978,8.173,8.173,0,0,0,.877,5.377c.068.109.138.219.208.32.085.118.156.219.241.323a5.313,5.313,0,0,0,5.109,1.858,6.858,6.858,0,0,0,2.448-.888,7.68,7.68,0,0,0,2.556-2.539,9.32,9.32,0,0,0,1.392-4.673c.056-2.157-.182-5.115-1.638-6.963a5.206,5.206,0,0,0-3.4-1.824,4.859,4.859,0,0,0-1.143.046",
    transform: "translate(18.12 10.808)",
    fill: "#2d154a"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M61.563,36.644c-3.385.527-7.3-1.422-9.314-4.634-.137-.232-.256-.445-.369-.66a13.317,13.317,0,0,1-1.392-4.828,9.327,9.327,0,0,1,1.689-6.746,5.918,5.918,0,0,1,3.916-2.28,8.247,8.247,0,0,1,6.475,1.868l.094.08a14.341,14.341,0,0,1,4.675,10.53l0,.187a6.51,6.51,0,0,1-.832,3.254,7.563,7.563,0,0,1-2.99,2.623,6.894,6.894,0,0,1-1.953.606m-5.4-18.723a5.487,5.487,0,0,0-3.636,2.113,8.915,8.915,0,0,0-1.607,6.447,13.094,13.094,0,0,0,1.346,4.672q.164.312.346.613c1.654,2.653,5.235,5.021,8.889,4.453a6.468,6.468,0,0,0,1.83-.569,7.172,7.172,0,0,0,2.8-2.45,6.072,6.072,0,0,0,.774-3.04V29.98a13.909,13.909,0,0,0-4.53-10.211l-.067-.061a7.836,7.836,0,0,0-6.15-1.786",
    transform: "translate(26.107 9.014)",
    fill: "#2d154a"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M55.7,6.684a.217.217,0,0,0-.012-.056c-.039.032-.076.061-.112.1.039-.014.082-.026.124-.039",
    transform: "translate(28.775 3.432)",
    fill: "#9c005d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(39.484 4.743)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M91.754,23.294l-.015-.008,0-.035c-.873-2.3-3.5-3.236-5.544-4.093a36.227,36.227,0,0,0-7.63-2.412,21,21,0,0,0-4.544-.314,33.973,33.973,0,0,0-4.092.49c-.636.1-2.923.668-3.262-.2,0-.011-.537-.155.285-.261.238-.44,1.084-.8,1.525-1.053a23.419,23.419,0,0,1,8.279-3.136c1.77-.228,3.6.175,5.412-.126a6.348,6.348,0,0,0,3.391-.814,1.189,1.189,0,0,0,.212-.114.224.224,0,0,0,.085-.111c.033-.03.073-.052.106-.082.12-.106-.044-.3-.178-.216a.578.578,0,0,0-.052.03.238.238,0,0,0-.19.008c-.442.217-1.041,0-1.5-.065a37.411,37.411,0,0,0-14.576,1.235c-.709.194-1.415.408-2.11.654a6.862,6.862,0,0,0-1.967.786c1.31-1.16,2.566-2.375,3.819-3.6a14.566,14.566,0,0,1,3.781-2.817c.836-.293,1.68-.554,2.524-.792.314-.091.164-.542-.146-.477a9.851,9.851,0,0,0-1.824.572,31.067,31.067,0,0,0-10.627,6.9c-.894.908-1.718,1.888-2.645,2.767-2.351,2.231-3.99,2.84-3.6.8a28.715,28.715,0,0,1,3.057-4.55C61.1,10.9,62.613,9.683,64.064,8.4c1.328-1.173,2.507-2.823,4.063-3.691a.187.187,0,0,0,.077-.049c.018-.011.035-.024.055-.035.235-.12.018-.46-.214-.346l-.02.012c-.861.416-1.961.495-2.862.9a20.94,20.94,0,0,0-2.691,1.448,30.337,30.337,0,0,0-4.913,3.928c-.841.821-1.644,1.683-2.409,2.576-1.061,1.238-2.026,2.556-3.105,3.778-.111.127-1.5,1.75-1.6.912-.314-2.457,1.8-5,3.208-6.793a23.394,23.394,0,0,1,2.878-2.913c.527-.467,1.061-.927,1.569-1.408.121-.117,1.062-1.029.724-1.059.654-.662,2.424-1.472,2.4-2.536a21.469,21.469,0,0,0-5.432,3.8,30.682,30.682,0,0,0-4.708,4.933,17.71,17.71,0,0,0-2.456,4.628c-.067.178-.845,1.654-.82,1.692-1.161-1.984.669-5.288,1.694-6.977a9.629,9.629,0,0,0,.763-1.307c.681-1.68-1.407-.129-1.818.266a11.458,11.458,0,0,0-2.516,3.6,6.769,6.769,0,0,0-.527,4.023,17.272,17.272,0,0,0-4.9-2.428,28.334,28.334,0,0,0-7.446-1.867c-.017,0-.02.02-.012.03a1.508,1.508,0,0,0,.212.179.087.087,0,0,0,.052.07,17.524,17.524,0,0,1,3.318,1.962c.373.291.735.6,1.093.912a2.245,2.245,0,0,0-.528.093,1.344,1.344,0,0,0-.563.114,15.312,15.312,0,0,1,6.168,1.516c3.885,1.767-1.446.5-4.706,1.185a21.629,21.629,0,0,0-10.3,5.608c-.762.706-.908,1.178-1.773,1.909,1.888-.246,4.883-2.9,6.472-3.773a23.2,23.2,0,0,1,5.327-2.395c1.029-.263,4.3-.335,2.12,1.153-.41.281-.877.481-1.278.773-.053.027-.106.053-.155.08a.094.094,0,0,0-.046.073l-.014.009c-.09.08.03.211.124.158a1.132,1.132,0,0,1,.127-.068c.41-.223,1.625-.452,1.953-.018.525.7-.742,1.333-1.178,1.581a17.96,17.96,0,0,0-3.65,2.481c-.642.624-1.751,1.5-2,2.4a23.291,23.291,0,0,1,3.674-3.184,7.028,7.028,0,0,1,2.893-1.639c1.018-.185,2.321.467,1.29,1.571a13.109,13.109,0,0,1-2.313,1.513c-.288.2-3.916,3.208-3.215,2.828.469-.255,3.181-2.214,3.533-2.437a2.814,2.814,0,0,1,1.245-.454c1.348-.127-1.194,3.618-1.446,4.007a17.879,17.879,0,0,0-1.683,3.4,10.645,10.645,0,0,1-1.5,3.407c-.908,1.035-2.19-.282-2.466-1.108a3.741,3.741,0,0,1,.1-2.4.271.271,0,0,0-.14-.335.168.168,0,0,0-.275-.046c-1.381,1.786-.739,4.678-.422,6.705.05.325.566.31.516-.023-.012-.076-.024-.149-.035-.225a12.158,12.158,0,0,1,1.56.3,5.613,5.613,0,0,1,1.817,1.536,1.46,1.46,0,0,0,.671.527l.006-.012a10.669,10.669,0,0,0,.633-1.2c.44-1.369.68-2.893,1.126-4.225a37.087,37.087,0,0,1,1.472-4.474c1.314-2.691,3.715-4.38,5.937-6.283a.537.537,0,0,1,.178-.1.458.458,0,0,1,.278-.246,1.715,1.715,0,0,0,.276-.134,3.922,3.922,0,0,1,1.187-.965.532.532,0,0,1,.552.894c-.041.032-.079.065-.118.1a6.461,6.461,0,0,0-.4,1.214,3.45,3.45,0,0,0-.015.376.689.689,0,0,0,.087.126c2.041-.941,3.7-2.51,5.681-3.6a42.839,42.839,0,0,1,6.456-3.023.521.521,0,0,1,.338-.011c.041-.02.077-.041.117-.061a5.827,5.827,0,0,1,3.034-.851.535.535,0,0,1,.366.838A6.041,6.041,0,0,1,62.878,23.8a2.255,2.255,0,0,0,1.094.31c1.348-.261,2.659-.7,3.99-1.037a8.5,8.5,0,0,1,.83-.244,6.046,6.046,0,0,1,1.615-.208,6.123,6.123,0,0,1,2.19.232,4.257,4.257,0,0,1,1.081.22c1.827.671,2.627,1.774,4.03,3.043A14.151,14.151,0,0,1,80.561,30.3c.914,1.818,1.806,4.371,3.309,5.8a.364.364,0,0,0,.15-.083,12.649,12.649,0,0,1,3.192-2.6c.994-.548,1.826-1.289,1.46-2.541-.109-.384-.751-2.286-1.357-2.14-.42.1-.216,2.044-.671,2.492-1.017.993-2.861.115-3.744-.627a11.234,11.234,0,0,1-2.513-3.286c-.2-.357-1.683-3.788-1.641-3.794,2.023-.284,4.125,1.276,5.614,2.319a22.354,22.354,0,0,1,2.368,2.116c-.106.156.381-.127.549-.2.483-.206.786.32,1,.6a5.139,5.139,0,0,0,.8.938.163.163,0,0,0,.223-.237c-.012-.011-.021-.024-.032-.035a4.739,4.739,0,0,1,1.106,1.518c.064.168.361.143.329-.058a5.031,5.031,0,0,0-1.544-2.345A18.216,18.216,0,0,0,85.739,25.1a21.521,21.521,0,0,0-8.147-3.816c-1.213-.211-2.444-.191-3.644-.472-.894-.209-2.826-1.442-1.562-2.421.861-.668,2.658-.46,3.674-.43a16.649,16.649,0,0,1,8.3,2.6,28.566,28.566,0,0,0,7.27,3.076c.2.05.32-.263.126-.345",
    transform: "translate(-26.015 -3.125)",
    fill: "#9c005d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(50.908 13.53)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M84.047,31.7a2.263,2.263,0,0,0-2.354-1.972c-1.281-.082-2.163.285-3.334-.609a8.381,8.381,0,0,1-2.107-3.3c-1.176-2.6-2.844-5.1-5.364-6.258a4.111,4.111,0,0,1,.423-.046c.757-.036,1.5.193,2.252.156.153-.006.226-.243.071-.31a5.61,5.61,0,0,0-3.466-.272.191.191,0,0,0-.07-.036c-.516-.14-.943-.4-1.474-.511a6.332,6.332,0,0,0-1.387-.058,11.091,11.091,0,0,0-2.9.475,3.285,3.285,0,0,1-1.263.172c-.988-.1-.222-1.143.115-1.46a6.187,6.187,0,0,1,2.3-1.3c.313-.1.244-.625-.1-.583-.023,0-.049.009-.074.014-1.539.232-3.756,1.762-5.151.64-.633-.51,1.293-1.835,2.017-2.389.021-.014.042-.026.062-.041a.122.122,0,0,0,.052-.049l.1-.083c.127-.123-.044-.319-.191-.234l-.1.058a32.28,32.28,0,0,0-5.5,3.69A18.975,18.975,0,0,1,54.1,18.914c-.385.2-2.509,1-1.537-.038,1.415-1.518,3.435-2.554,5.059-3.828a31.259,31.259,0,0,0,4.984-5.3.237.237,0,0,0-.343-.326,75.51,75.51,0,0,1-6.783,5.875c-.933.653-1.874,1.325-2.856,1.9a3.959,3.959,0,0,1-.651.3c-.648.249-.867-.4-.531-.864a6.905,6.905,0,0,0,.627-.88.211.211,0,0,0-.118-.3c.407-.768.824-1.528,1.275-2.277a16.1,16.1,0,0,1,1.534-2.319,7.435,7.435,0,0,0,1.323-1.6.242.242,0,0,0-.34-.316c-2.186,1.2-3.372,3.636-4.875,5.523A10.531,10.531,0,0,1,48,17.085c-1,.572-2.481.486-2.6-.911a1.282,1.282,0,0,1,0-.187,4.909,4.909,0,0,0,.164-.463.131.131,0,0,0-.046-.146c.156-.489.419-.985.542-1.428a.13.13,0,0,0-.24-.091,7.238,7.238,0,0,0-.892,2.274,1.637,1.637,0,0,1-.756.8c-.42.167-.681-.505-.765-.783a6.09,6.09,0,0,1-.118-1.469c-.006-.158-.255-.19-.281-.026s-.049.348-.062.549c-.243.305-.41.639-.873.555A2.766,2.766,0,0,1,41,15.067c-.065-.05-.194,0-.153.1.017.039.039.082.061.123a.108.108,0,0,0-.011.088A14.044,14.044,0,0,0,42,17.66a7.212,7.212,0,0,1,.416.9c-.012-.011-.03-.023-.042-.035a4.181,4.181,0,0,0-2.107-.939c-.024-.018-.049-.038-.073-.055a.092.092,0,0,0-.131.061l0,.012v0a.084.084,0,0,0,.044.127.129.129,0,0,1,.036.012c.173.216.346.428.508.651a2.056,2.056,0,0,1,.267.495.319.319,0,0,1-.067.329,9.6,9.6,0,0,0-1.219-.112.073.073,0,0,0-.032.137,10.666,10.666,0,0,0,1.876.6,3.476,3.476,0,0,1,1.05.5.776.776,0,0,1,.263.346,7.219,7.219,0,0,0-2.768.146.1.1,0,0,0-.042.17c-.059.05-.083.144.009.178.537.2,1.1.328,1.645.507a4.859,4.859,0,0,1,.961.439c.208.121.375.285.569.42a15.908,15.908,0,0,0-6.948,6.488c-1.8,2.9-3.462,7.487-2.272,10.876a.174.174,0,0,0,.216.1,3.9,3.9,0,0,1,.2-1.958,37.944,37.944,0,0,1,1.383-4.237c1.235-3.213,2.662-6.859,5.746-8.6A5.693,5.693,0,0,1,43.459,23.8a25.717,25.717,0,0,1,2.5-1.72c.352-.187.586.31.341.555a5.05,5.05,0,0,0-.8,1.144,10.176,10.176,0,0,0-.65,1.135c-.29.733.912.064,1.173-.1a.276.276,0,0,1,.175-.041c3.161-1.985,6.048-4.31,9.621-5.611a17.891,17.891,0,0,1,2.82-.862.258.258,0,0,1,.26-.208c.539-.02,1.3-.422,1.792-.049.565.428.32,1.1-.082,1.55a4.915,4.915,0,0,1-.61.554c-.15.144-.308.288-.466.422-.062.068-.143.158-.223.256a.836.836,0,0,0,.426.607,6.413,6.413,0,0,0,.883-.26.25.25,0,0,1,.09-.03c.041-.017.083-.03.12-.044a.323.323,0,0,1,.179-.014c1.431-.222,2.856-.964,4.315-1.193a11.552,11.552,0,0,1,3.249-.161,6.243,6.243,0,0,1,2.533.892c.077.036.156.07.231.109.039.023.071.047.111.071A5.565,5.565,0,0,1,73.581,22.7,13.076,13.076,0,0,1,75.7,25.665a46.365,46.365,0,0,0,4.75,7.692,7.478,7.478,0,0,0,.836-.206A16.02,16.02,0,0,0,83.8,32.5a.543.543,0,0,0,.25-.692.445.445,0,0,0,0-.1",
    transform: "translate(-33.542 -8.914)",
    fill: "#81004b"
  }))))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M41.582,3.194C39.9,4.642,39.028,7.667,39.12,9.816c0,.1.165.12.176.017a14.323,14.323,0,0,1,.929-3.691c.4-.993,1.193-1.867,1.489-2.879.024-.08-.079-.114-.132-.068",
    transform: "translate(20.25 1.643)",
    fill: "#eda5c5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M50.578,3.891a5.361,5.361,0,0,0-2,.908,15.886,15.886,0,0,0-2.686,1.911,16.275,16.275,0,0,0-4.072,5.075c-.065.135.123.287.222.158.278-.363.549-.724.826-1.084a16.745,16.745,0,0,0-2.377,4.849.136.136,0,0,0,.252.094,24.952,24.952,0,0,1,3.882-6.535c.141-.173-.1-.4-.252-.24-.181.188-.354.387-.525.583a21.633,21.633,0,0,1,2.135-2.319,17.106,17.106,0,0,1,2.53-1.9,19.509,19.509,0,0,0,2.169-1.273c.1-.082.006-.237-.1-.231",
    transform: "translate(20.96 2.015)",
    fill: "#eda5c5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M55.3,4.174a16.2,16.2,0,0,0-10.46,6.991c-.082.137.117.273.222.162A27.874,27.874,0,0,1,49.712,7.09a35.608,35.608,0,0,1,5.664-2.661.133.133,0,0,0-.077-.255",
    transform: "translate(23.204 2.16)",
    fill: "#eda5c5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M61.952,5.1c-4.23.51-8.633,2.371-11.38,5.7a.145.145,0,0,0-.24-.059,29.4,29.4,0,0,0-3.558,5.11c-.1.17.152.287.258.137.715-1,1.418-2.016,2.12-3.031-.036.068-.077.135-.112.2a.172.172,0,0,0,.3.161,17.585,17.585,0,0,1,5.192-5.3c2.339-1.446,4.958-1.717,7.457-2.689.118-.047.1-.25-.041-.234",
    transform: "translate(24.205 2.639)",
    fill: "#eda5c5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M68.729,8.157a12.635,12.635,0,0,0-5.2-1.289,17.3,17.3,0,0,0-5.743.263c-.152.038-.1.263.046.261,1.6,0,3.175-.138,4.769-.1A15.993,15.993,0,0,0,54.14,9.752c-.114.073-.032.278.1.22a34.489,34.489,0,0,1,4.348-1.6A30.984,30.984,0,0,1,63.5,7.683a.176.176,0,0,0,.059-.335,32.044,32.044,0,0,1,5.069,1.07.141.141,0,0,0,.1-.261",
    transform: "translate(28.002 3.497)",
    fill: "#eda5c5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M71.424,11.721a6.419,6.419,0,0,0-2.576-1.185,18.913,18.913,0,0,0-3.082-.871,16.246,16.246,0,0,0-6.381.173c-.178.042-.114.294.049.3,2.236.067,4.377-.322,6.607.1a19.161,19.161,0,0,1,2.988.892,5.233,5.233,0,0,0,2.378.677c.038-.006.038-.056.017-.08",
    transform: "translate(30.69 4.88)",
    fill: "#eda5c5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M66.634,12.183A18.378,18.378,0,0,0,60,10.946a.149.149,0,0,0-.024.293,44,44,0,0,1,6.17,1.269,11.986,11.986,0,0,1,3.249,1.677,7.536,7.536,0,0,1,.982.87c.279.29.372.593.71.769.085.046.212-.039.172-.143-.712-1.771-2.97-2.841-4.621-3.5",
    transform: "translate(30.991 5.667)",
    fill: "#eda5c5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M70.319,18.46A16.292,16.292,0,0,0,66.7,15.607a18.442,18.442,0,0,0-4.113-1.779,11.776,11.776,0,0,0-4.423-.678.155.155,0,0,0-.029.305c1.207.307,2.471.376,3.687.672a18.737,18.737,0,0,1,4.071,1.542,13.675,13.675,0,0,1,6.4,6.279.124.124,0,0,0,.237-.073,7.752,7.752,0,0,0-2.211-3.415",
    transform: "translate(30.038 6.792)",
    fill: "#eda5c5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M47.942,6.632a21.354,21.354,0,0,0-5.274,7.624.1.1,0,0,0,.184.1c.744-1.222,1.434-2.474,2.231-3.664C46,9.315,47.106,8.1,48.147,6.828a.142.142,0,0,0-.2-.2",
    transform: "translate(22.085 3.414)",
    fill: "#eda5c5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M47.4,7.951a35.464,35.464,0,0,0-3.292,3.309c-.082.087.044.2.132.124,1.16-1.023,2.2-2.166,3.359-3.189.134-.118-.059-.357-.2-.244",
    transform: "translate(22.821 4.102)",
    fill: "#eda5c5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M55.851,6.973A19.081,19.081,0,0,0,48.008,13.9c-.061.1.1.209.167.12a27.835,27.835,0,0,1,7.838-6.783c.179-.1.014-.343-.161-.263",
    transform: "translate(24.848 3.602)",
    fill: "#eda5c5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M65.594,12.353c-2.7-1.374-6.464-1.3-9.331-.525a.061.061,0,0,0,.023.118,40.908,40.908,0,0,1,4.458-.22,19.05,19.05,0,0,1,4.749.9.148.148,0,0,0,.1-.275",
    transform: "translate(29.108 5.837)",
    fill: "#eda5c5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M67.436,11.141a12.8,12.8,0,0,0-5.79-1.028c-.087.009-.111.149-.015.159,1.958.194,3.779.829,5.707,1.131.15.023.255-.2.1-.263",
    transform: "translate(31.876 5.213)",
    fill: "#eda5c5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M66.911,16.4a13.974,13.974,0,0,0-4.048-1.9,26.012,26.012,0,0,0-5.265-.844.112.112,0,0,0-.049.219c1.472.416,3.026.42,4.517.836a32.768,32.768,0,0,1,4.69,1.911c.131.061.285-.12.155-.217",
    transform: "translate(29.751 7.07)",
    fill: "#eda5c5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M69.179,20.111a15.3,15.3,0,0,0-7.293-5.128c-.106-.036-.168.138-.067.185a21.214,21.214,0,0,1,3.9,2.176,38.217,38.217,0,0,1,3.163,3.011c.155.15.442-.07.3-.244",
    transform: "translate(31.979 7.755)",
    fill: "#eda5c5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M40.882,4.575a12.3,12.3,0,0,0-1.038,5.119.115.115,0,0,0,.229-.008,15.68,15.68,0,0,1,1.034-5.03c.042-.127-.175-.209-.225-.082",
    transform: "translate(20.625 2.336)",
    fill: "#eda5c5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M41.037,3.557a9.524,9.524,0,0,0-.206,3.762c.02.167.276.161.266-.011a19.865,19.865,0,0,1,.161-3.7.113.113,0,0,0-.22-.05",
    transform: "translate(21.091 1.798)",
    fill: "#eda5c5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M37.046,19.788c-1.548.39-2.869,2.307-3.755,3.53a9.065,9.065,0,0,0-1.821,4.761c-.011.19.29.208.329.026a12.9,12.9,0,0,1,1.894-4.5,11.591,11.591,0,0,1,3.473-3.556c.149-.083.035-.305-.12-.264",
    transform: "translate(16.293 10.242)",
    fill: "#eda5c5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M36.68,18.577c-2.973,1.518-5.922,4.64-6.628,7.991-.017.074.094.12.126.047a20.788,20.788,0,0,1,2.641-4.506,16.506,16.506,0,0,1,3.963-3.369c.1-.067.006-.217-.1-.162",
    transform: "translate(15.558 9.612)",
    fill: "#eda5c5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M38.718,16.525a9.48,9.48,0,0,0-3.013,1.061c.193-.12.384-.244.577-.367.112-.074.035-.273-.1-.22A15.083,15.083,0,0,0,32,19.678c-1.41,1.225-2.189,2.793-3.342,4.216a.068.068,0,0,0,.1.094c1.173-1.032,1.879-2.485,3-3.586A14.569,14.569,0,0,1,34.2,18.528a13.932,13.932,0,0,0-4.172,4.711c-.08.161.147.34.266.191a26.139,26.139,0,0,1,3.448-3.82,17.73,17.73,0,0,1,5.019-2.835c.124-.053.111-.275-.044-.25",
    transform: "translate(14.831 8.555)",
    fill: "#eda5c5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M35.924,15.494a10.727,10.727,0,0,0-6.947,3.966.109.109,0,0,0,.159.147c1.97-2,4.245-2.917,6.834-3.838.144-.05.12-.293-.047-.275",
    transform: "translate(14.989 8.022)",
    fill: "#eda5c5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M41,13.826a13.476,13.476,0,0,0-8.252-.947.117.117,0,0,0,.038.229,19.6,19.6,0,0,1,4.26.008,13.616,13.616,0,0,1,1.9.511,18.622,18.622,0,0,0-11.366,1.638c-.1.052-.021.222.082.182a24.237,24.237,0,0,1,11.683-1.38.194.194,0,0,0,.206-.25,9.834,9.834,0,0,0,1.334.328c.181.027.308-.246.117-.319",
    transform: "translate(14.256 6.512)",
    fill: "#eda5c5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M35.54,13.6a21.337,21.337,0,0,0-5.5.867c-.126.032-.093.246.039.228,1.824-.249,3.644-.48,5.473-.694a.2.2,0,0,0-.017-.4",
    transform: "translate(15.514 7.04)",
    fill: "#eda5c5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M41.175,12.99a4.688,4.688,0,0,0-.6-.566.173.173,0,0,0,.087-.288c-1.729-1.726-5.056-2.926-7.455-2.155a.114.114,0,0,0,.038.223,15.563,15.563,0,0,1,3.64.436,9.716,9.716,0,0,1,1.993.851,13.726,13.726,0,0,0-3.389-.722.1.1,0,0,0-.042.2c.885.252,1.788.439,2.664.727a11.466,11.466,0,0,1,2.849,1.592c.185.124.34-.152.216-.3",
    transform: "translate(17.152 5.044)",
    fill: "#eda5c5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M36.563,15.484a14.905,14.905,0,0,0-5.477,2.2.153.153,0,0,0,.161.26,42.286,42.286,0,0,1,5.38-2.246.11.11,0,0,0-.064-.209",
    transform: "translate(16.058 8.015)",
    fill: "#eda5c5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M37.564,18.4a15.4,15.4,0,0,0-6.522,5.956c-.094.162.158.352.275.2a21.785,21.785,0,0,1,6.411-5.886c.176-.106.012-.355-.164-.267",
    transform: "translate(16.061 9.518)",
    fill: "#eda5c5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M34.827,21.624a10.726,10.726,0,0,0-3.2,6.4c-.012.153.228.162.264.023a13.277,13.277,0,0,1,3.127-6.238c.12-.124-.074-.305-.193-.182",
    transform: "translate(16.375 11.175)",
    fill: "#eda5c5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M34.078,23.1a8.779,8.779,0,0,0-1.688,5.046c.008.111.187.14.2.018a12.764,12.764,0,0,1,1.7-4.946c.082-.14-.135-.253-.22-.118",
    transform: "translate(16.763 11.928)",
    fill: "#eda5c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(39.915 3.34)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(24.422 2.421)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M58.294,3.866c-2.97-.511-6.525,1.85-8.848,3.466a22.62,22.62,0,0,0-7.019,7.945c-.17.323.308.694.536.387,3.913-5.294,8.672-9.88,15.353-11.234a.294.294,0,0,0-.021-.565",
    transform: "translate(-42.391 -3.795)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(29.561 4.209)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M61.97,4.974A18.941,18.941,0,0,0,45.808,16.585a.347.347,0,0,0,.612.326,28.852,28.852,0,0,1,6.144-7.434A18.981,18.981,0,0,1,62,5.732c.475-.062.469-.786-.03-.757",
    transform: "translate(-45.777 -4.974)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(20.271 1.49)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M52.923,3.188c-3.31.654-6.376,3.558-8.643,5.927a16.832,16.832,0,0,0-4.617,8.6.391.391,0,0,0,.762.17A23.173,23.173,0,0,1,45,9.8a28.288,28.288,0,0,1,8.173-6.048c.337-.173.067-.622-.252-.56",
    transform: "translate(-39.656 -3.182)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(2.748 19.343)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M42.239,15.224c-4.955-1.119-11.262,1.223-14.089,5.429-.162.241.217.5.4.293A14.867,14.867,0,0,1,35.019,16.8c2.359-.786,4.723-.663,7.153-.85a.368.368,0,0,0,.067-.724",
    transform: "translate(-28.109 -14.945)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(0 15.322)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M45.26,14.238c-5.168-3.169-14.839-2.5-18.864,2.321-.282.337.1.871.5.615a19.648,19.648,0,0,1,8.961-3.416c3.175-.328,6.123.405,9.187,1.068a.317.317,0,0,0,.217-.587",
    transform: "translate(-26.299 -12.296)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(7.952 10.919)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M43.186,11.857c-2.709-2.706-8.038-2.917-11.5-1.9a.21.21,0,0,0,.068.41,27.078,27.078,0,0,1,6.018.281c1.818.329,3.36,1.276,5.089,1.829.361.115.568-.381.329-.619",
    transform: "translate(-31.539 -9.395)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(18.62)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M42.717,2.273c-3.172,2.6-5.1,8.772-3.667,12.681.1.281.587.323.63-.024.276-2.085.077-4.148.542-6.232a17.531,17.531,0,0,1,2.993-6.066c.214-.314-.253-.557-.5-.358",
    transform: "translate(-38.568 -2.2)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(40.424 12.01)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M67.2,10.853C62.873,9.7,56.674,9.6,53.082,12.685a.524.524,0,0,0,.531.856A20.508,20.508,0,0,1,66.3,12.01a14.983,14.983,0,0,1,10.7,7.539.361.361,0,0,0,.65-.293c-1.305-4.729-6.039-7.227-10.456-8.4",
    transform: "translate(-52.934 -10.113)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(47.149 16.522)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M67.686,15.985a15.135,15.135,0,0,0-4.052-2.195,28.728,28.728,0,0,0-5.956-.7c-.261-.024-.458.338-.175.469a10.768,10.768,0,0,0,3.348.677,11.817,11.817,0,0,1,4.656,1.724,20.59,20.59,0,0,1,6.657,6.564c.25.373,1,.247.915-.278-.452-2.686-3.3-4.8-5.394-6.259",
    transform: "translate(-57.365 -13.086)",
    fill: "#ed4096"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(4.319 23.69)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M38.919,17.809c-2.356.042-4.691,2.536-6.119,4.2a16.324,16.324,0,0,0-3.65,7.847c-.067.4.545.686.713.263,1.982-5.036,4.159-9.31,9.173-11.914.2-.1.083-.395-.117-.392",
    transform: "translate(-29.145 -17.809)",
    fill: "#ed4096"
  })))))))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M71.837,21.259a16.082,16.082,0,0,0-7.628-4.842c-2.946-1-6.765-1.92-9.721-.549-.278.129-.055.5.2.454a14.22,14.22,0,0,1,4.832-.3,27.126,27.126,0,0,1,4.221.926,21.483,21.483,0,0,1,7.841,4.515c.132.114.375-.052.252-.2",
    transform: "translate(28.143 7.856)",
    fill: "#2d154a"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M70.066,7.025c-3.65,2.891-6.9,6.3-10.421,9.348-1.893,1.636-3.84,3.208-5.852,4.7a31.468,31.468,0,0,1-2.761,1.859,14.859,14.859,0,0,0,1.877-2.29c1.289-1.859,2.407-3.835,3.673-5.711A35.774,35.774,0,0,1,61.717,8.69,12.838,12.838,0,0,1,65.3,6.283a25.131,25.131,0,0,1,3.79-1.1.185.185,0,0,0-.059-.361c-5.163.381-8.806,4.169-11.655,8.141-1.375,1.908-2.623,3.885-3.813,5.91a14.677,14.677,0,0,1-3.878,4.741c-.449.2-.9.4-1.342.61a3.844,3.844,0,0,0-.539-.879,21.782,21.782,0,0,1,.486-4.8,20.556,20.556,0,0,1,2.066-5.141,21.788,21.788,0,0,1,3.3-4.45,29.54,29.54,0,0,1,4.017-3.225c.146-.111.056-.381-.137-.308-3.336,1.232-5.96,4.75-7.652,7.727-1.572,2.762-2.913,6.466-2.5,9.759-.03-.026-.056-.055-.085-.08a.178.178,0,0,0,.02-.061,4.518,4.518,0,0,0-.493-2.05,10.03,10.03,0,0,1-.246-6.561c.688-2.113,2.041-3.879,3.075-5.817.091-.17-.158-.363-.278-.2-2.234,2.973-4.574,7.108-3.661,10.909a10.554,10.554,0,0,0-2.038-1.855,7.743,7.743,0,0,0-3.43-1c-.566-.074-1.129-.152-1.688-.273-.369-.08-.715-.358-1.09-.263a.027.027,0,0,0-.014.027c.1.549,1.106.644,1.542.735,1.068.226,2.157.313,3.212.619a6.7,6.7,0,0,1,3.16,2.494,14.956,14.956,0,0,1,1.545,3,6.107,6.107,0,0,0-1.123-.612c-1.594-2.911-5.512-3.06-8.384-2.469a18.813,18.813,0,0,0-9.191,4.795c-.123.126.056.363.2.249A22.366,22.366,0,0,1,36.6,20.227a11.49,11.49,0,0,1,5.015-.331,6.369,6.369,0,0,1,3.21,1.7A11.347,11.347,0,0,0,41.9,21.2a17.6,17.6,0,0,0-4.869.672,19.733,19.733,0,0,0-5.924,3.394.125.125,0,0,0,.131.212c1.832-.836,3.368-2.167,5.265-2.89a14.662,14.662,0,0,1,4.45-.768,10.672,10.672,0,0,1,4.288.569,4.656,4.656,0,0,1,1.832,1.234c-1.976-1.037-4.8-.706-6.755-.2a15.654,15.654,0,0,0-8.672,6.082c-.085.117.1.237.2.144a33.1,33.1,0,0,1,3.784-3.506,14.438,14.438,0,0,1,4.3-2.019,12.527,12.527,0,0,1,4.169-.565,6.048,6.048,0,0,1,2.331.587c-2.682-.293-5.573,1.091-7.74,2.442a20.723,20.723,0,0,0-3.755,3.037,17.875,17.875,0,0,0-2.714,4.38c-.05.093.08.193.152.111.99-1.16,1.41-2.645,2.463-3.776a20.339,20.339,0,0,1,3.555-2.967,14.433,14.433,0,0,1,9.024-2.614.242.242,0,0,0,.269.352c.111-.026.225-.064.335-.1.093.181.179.364.263.555s.419.184.395-.064a4.219,4.219,0,0,0-.114-.656,19.891,19.891,0,0,0,4.889-2.812c1.953-1.425,3.831-2.952,5.673-4.514A120.01,120.01,0,0,0,70.208,7.206c.085-.094-.036-.264-.143-.181",
    transform: "translate(14.587 2.497)",
    fill: "#2d154a"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M75.361,12.6a26.586,26.586,0,0,0-13.236-.709,29.482,29.482,0,0,0-5.35,1.808c.483-.307.968-.613,1.462-.9a25.776,25.776,0,0,1,6.977-2.946,18.784,18.784,0,0,1,4.039-.513c1.179-.033,2.345.411,3.521.222a.347.347,0,1,0-.114-.681c-1.216.241-2.542-.223-3.787-.182a19.311,19.311,0,0,0-3.512.474,24.733,24.733,0,0,0-6.845,2.8A55.328,55.328,0,0,0,53.4,15.352a12.864,12.864,0,0,0-2.943,2.154c-.464.337-.932.675-1.4,1.008a25.868,25.868,0,0,0-3.046,2.157.1.1,0,0,0,.1.156,13.18,13.18,0,0,0,2.908-1.733c.463-.316.92-.636,1.377-.958a.216.216,0,0,0,.146-.038,37.128,37.128,0,0,1,4.924-3.158A31.369,31.369,0,0,1,61.91,12.52a20.1,20.1,0,0,1,7.1-.581c2.11.214,4.151.864,6.253,1.076a.211.211,0,0,0,.094-.411",
    transform: "translate(23.805 4.502)",
    fill: "#2d154a"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M74.463,17.2a11.7,11.7,0,0,1-2.621-1.887A9.686,9.686,0,0,0,69.1,13.844,17.636,17.636,0,0,0,62.378,12.7a16.546,16.546,0,0,0-6.444,1.574,12.07,12.07,0,0,0-2.773,1.751c-.961.81-1.665,1.883-2.692,2.626-.325.234,0,.769.325.531a14.1,14.1,0,0,0,2.049-1.965,10.863,10.863,0,0,1,2.77-2.081A15.907,15.907,0,0,1,62.4,13.319a16.757,16.757,0,0,1,7.108,1.333c1.777.724,2.982,2.39,4.8,2.967a.227.227,0,0,0,.156-.42",
    transform: "translate(26.059 6.571)",
    fill: "#2d154a"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M33.714,28.012c-3.008-1.378-4.412,2.26-4.4,4.593.006,2.228,1.246,5.714,3.649,6.379a2.511,2.511,0,0,0,1.677-.1,41.491,41.491,0,0,1,1.425-8.64,6.143,6.143,0,0,0-2.348-2.231",
    transform: "translate(15.175 14.346)",
    fill: "#8ea2d1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M34.264,39.625h0a3,3,0,0,1-1.272-.08c-2.689-.744-3.957-4.491-3.966-6.79,0-1.994.971-4.955,3.161-5.3a3.219,3.219,0,0,1,1.853.311,6.587,6.587,0,0,1,2.525,2.38l.106.162-.046.185a40.724,40.724,0,0,0-1.411,8.554l-.011.27-.252.1a2.8,2.8,0,0,1-.689.2M32.319,28.307c-1.668.26-2.436,2.8-2.433,4.445.009,2.116,1.172,5.364,3.334,5.963a2.12,2.12,0,0,0,1.147.006,41.8,41.8,0,0,1,1.375-8.247,5.389,5.389,0,0,0-2.061-1.926,2.41,2.41,0,0,0-1.363-.241",
    transform: "translate(15.028 14.2)",
    fill: "#2d154a"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M71.925,25.978c-.732-2.72-3.544-4.634-6.194-2.928a4.455,4.455,0,0,0-1.709,2.661c.962,2.111,1.814,4.277,2.68,6.438.288.729.555,1.468.788,2.216a3.94,3.94,0,0,0,2.3-.977,7.617,7.617,0,0,0,2.132-7.41",
    transform: "translate(33.146 11.6)",
    fill: "#8ea2d1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M68.024,34.9c-.117.018-.232.03-.348.039l-.341.023-.1-.326c-.217-.7-.478-1.434-.777-2.179l-.3-.742c-.751-1.879-1.527-3.82-2.375-5.682l-.065-.144.044-.152a4.791,4.791,0,0,1,1.887-2.9,4.408,4.408,0,0,1,1.712-.668,4.818,4.818,0,0,1,5.131,3.846,8.034,8.034,0,0,1-2.266,7.847A4.421,4.421,0,0,1,68.024,34.9m-3.386-9.078c.829,1.833,1.589,3.734,2.324,5.573l.3.741c.258.647.49,1.286.692,1.9a3.6,3.6,0,0,0,1.717-.833,7.13,7.13,0,0,0,2-6.972A3.967,3.967,0,0,0,67.5,23.017a3.539,3.539,0,0,0-1.375.54,3.864,3.864,0,0,0-1.483,2.267",
    transform: "translate(32.99 11.453)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(44.486 42.056)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M33.714,28.012c-3.008-1.378-4.412,2.26-4.4,4.593.006,2.228,1.246,5.714,3.649,6.379a2.511,2.511,0,0,0,1.677-.1,41.491,41.491,0,0,1,1.425-8.64,6.143,6.143,0,0,0-2.348-2.231",
    transform: "translate(-29.311 -27.71)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(97.168 34.004)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M71.925,25.978c-.732-2.72-3.544-4.634-6.194-2.928a4.455,4.455,0,0,0-1.709,2.661c.962,2.111,1.814,4.277,2.68,6.438.288.729.555,1.468.788,2.216a3.94,3.94,0,0,0,2.3-.977,7.617,7.617,0,0,0,2.132-7.41",
    transform: "translate(-64.022 -22.404)",
    fill: "#8ea2d1"
  }))))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M68.3,24.451a2.448,2.448,0,0,0-.275.117c-.08.042-.181.088-.287.155a3.388,3.388,0,0,0-.334.229,3.245,3.245,0,0,0-.331.319,3.735,3.735,0,0,0-.3.395,3.417,3.417,0,0,0-.231.48c-.03.085-.068.165-.1.256l-.074.273a3.8,3.8,0,0,0-.118.562,4.557,4.557,0,0,0-.079.568c-.023.187-.049.37-.053.546s-.021.346-.036.5-.014.3-.026.433-.017.244-.026.34c-.02.19-.038.3-.038.3s-.053-.1-.132-.273c-.036-.09-.085-.2-.129-.323a3.182,3.182,0,0,1-.143-.426c-.039-.161-.079-.334-.109-.522a2.694,2.694,0,0,1-.065-.6,3.259,3.259,0,0,1,.006-.654,3.549,3.549,0,0,1,.117-.678l.1-.337a3.24,3.24,0,0,1,.149-.322,2.746,2.746,0,0,1,.381-.581,2.4,2.4,0,0,1,.49-.431,2.348,2.348,0,0,1,.511-.264,2.256,2.256,0,0,1,.464-.106,1.861,1.861,0,0,1,.358-.012,1.37,1.37,0,0,1,.305.053",
    transform: "translate(33.858 12.63)",
    fill: "#2d154a"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M30.314,31.554a1.562,1.562,0,0,1,.1-.267,2.059,2.059,0,0,1,.452-.627,1.557,1.557,0,0,1,.47-.311,1.292,1.292,0,0,1,.7-.087,1.454,1.454,0,0,1,.684.307,2.284,2.284,0,0,1,.474.515,4.072,4.072,0,0,1,.521,1.135,5.421,5.421,0,0,1,.19,1.029,5.05,5.05,0,0,1,.015.738c-.012.178-.024.279-.024.279s-.059-.087-.144-.243-.2-.379-.325-.645-.269-.562-.425-.885a7.66,7.66,0,0,0-.515-.918,1.4,1.4,0,0,0-.612-.568,1.018,1.018,0,0,0-.73.062,4,4,0,0,0-.6.331c-.147.093-.232.155-.232.155",
    transform: "translate(15.694 15.66)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(82.121 36.984)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M64.007,26.57c-.888.48-1.759,1.009-2.641,1.5a9.621,9.621,0,0,0,2.553-2.164.366.366,0,0,0-.448-.566c.115-.109.238-.214.349-.326a.389.389,0,0,0-.484-.6c-2.664,1.507-5.7,3.811-8.917,3.866a.2.2,0,0,0-.083.366,2.653,2.653,0,0,0,.906.208.149.149,0,0,0,.088.165,6.325,6.325,0,0,0,5.188-.492A9.337,9.337,0,0,1,54.354,29.8a.2.2,0,0,0-.141.375c2.11,1.12,5.159.533,7.522-.78a10.423,10.423,0,0,1-1.585.88A13.607,13.607,0,0,1,56,31.081a.23.23,0,0,0-.041.452,7.032,7.032,0,0,0,3.295.1c-.079.036-.158.07-.234.112a.2.2,0,0,0,.061.367c1.774.539,4.332-.782,5.21-2.333a.4.4,0,0,0-.445-.578c.156-.161.31-.325.449-.5.307-.375-.076-1.009-.505-.827a6.9,6.9,0,0,0,.671-.747.366.366,0,0,0-.455-.56",
    transform: "translate(-54.108 -24.368)",
    fill: "#deeaf4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(78.573 26.952)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M59.722,19.3a4.391,4.391,0,0,0-.813-.3.39.39,0,0,0-.093-.633,4.544,4.544,0,0,0-.58-.191.123.123,0,0,1-.021-.018,5.045,5.045,0,0,0-2.621-.4.27.27,0,0,0-.194.43,9.677,9.677,0,0,0-2.035.7c-.237.111-.068.407.127.423.062,0,.126,0,.187,0a3.6,3.6,0,0,0-1.885,1.512.205.205,0,0,0,.237.29,22.47,22.47,0,0,1,3.822-1.237,24.511,24.511,0,0,1,3.717.085.358.358,0,0,0,.153-.669",
    transform: "translate(-51.77 -17.757)",
    fill: "#deeaf4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(55.138 44.062)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M44.346,29.035c-1.237.173-2.425.546-3.667.71-1.433.188-2.791-.108-4.207-.059a.145.145,0,0,0-.065.272,6.251,6.251,0,0,0,1.155.428c-.1-.012-.2-.018-.307-.032a.216.216,0,0,0-.1.42c.049.017.1.03.153.046-.229.029-.46.061-.691.108-.2.039-.141.291.011.34a7.207,7.207,0,0,0,1.317.264c-.26,0-.516-.006-.777-.012-.191,0-.27.294-.087.364a6.082,6.082,0,0,0,1.047.288c-.308.008-.619.012-.933.006-.255-.006-.252.334-.041.4a9.4,9.4,0,0,0,2.557.414,10.81,10.81,0,0,1-2.072.071c-.235-.018-.247.331-.038.382a8.217,8.217,0,0,0,1.544.234c-.024,0-.049.009-.071.012a.213.213,0,0,0,.014.425,5.816,5.816,0,0,0,2.972-.247c.27-.134.1-.5-.156-.5-.064,0-.129,0-.193,0,.041-.012.085-.024.124-.038a.326.326,0,0,0,.121-.533,8.7,8.7,0,0,0,1.575-.48c.351-.147.325-.745-.118-.692-.234.03-.463.058-.694.09a5.312,5.312,0,0,0,.65-.329c.278-.165.173-.662-.173-.628a10.052,10.052,0,0,0,1.09-.505.292.292,0,0,0,0-.521c.079-.038.164-.071.238-.109a.32.32,0,0,0-.181-.593",
    transform: "translate(-36.329 -29.031)",
    fill: "#deeaf4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(56.556 32.127)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M43.945,22.56c-.161-.042-.325-.079-.493-.114a.3.3,0,0,0-.106-.492l0,0a.283.283,0,0,0-.168-.291,5.712,5.712,0,0,0-2.486-.492.262.262,0,0,0-.234.389A5.19,5.19,0,0,0,38.618,22a.219.219,0,0,0,.134.41c.4-.047.779-.077,1.163-.085a6.742,6.742,0,0,0-2.529.883c-.25.155-.079.464.2.41a17.714,17.714,0,0,1,3.378-.531c.979-.015,1.924.2,2.9.114a.323.323,0,0,0,.076-.64",
    transform: "translate(-37.264 -21.168)",
    fill: "#deeaf4"
  }))))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M43.982,29.143a14.376,14.376,0,0,1-4.245.817,7.274,7.274,0,0,1-4.007-.845c-.062-.047-.147.049-.1.108.709.933,2.327.994,3.388,1.079a9.361,9.361,0,0,0,5.071-.923.13.13,0,0,0-.1-.235",
    transform: "translate(18.439 15.067)",
    fill: "#2d154a"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M44.716,30.589a7.41,7.41,0,0,1-8.422-.443.1.1,0,0,0-.143.149,6.921,6.921,0,0,0,8.724.557.154.154,0,0,0-.159-.263",
    transform: "translate(18.699 15.595)",
    fill: "#2d154a"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M45.358,28.581a11.3,11.3,0,0,1-6.71,3.045c-.09,0-.108.152-.014.159a8.722,8.722,0,0,0,3.916-.827,6.5,6.5,0,0,0,2.982-2.251c.076-.108-.088-.2-.175-.126",
    transform: "translate(19.97 14.784)",
    fill: "#2d154a"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M41.349,32.351a6.283,6.283,0,0,1-4.89-1.554c-.087-.073-.238.036-.164.137a4.887,4.887,0,0,0,5.1,1.676.132.132,0,0,0-.044-.258",
    transform: "translate(18.78 15.933)",
    fill: "#2d154a"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M43.534,22.588c-1.685-.915-4.483-.481-6.086.423-.159.091-.011.317.149.238a8.18,8.18,0,0,1,5.819-.346c.185.062.281-.228.118-.316",
    transform: "translate(19.353 11.432)",
    fill: "#2d154a"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M43.739,22.519c-1.483-1.278-3.873-.95-5.573-.338a.075.075,0,0,0,.046.143,7.944,7.944,0,0,1,5.333.47c.165.079.346-.144.194-.275",
    transform: "translate(19.733 11.205)",
    fill: "#2d154a"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M39.113,21.418a.116.116,0,0,0,.068.222,5.17,5.17,0,0,1,2.987.337,12.71,12.71,0,0,1,2.129,1.48c.124.087.243-.087.184-.2-.93-1.782-3.577-2.419-5.368-1.839",
    transform: "translate(20.208 10.981)",
    fill: "#2d154a"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M64.751,23.9a17.141,17.141,0,0,1-5.024,3.348,16.414,16.414,0,0,1-6.28,1.155.167.167,0,0,0-.032.328c2.164.442,4.427-.294,6.447-1.044,1.8-.666,4.136-1.88,5.057-3.665a.105.105,0,0,0-.168-.121",
    transform: "translate(27.59 12.357)",
    fill: "#2d154a"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M64.733,25.765a5.609,5.609,0,0,1-.472,1.044.169.169,0,0,0-.238-.194A20,20,0,0,1,52.6,28.472c-.056-.008-.076.076-.021.085A17.809,17.809,0,0,0,64.194,26.89a.175.175,0,0,0,.047-.039c-1.436,2.492-4.527,3.753-7.2,4.35-.182.039-.129.328.053.316,3.069-.223,7.191-2.437,7.885-5.695a.128.128,0,0,0-.249-.056",
    transform: "translate(27.206 13.291)",
    fill: "#2d154a"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M62.538,25.47c-.208,2.761-2.3,4.424-4.278,6.06-.135.109.049.322.19.232,2.167-1.4,4.4-3.533,4.345-6.3,0-.167-.243-.149-.256.009",
    transform: "translate(30.138 13.122)",
    fill: "#2d154a"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M60.959,27.272a21.771,21.771,0,0,1-7.035,1.876.083.083,0,0,0,.008.165,12.722,12.722,0,0,0,7.133-1.8c.126-.073.032-.3-.106-.237",
    transform: "translate(27.879 14.114)",
    fill: "#2d154a"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M62.59,24.979a11.856,11.856,0,0,1-5.968,3.2c-.071.018-.049.127.023.124A8.137,8.137,0,0,0,62.8,25.128c.08-.126-.112-.252-.209-.149",
    transform: "translate(29.292 12.913)",
    fill: "#2d154a"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M62.481,20.249a7.752,7.752,0,0,0-1.319-.574.136.136,0,0,0-.021-.2,4.85,4.85,0,0,0-1.067-.657l-.009-.014c-1.668-1.323-4.209-1.2-6.088-.452-.172.068-.1.337.087.279a6.714,6.714,0,0,1,2.993-.3,10.931,10.931,0,0,0-5.764,2.248.076.076,0,0,0,.08.129A15,15,0,0,1,56.081,18.9a7.494,7.494,0,0,1,3.987.489,11.779,11.779,0,0,0-8.385,1.566.1.1,0,0,0,.1.168,11.343,11.343,0,0,1,5.376-1.416,22.652,22.652,0,0,1,5.2.862.172.172,0,0,0,.12-.319",
    transform: "translate(26.539 9.215)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(57.294 51.948)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M75.962,37.731c-.345-1.108-.716-2.205-1.123-3.29-.178-.463-.461-.08-.349.261l.085.267c-.047-.061-.09-.124-.144-.185-.214-.252-.335,0-.363.226a.16.16,0,0,0-.244.042c-.138-.395-.495-.305-.49.109,0,.033,0,.068,0,.1a5.1,5.1,0,0,0-.234-.487c-.14-.256-.41-.235-.446.07-.027-.1-.046-.2-.074-.3-.087-.32-.426-.405-.484-.029a5.833,5.833,0,0,0-.029,1.348,5.308,5.308,0,0,0-.5-.87c-.209-.293-.414.067-.4.285.018.244.052.484.091.725a5.714,5.714,0,0,0-.654-1.16c-.267-.358-.448.2-.393.422.27,1.146.609,2.274.9,3.412.634,2.469-.417,3.884-2.058,5.57a19.766,19.766,0,0,1-7.841,5.072,17.048,17.048,0,0,1-7.335.845.7.7,0,0,0-.152-.463,3.029,3.029,0,0,0-.389-.246c0-.014,0-.029,0-.046a19.764,19.764,0,0,1-6.42-2.336,3.559,3.559,0,0,1-1.041-.87l.036.114a9.264,9.264,0,0,1-3.718-3.986c-.137-.3-.417-.212-.458.082-.023.162-.042.291-.056.41a11,11,0,0,0-.47-1.21c-.176-.372-.489-.124-.461.2a.12.12,0,0,1,0,.033c-.129-.012-.246.106-.232.364.018.361.024.716.026,1.07-.244-.782-.484-1.56-.733-2.339-.124-.384-.493-.323-.47.083.018.343.419,2.016-.164.707-.127-.288-.358-.173-.416.074-.033.269-.079.407-.135.428-.015,0-.027,0-.041,0-.065-.042-.14-.229-.228-.574-.023-.143-.059-.3-.121-.568l0,0c-.006-.038-.015-.073-.024-.112-.165-.449-.539-.209-.437.193q.109.585.214,1.172a.492.492,0,0,0,.246.39,17.022,17.022,0,0,0,.548,2.536c.156.49.5.2.445-.2-.088-.64-.188-1.278-.287-1.914a.18.18,0,0,0,.123-.138c.131-.562-.03-.32.3.235.144.246.367.214.416-.073.027-.156.046-.305.061-.455.231.76.458,1.519.7,2.28.091.288.449.43.481.026q.057-.733.071-1.459a.24.24,0,0,0,.225-.182c.118.354.24.706.389,1.046.173.4.455.094.46-.2l.052-.589a11.824,11.824,0,0,0,4.593,4.21,8.648,8.648,0,0,0,.912.971c3,2.75,7.543,3.034,11.34,2.346,4.687-.851,8.13-3.635,11.3-7.035A5.345,5.345,0,0,0,71.7,39.272a8.358,8.358,0,0,0,.492,1.378c.178.373.463.109.454-.2a14.968,14.968,0,0,0-.595-3.117c.237.792.379,1.625.625,2.395.129.4.519.341.492-.087a8.957,8.957,0,0,0-.127-1c.168.155.4.112.37-.267-.049-.631-.158-1.279-.209-1.924.179.555.319,1.123.524,1.673.2.531.559.229.5-.22-.018-.143-.044-.284-.068-.423.14.033.276-.147.281-.387.208.326.431-.1.387-.37-.02-.127-.039-.252-.059-.376.3.584.528,1.219.836,1.792.253.472.458-.121.369-.4",
    transform: "translate(-37.75 -34.227)",
    fill: "#8ea2d1"
  }))))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M67.32,38.232c-4.758-.132-9.639,2.8-12.3,2.456s-5.4.672-7.985,1.893-3.1,1.462-4.426.252a2.64,2.64,0,0,0-.8-.5c.586.486,1.269,1.1,2.107,1.874,2.9,2.688,8.977,5.016,15.953,2.334a16.184,16.184,0,0,0,7.458-8.31",
    transform: "translate(21.642 19.792)",
    fill: "#7f1424"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M73.69,34.833c-2.4,1.276-5.678.559-11.224.563-5.987,0-12.054,3.016-17.355,5.69a11.511,11.511,0,0,1-5.2,1.345,6.472,6.472,0,0,1,2.872,1.659,2.67,2.67,0,0,1,.8.5c1.331,1.21,1.839.965,4.426-.252s5.315-2.24,7.985-1.893,7.546-2.586,12.3-2.456a16.178,16.178,0,0,1-7.458,8.31c.534-.208,1.073-.439,1.615-.7C70.1,43.85,72.385,36.143,73.71,34.848Z",
    transform: "translate(20.662 18.034)",
    fill: "#f289aa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(66.655 58.02)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M53.919,40.688c-2.67-.348-5.4.672-7.985,1.893a21.136,21.136,0,0,1-2.017.879,2.236,2.236,0,0,0,.378-.1,18.457,18.457,0,0,1,8.546-1.073c2.967.408,4.588.892,7.186-.246,2.957-1.295.117,3.1-4.376,4.309a17.438,17.438,0,0,1-7.593.73,16.489,16.489,0,0,0,10.708-.54,16.185,16.185,0,0,0,7.457-8.31c-4.758-.132-9.638,2.8-12.3,2.456",
    transform: "translate(-43.918 -38.228)",
    fill: "#7f1424"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(60.571 52.868)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M73.691,34.833c-2.4,1.276-5.678.559-11.224.563-5.987,0-12.054,3.016-17.355,5.69a11.516,11.516,0,0,1-5.2,1.346,6.46,6.46,0,0,1,2.873,1.659,2.64,2.64,0,0,1,.8.5c1.331,1.21,1.839.965,4.426-.252S53.326,42.1,56,42.446s7.546-2.588,12.3-2.456A16.178,16.178,0,0,1,60.841,48.3c.534-.206,1.073-.437,1.615-.7C70.1,43.85,72.385,36.143,73.71,34.848ZM71.28,37.44c-.578,1.7-1.317,1.8-2.972,1.914s-2.418-3.128-3.325-1.436-1.153.8-2.137-.076-1.392-.384-1.853.858-.927,1.207-1.882-.033-1.979-1.871-2.3.085-.747,2.14-2.041.944-2.107-1.415-2.29.789-.692.563-1.408-.07-1.3-.76-1.425.4.046,1.14-.81.53c-1.109-.794-1.753-.683-1.862.821s.24,1.8-.782,2.234-1.876.2-3.02-.637.833-1.472,2.09-2.028c2.076-.917,3.16-1.439,5.42-2.524A32.36,32.36,0,0,1,65,36.393c5.248.364,6.725-.275,6.276,1.047",
    transform: "translate(-39.909 -34.834)",
    fill: "#ca6b8e"
  }))))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M44.9,41.254c.181.729.788,2.981,2.444,2.424a6.255,6.255,0,0,0-.4-2.741c-.578-1.979-1.938-1.959-1.938-1.959s-.533.6-.106,2.277",
    transform: "translate(23.162 20.18)",
    fill: "#fde387"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M44.91,41.279a6.7,6.7,0,0,0,.3.929,3.608,3.608,0,0,0,.484.841,1.789,1.789,0,0,0,.337.332.968.968,0,0,0,.191.131.905.905,0,0,0,.206.09.709.709,0,0,0,.22.049.773.773,0,0,0,.222,0,1.058,1.058,0,0,0,.217-.033l.216-.065-.1.111a1.776,1.776,0,0,0,0-.322,2.564,2.564,0,0,0-.026-.34c-.035-.231-.077-.458-.106-.688-.018-.114-.056-.228-.079-.341l-.09-.343-.079-.341a2.852,2.852,0,0,0-.082-.323l-.118-.338a1.581,1.581,0,0,0-.129-.322c-.055-.094-.1-.191-.155-.288a1.274,1.274,0,0,0-.193-.27,1.35,1.35,0,0,0-.229-.244,1.7,1.7,0,0,0-.267-.2,1.641,1.641,0,0,0-.3-.149,1.361,1.361,0,0,0-.325-.082l.053-.023a.974.974,0,0,0-.137.229,2.552,2.552,0,0,0-.094.269c-.02.094-.039.188-.055.284l-.018.29a2.666,2.666,0,0,0,.008.29l.024.291Zm0,0-.124-.572-.03-.291a1.9,1.9,0,0,1-.024-.291l0-.3.033-.3a2.628,2.628,0,0,1,.068-.293,1.006,1.006,0,0,1,.135-.284l.015-.026h.038a1.454,1.454,0,0,1,.376.05,1.827,1.827,0,0,1,.355.127,2.013,2.013,0,0,1,.326.194,1.543,1.543,0,0,1,.287.246,1.619,1.619,0,0,1,.252.287c.071.106.147.214.216.323a1.806,1.806,0,0,1,.155.332l.138.329a2.654,2.654,0,0,1,.1.364l.091.354.083.354c.024.118.059.235.076.357.03.241.05.487.076.73a2.794,2.794,0,0,1,0,.373,1.811,1.811,0,0,1-.042.39l-.023.1-.079.014-.261.052a1.319,1.319,0,0,1-.269.015,1.048,1.048,0,0,1-.266-.036.949.949,0,0,1-.252-.085,1.049,1.049,0,0,1-.228-.129,1.235,1.235,0,0,1-.2-.165,2.121,2.121,0,0,1-.317-.392,3.661,3.661,0,0,1-.237-.436,4.41,4.41,0,0,1-.187-.455,8.04,8.04,0,0,1-.278-.939",
    transform: "translate(23.156 20.155)",
    fill: "#2d154a"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M46.784,41.094c.264.639,1,2.078,1.991,2.3a3.547,3.547,0,0,0-.08-2.627c-.58-1.627-1.621-2.2-1.9-2.213,0,0-.759.718-.015,2.536",
    transform: "translate(24.052 19.963)",
    fill: "#fde387"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M46.8,41.127a5.527,5.527,0,0,0,.8,1.345,3.489,3.489,0,0,0,.557.534,2.2,2.2,0,0,0,.32.194,1.711,1.711,0,0,0,.346.114l-.137.064a2.7,2.7,0,0,0,.121-.654,5.029,5.029,0,0,0-.023-.677,2.086,2.086,0,0,0-.053-.335c-.027-.112-.035-.225-.068-.332l-.1-.328-.05-.164c-.011-.032-.041-.1-.061-.152l-.135-.331a3.12,3.12,0,0,0-.153-.3,2.028,2.028,0,0,0-.164-.29l-.187-.285c-.068-.091-.146-.175-.214-.261a2.592,2.592,0,0,0-.24-.243,3.234,3.234,0,0,0-.269-.206,1.13,1.13,0,0,0-.278-.129l.07-.027a.937.937,0,0,0-.173.244,2.15,2.15,0,0,0-.123.291l-.065.319c-.009.108-.006.217-.008.326a.736.736,0,0,0,0,.164l.026.162.052.329Zm0,0-.219-.628-.07-.325-.035-.162a.769.769,0,0,1-.017-.167c-.006-.112-.015-.225-.02-.337l.03-.337a3.329,3.329,0,0,1,.1-.334,1.061,1.061,0,0,1,.185-.313l.026-.03.042,0a1.224,1.224,0,0,1,.384.117,3.319,3.319,0,0,1,.322.2,2.7,2.7,0,0,1,.29.232c.09.087.184.17.267.263l.232.291a2.673,2.673,0,0,1,.2.316,2.462,2.462,0,0,1,.182.329l.141.326c.026.061.044.1.074.176l.052.179.1.357c.03.118.041.243.064.366a2.336,2.336,0,0,1,.033.372c0,.124.009.249,0,.373l-.043.37a2.937,2.937,0,0,1-.226.724l-.049.091-.088-.027a1.729,1.729,0,0,1-.384-.172,2.475,2.475,0,0,1-.329-.25,3.507,3.507,0,0,1-.51-.615,7.607,7.607,0,0,1-.742-1.386",
    transform: "translate(24.041 19.93)",
    fill: "#2d154a"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M48.72,37.63a5.408,5.408,0,0,0-.07,3.413c.543,2.094,1.7,2.377,1.7,2.377a4.257,4.257,0,0,0,.467-3.476,3.475,3.475,0,0,0-2.1-2.315",
    transform: "translate(25.071 19.483)",
    fill: "#fde387"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M48.759,37.63a4.465,4.465,0,0,0-.158.792,3.5,3.5,0,0,0-.027.4,2.941,2.941,0,0,0,0,.4l.017.4.053.4a2.673,2.673,0,0,0,.067.392l.094.387.046.193.065.181.135.382a2.174,2.174,0,0,0,.161.355c.061.111.108.229.178.335l.219.313c.079.1.172.184.252.278a3,3,0,0,0,.287.232,1.585,1.585,0,0,0,.3.149l-.223.083c.058-.1.134-.223.188-.345a3.049,3.049,0,0,0,.161-.376,2.62,2.62,0,0,0,.126-.387c.029-.132.073-.264.094-.4l.05-.4a2.129,2.129,0,0,0,.006-.405,2.411,2.411,0,0,0-.026-.407l-.077-.4c-.014-.059-.026-.144-.038-.188l-.074-.2-.152-.4c-.062-.123-.134-.235-.2-.355l-.1-.178-.131-.161a2.477,2.477,0,0,0-.264-.323,3.641,3.641,0,0,0-.305-.287,3.021,3.021,0,0,0-.343-.247,2.356,2.356,0,0,0-.375-.2m0,0a2.232,2.232,0,0,1,.405.146,2.975,2.975,0,0,1,.379.209,4.138,4.138,0,0,1,.352.261,2.508,2.508,0,0,1,.316.307l.15.159.124.187c.08.126.173.252.244.378l.181.389.09.2c.035.091.042.15.067.225l.111.434a2.557,2.557,0,0,1,.047.446,2.436,2.436,0,0,1,.009.446l-.041.451c-.02.146-.064.29-.1.434a5.39,5.39,0,0,1-.307.839,2.939,2.939,0,0,1-.222.4l-.083.131-.146-.044a1.7,1.7,0,0,1-.428-.209,3.611,3.611,0,0,1-.341-.281c-.1-.109-.2-.212-.29-.328l-.237-.358c-.074-.123-.124-.261-.19-.392a2.251,2.251,0,0,1-.156-.39l-.117-.39-.056-.206-.036-.206-.07-.407a3.164,3.164,0,0,1-.039-.414l-.027-.413.018-.414a2.708,2.708,0,0,1,.046-.411,3.46,3.46,0,0,1,.076-.4,3.324,3.324,0,0,1,.267-.776",
    transform: "translate(25.033 19.483)",
    fill: "#2d154a"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M51.222,38.966a5.542,5.542,0,0,0,1.669,3.908,3.542,3.542,0,0,0,.692-3.43,3.68,3.68,0,0,0-2.006-2.576,3.4,3.4,0,0,0-.355,2.1",
    transform: "translate(26.499 19.089)",
    fill: "#fde387"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M51.223,38.987c.056.358.087.724.162,1.079.027.178.088.351.134.527a3.83,3.83,0,0,0,.19.505,3.22,3.22,0,0,0,.25.475,2.255,2.255,0,0,0,.3.44l.165.212a1.266,1.266,0,0,0,.184.188l.384.366-.211.006a2.389,2.389,0,0,0,.234-.335c.071-.118.137-.243.2-.367a3.806,3.806,0,0,0,.255-.786,4.043,4.043,0,0,0,.061-.407c0-.14.017-.276.009-.414a3.961,3.961,0,0,0-.112-.82l-.023-.1-.006-.026v0c.006.023,0,0,0,0l0-.012-.02-.053-.07-.208-.138-.416c-.056-.131-.12-.249-.178-.376a1.909,1.909,0,0,0-.206-.367c-.082-.115-.149-.241-.241-.349s-.187-.217-.287-.316-.208-.2-.328-.275a1.939,1.939,0,0,0-.364-.217l.059-.023a2.462,2.462,0,0,0-.229.481,3.282,3.282,0,0,0-.143.516,2.877,2.877,0,0,0-.055.536,4.613,4.613,0,0,0,.029.539m0,0a4.951,4.951,0,0,1-.041-.539,4.046,4.046,0,0,1,.041-.54,3.178,3.178,0,0,1,.118-.53,3.226,3.226,0,0,1,.193-.513l.02-.036.039.015a2.154,2.154,0,0,1,.41.193,3.64,3.64,0,0,1,.37.255c.117.1.222.2.335.3a4.3,4.3,0,0,1,.293.346,2.2,2.2,0,0,1,.258.376c.076.131.164.264.231.4l.168.407.083.2.02.052.006.012.009.026.008.029.029.109a3.683,3.683,0,0,1,.147.912,3.933,3.933,0,0,1-.009.463c-.026.153-.039.308-.079.457a3.351,3.351,0,0,1-.32.868,3.941,3.941,0,0,1-.247.392A3,3,0,0,1,53,43l-.115.115-.1-.109-.372-.423a1.325,1.325,0,0,1-.173-.217l-.15-.235a2.763,2.763,0,0,1-.272-.486,3.541,3.541,0,0,1-.208-.511c-.05-.176-.118-.349-.15-.527s-.085-.357-.1-.539c-.059-.358-.091-.721-.137-1.082",
    transform: "translate(26.498 19.068)",
    fill: "#2d154a"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M54.734,36.772a4.792,4.792,0,0,0-.7,2.856c.044,1.874.776,2.359.776,2.359A2.9,2.9,0,0,0,56.3,39.471a3.256,3.256,0,0,0-1.563-2.7",
    transform: "translate(27.974 19.038)",
    fill: "#fde387"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M54.79,36.772a3.83,3.83,0,0,0-.269.631,4.39,4.39,0,0,0-.164.662L54.3,38.4l-.032.337c0,.112-.024.223-.018.335l.006.34a2.006,2.006,0,0,0,.017.331l.036.345a5.7,5.7,0,0,0,.114.651l.1.31a2.708,2.708,0,0,0,.126.3,2.344,2.344,0,0,0,.153.27,1.805,1.805,0,0,0,.179.2l-.209-.015a2.433,2.433,0,0,0,.294-.2,3.156,3.156,0,0,0,.279-.237,2.732,2.732,0,0,0,.451-.578,2.994,2.994,0,0,0,.162-.328,2.387,2.387,0,0,0,.12-.346,3.653,3.653,0,0,0,.073-.363c0-.121.029-.252.023-.367A2.068,2.068,0,0,0,56.157,39a2.607,2.607,0,0,0-.065-.363,2.949,2.949,0,0,0-.285-.7,3.691,3.691,0,0,0-1.017-1.166m0,0a3.359,3.359,0,0,1,1.2,1.047,3.086,3.086,0,0,1,.369.735,2.426,2.426,0,0,1,.106.407,2.66,2.66,0,0,1,.053.4,3.255,3.255,0,0,1,0,.422,3.793,3.793,0,0,1-.067.417,2.733,2.733,0,0,1-.12.4,2.451,2.451,0,0,1-.178.384,3.04,3.04,0,0,1-.511.672,3.727,3.727,0,0,1-.317.282,2.953,2.953,0,0,1-.369.232l-.115.061-.1-.074a1.439,1.439,0,0,1-.287-.31,2.539,2.539,0,0,1-.187-.329,2.6,2.6,0,0,1-.137-.343l-.1-.354a5.51,5.51,0,0,1-.1-.715l-.014-.346a2.583,2.583,0,0,1,.009-.36l.023-.354a3.333,3.333,0,0,1,.05-.349,3.964,3.964,0,0,1,.153-.689,4.422,4.422,0,0,1,.258-.653,2.758,2.758,0,0,1,.367-.592",
    transform: "translate(27.919 19.038)",
    fill: "#2d154a"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M56.374,38.773a8.345,8.345,0,0,0,.507,3.435s1.088-.876.892-3.187a4.718,4.718,0,0,0-.666-2.184s-.672.4-.733,1.937",
    transform: "translate(29.183 19.071)",
    fill: "#fde387"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M56.376,38.805c0,.291,0,.584.015.876a8.2,8.2,0,0,0,.1.865,8.558,8.558,0,0,0,.2.845l.14.405.184.378-.22-.047a1.764,1.764,0,0,0,.2-.255,1.866,1.866,0,0,0,.162-.291,1.333,1.333,0,0,0,.137-.308,2.948,2.948,0,0,0,.109-.32l.08-.331a1.627,1.627,0,0,0,.05-.334l.042-.341a2.161,2.161,0,0,0,.011-.345v-.345a2.992,2.992,0,0,0-.006-.351c-.017-.229-.036-.464-.073-.694a5.142,5.142,0,0,0-.15-.681l-.123-.323-.172-.3.088.015a.923.923,0,0,0-.185.158,2.114,2.114,0,0,0-.164.2l-.129.231c-.033.079-.065.162-.1.243a3.884,3.884,0,0,0-.137.515Zm0,0,.046-.531c.041-.173.058-.352.112-.524.027-.085.053-.172.083-.256l.114-.246a1.415,1.415,0,0,1,.343-.439l.049-.036.039.052c.074.1.152.2.225.3l.168.329a5.788,5.788,0,0,1,.24.7,6.437,6.437,0,0,1,.15.719,2.979,2.979,0,0,1,.033.366l.017.372a2.141,2.141,0,0,1,0,.369l-.038.37a1.615,1.615,0,0,1-.068.367l-.1.366a2.617,2.617,0,0,1-.143.348,1.959,1.959,0,0,1-.175.335,1.849,1.849,0,0,1-.225.31,1.754,1.754,0,0,1-.275.278l-.156.134-.064-.179-.152-.43-.1-.439a8.559,8.559,0,0,1-.1-.879c-.011-.146-.012-.291-.021-.437s-.009-.293-.011-.439c-.009-.293,0-.583.008-.876",
    transform: "translate(29.181 19.039)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(67.903 60.232)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M47.186,42.283c-1.625.552-2.227-1.7-2.41-2.431-.015-.056-.024-.109-.035-.165a4.678,4.678,0,0,0,.161,1.2c.182.729.789,2.981,2.445,2.424a4.725,4.725,0,0,0-.158-1.806,2.912,2.912,0,0,1,0,.779",
    transform: "translate(-44.739 -39.685)",
    fill: "#d0b86c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(70.512 59.608)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M48.569,42.007c-.968-.231-1.7-1.67-1.962-2.31-.059-.149-.106-.288-.149-.422a3.812,3.812,0,0,0,.325,1.448c.266.639,1,2.078,1.991,2.3a3.53,3.53,0,0,0-.029-2.463,3.019,3.019,0,0,1-.176,1.443",
    transform: "translate(-46.459 -39.274)",
    fill: "#d0b86c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(73.57 59.119)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M50.684,38.952a4.381,4.381,0,0,1-.609,2.771s-1.038-.266-1.6-2.116a7.058,7.058,0,0,0,.153.753c.542,2.093,1.7,2.377,1.7,2.377a4.257,4.257,0,0,0,.467-3.476c-.035-.108-.074-.212-.114-.31",
    transform: "translate(-48.474 -38.952)",
    fill: "#d0b86c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(77.911 57.752)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M53.208,38.051a3.559,3.559,0,0,1-.724,3.207,4.6,4.6,0,0,1-1.15-1.61,4.66,4.66,0,0,0,1.48,2.614,3.539,3.539,0,0,0,.694-3.43,5.594,5.594,0,0,0-.3-.78",
    transform: "translate(-51.334 -38.051)",
    fill: "#d0b86c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(82.132 56.838)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M55.827,38.132a2.866,2.866,0,0,1-1.456,2.51,1.1,1.1,0,0,1-.256-.3,2.083,2.083,0,0,0,.653,1.289,2.919,2.919,0,0,0,.982-4.186,2.851,2.851,0,0,1,.077.683",
    transform: "translate(-54.115 -37.45)",
    fill: "#d0b86c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(85.721 55.907)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M57.05,36.836l-.018.011a6.823,6.823,0,0,1,.206,1.194,3.968,3.968,0,0,1-.759,3.072,4.316,4.316,0,0,0,.345,1.1s1.088-.877.892-3.189a4.718,4.718,0,0,0-.666-2.184",
    transform: "translate(-56.48 -36.836)",
    fill: "#d0b86c"
  }))))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M47.309,44.955s-.577-.727-.341-2.724c0,0,.83.088,1.686,2.787,0,0-.389.66-1.345-.062",
    transform: "translate(24.287 21.865)",
    fill: "#fde387"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M47.351,45.024a1.853,1.853,0,0,1-.164-.307c-.041-.109-.077-.22-.115-.331a6.256,6.256,0,0,1-.156-.688,3.414,3.414,0,0,1-.049-.351l-.03-.357-.008-.713,0-.181.2.023a.571.571,0,0,1,.155.047.41.41,0,0,1,.115.058,1.213,1.213,0,0,1,.2.138,1.873,1.873,0,0,1,.31.332,2.04,2.04,0,0,1,.247.366c.067.126.146.252.2.382a7.691,7.691,0,0,1,.291.8l.216.82.012.038-.018.021a.593.593,0,0,1-.159.144.683.683,0,0,1-.184.088.363.363,0,0,1-.1.017l-.1.012a.288.288,0,0,1-.1-.008l-.1-.015a.514.514,0,0,1-.182-.059c-.058-.024-.12-.044-.176-.073Zm0,0,.325.2a1.352,1.352,0,0,0,.176.065.5.5,0,0,0,.181.039l.093,0a.254.254,0,0,0,.09,0l.088-.021a.381.381,0,0,0,.085-.03.706.706,0,0,0,.141-.1.528.528,0,0,0,.1-.129l-.008.061-.343-.757a3.48,3.48,0,0,0-.194-.364l-.185-.363a7.916,7.916,0,0,0-.428-.671,2,2,0,0,0-.246-.29.711.711,0,0,0-.131-.115.175.175,0,0,0-.067-.042c-.018-.014-.047-.027-.039-.027l.2-.159-.109.68-.023.343a2.619,2.619,0,0,0-.015.345l.011.346.053.343a1.871,1.871,0,0,0,.246.647",
    transform: "translate(24.245 21.796)",
    fill: "#2d154a"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M49.138,45.512a7.984,7.984,0,0,1-.648-3.466A6.382,6.382,0,0,1,50,45.271s.369.624-.859.241",
    transform: "translate(25.089 21.769)",
    fill: "#fde387"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M49.205,45.668a6.63,6.63,0,0,1-.389-.81A8.683,8.683,0,0,1,48.525,44l-.1-.445a2.863,2.863,0,0,1-.067-.455,2.73,2.73,0,0,1-.029-.461l.014-.467.018-.431.334.3c.068.068.112.123.173.185l.147.187c.1.123.178.258.263.39s.149.27.222.407.127.281.19.423a7.925,7.925,0,0,1,.3.87c.041.147.067.3.1.445l.087.449-.012-.035a.513.513,0,0,1,.053.19.27.27,0,0,1-.07.214.315.315,0,0,1-.185.09.872.872,0,0,1-.168,0,2.014,2.014,0,0,1-.592-.187m0,0a3.12,3.12,0,0,0,.595.058c.091,0,.2-.032.208-.074a.075.075,0,0,0,0-.068.339.339,0,0,0-.044-.1l0,0-.009-.027-.141-.423c-.05-.141-.087-.282-.138-.419-.124-.27-.2-.555-.346-.81-.065-.131-.118-.266-.191-.395s-.141-.253-.216-.376-.155-.243-.24-.355l-.129-.172c-.042-.047-.1-.108-.131-.146l.348-.127-.029.42a2.52,2.52,0,0,0,0,.428c.009.143.009.287.032.43l.055.433.077.434c.021.144.062.285.087.433.059.288.138.572.216.862",
    transform: "translate(25.022 21.613)",
    fill: "#2d154a"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M49.946,45.012a3.624,3.624,0,0,1-.2-2.009,6.52,6.52,0,0,1,.889,1.876c0,.489-.686.134-.686.134",
    transform: "translate(25.724 22.264)",
    fill: "#fde387"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M50.008,45.22a1.923,1.923,0,0,1-.241-.467,2.548,2.548,0,0,1-.146-.51,2.83,2.83,0,0,1-.053-.533,4.211,4.211,0,0,1,.03-.536l.053-.572.328.495a6.782,6.782,0,0,1,.71,1.331,3.193,3.193,0,0,1,.112.376,1.758,1.758,0,0,1,.024.217l0,.055a.171.171,0,0,1-.008.059l-.009.047c-.009.023-.018.047-.029.068a.294.294,0,0,1-.214.173.491.491,0,0,1-.22-.018,1.083,1.083,0,0,1-.34-.185m0,0a1.43,1.43,0,0,0,.358.049.347.347,0,0,0,.147-.03.091.091,0,0,0,.047-.07l0-.015v-.046c0-.009,0-.047,0-.032l-.014-.038-.044-.146c-.053-.106-.091-.209-.15-.314-.109-.212-.232-.42-.352-.63l-.372-.627.381-.074c-.014.158-.064.316-.07.478,0,.08-.011.162-.02.243s0,.165,0,.246a1.7,1.7,0,0,0,0,.249c0,.082.006.167.017.25.017.165.038.334.07.507",
    transform: "translate(25.662 22.057)",
    fill: "#2d154a"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M50.836,45.516a9.8,9.8,0,0,1-.6-3.77s.68.4,1.032,2.324c0,0,.294,1.208.443,1.22Z",
    transform: "translate(26.001 21.613)",
    fill: "#fde387"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M50.908,45.654a6.1,6.1,0,0,1-.378-.892,4.471,4.471,0,0,1-.144-.466,4.549,4.549,0,0,1-.115-.472l-.094-.48-.053-.489a9.662,9.662,0,0,1-.032-.983l-.009-.392.328.223a1.076,1.076,0,0,1,.229.2,1.989,1.989,0,0,1,.3.437c.039.076.085.152.118.231.062.158.138.313.187.475s.1.322.135.484l.1.49.042.232.052.235.111.467c.02.079.042.153.067.228.012.032.024.073.038.1a.147.147,0,0,0,.02.041l.008.012a.029.029,0,0,0-.027,0l.015.176c-.3.047-.593.1-.894.138m0,0c.281-.114.568-.206.85-.313l.015.178a.243.243,0,0,1-.079-.033c-.018-.015-.023-.023-.035-.033a.446.446,0,0,1-.047-.062,1.336,1.336,0,0,1-.067-.117c-.036-.077-.071-.153-.1-.234-.061-.152-.121-.308-.17-.464l-.074-.235-.07-.244-.117-.461c-.047-.15-.1-.3-.153-.448s-.12-.285-.178-.431c-.03-.07-.074-.134-.108-.2a1.321,1.321,0,0,0-.12-.193c-.044-.058-.082-.123-.129-.173a1.235,1.235,0,0,0-.127-.127l.317-.168c.006.311-.026.624,0,.936l.02.474.047.467c.015.158.041.314.061.472s.047.313.076.47c.046.317.12.625.194.939",
    transform: "translate(25.929 21.476)",
    fill: "#2d154a"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M51.356,44.985a5.807,5.807,0,0,1,.123-2.6,7.574,7.574,0,0,1,.771,2.275s.132.27-.894.322",
    transform: "translate(26.538 21.946)",
    fill: "#fde387"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M51.412,45.155a5.473,5.473,0,0,1-.249-1.311,3.144,3.144,0,0,1-.011-.34,2.013,2.013,0,0,1,.017-.343c.02-.115.027-.231.053-.349s.083-.235.129-.355l.152-.4.217.4c.1.188.185.373.264.563a4.831,4.831,0,0,1,.212.581l.091.294a2.3,2.3,0,0,1,.061.308c.029.2.065.411.088.615l-.014-.041a.2.2,0,0,1,0,.158.192.192,0,0,1-.064.093.4.4,0,0,1-.146.088,1.2,1.2,0,0,1-.14.036.6.6,0,0,1-.137.017,2.733,2.733,0,0,1-.524-.014m0,0c.168-.046.334-.079.492-.135a.494.494,0,0,0,.112-.044.685.685,0,0,0,.1-.052c.023-.02.065-.039.064-.055s.012-.015,0-.012-.011,0,0,.035l.009.017-.02-.059c-.061-.19-.114-.376-.167-.565-.032-.091-.042-.187-.083-.278l-.109-.275c-.074-.181-.131-.369-.22-.543s-.158-.361-.246-.531l.369,0c-.032.085-.065.173-.1.261s-.044.2-.07.3a2.923,2.923,0,0,0-.044.31,3.1,3.1,0,0,0-.033.319c-.017.214-.027.428-.036.65Z",
    transform: "translate(26.483 21.776)",
    fill: "#2d154a"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M52.351,45.058a8.651,8.651,0,0,1,.093-3.606,5.381,5.381,0,0,1,.827,3.447Z",
    transform: "translate(27.021 21.461)",
    fill: "#fde387"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M52.408,45.22c-.088-.293-.144-.593-.2-.9a8,8,0,0,1-.109-.917c-.015-.153-.008-.308-.014-.466a3.733,3.733,0,0,1,.021-.467l.027-.235A1.374,1.374,0,0,1,52.169,42l.14-.474.117-.389.244.345a3.213,3.213,0,0,1,.253.416,4.345,4.345,0,0,1,.194.428c.064.143.1.294.152.442a2.614,2.614,0,0,1,.108.455c.024.153.068.3.077.458l.023.463a2.466,2.466,0,0,1-.012.461c-.015.153-.023.307-.041.46l-.009.082-.071,0c-.31.023-.621.056-.935.065m0,0c.3-.1.6-.172.9-.255l-.077.087c-.017-.15-.018-.3-.032-.443a3.244,3.244,0,0,0-.036-.437l-.067-.434a3.6,3.6,0,0,0-.1-.425,2.618,2.618,0,0,0-.123-.416,3.341,3.341,0,0,0-.152-.407,3.512,3.512,0,0,0-.182-.39,3.009,3.009,0,0,0-.208-.361L52.7,41.7l-.124.4a1.371,1.371,0,0,0-.046.211l-.036.216a2.963,2.963,0,0,0-.047.437,4.379,4.379,0,0,0-.032.446l-.015.451c0,.15,0,.3,0,.452,0,.305.012.606.015.912",
    transform: "translate(26.964 21.3)",
    fill: "#2d154a"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M53.564,44.127a4.608,4.608,0,0,1-.276-1.553,2.225,2.225,0,0,1,1.061,1.106l.114.272s-.66.539-.9.175",
    transform: "translate(27.587 22.042)",
    fill: "#fde387"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M53.637,44.213c-.052-.121-.083-.249-.132-.373s-.08-.253-.126-.381l-.068-.193a1.673,1.673,0,0,1-.046-.2c-.029-.134-.055-.272-.079-.411l-.041-.246.284.091a1.587,1.587,0,0,1,.24.106,1.677,1.677,0,0,1,.216.138c.065.052.131.106.191.162l.168.191a2.236,2.236,0,0,1,.135.216.944.944,0,0,1,.106.228,1.414,1.414,0,0,1,.079.234L54.62,44l.02.08-.046.027a2.274,2.274,0,0,1-.487.208.744.744,0,0,1-.258.026.28.28,0,0,1-.212-.132m0,0a.276.276,0,0,0,.212.118.531.531,0,0,0,.241-.061,1.423,1.423,0,0,0,.387-.3l-.027.108-.126-.2c-.038-.071-.085-.118-.126-.182a3.6,3.6,0,0,0-.272-.329c-.1-.1-.2-.2-.305-.293l-.164-.132c-.053-.042-.118-.083-.164-.118l.238-.153c-.006.124-.017.249-.032.378a1.7,1.7,0,0,0-.015.2l.006.2a2.3,2.3,0,0,0,.047.395,2.923,2.923,0,0,0,.1.381",
    transform: "translate(27.515 21.956)",
    fill: "#2d154a"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M54.667,44.564a5.787,5.787,0,0,1-.32-3.817s.756.193.93,3.416Z",
    transform: "translate(28.021 21.096)",
    fill: "#fde387"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M54.731,44.656a5.61,5.61,0,0,1-.411-.9c-.058-.158-.1-.316-.147-.475s-.074-.326-.108-.49A5.023,5.023,0,0,1,54,41.777a3.421,3.421,0,0,1,.068-.511,3.492,3.492,0,0,1,.143-.5l.058-.193.193.064a.5.5,0,0,1,.176.1,1.085,1.085,0,0,1,.255.322,2.092,2.092,0,0,1,.2.449,2.24,2.24,0,0,1,.132.454c.03.153.074.3.093.458l.055.458a4.264,4.264,0,0,1,.035.457c.006.307.012.612.008.917l0,.052-.032.017c-.216.114-.431.232-.653.338m0,0c.184-.161.378-.313.566-.467l-.035.068c-.058-.3-.1-.593-.144-.892s-.118-.583-.167-.876c-.024-.149-.076-.284-.111-.426a3.083,3.083,0,0,0-.134-.41,1.776,1.776,0,0,0-.175-.375.531.531,0,0,0-.108-.15c-.017-.021-.038-.055-.053-.061s-.047-.033-.014-.021l.252-.127a3.274,3.274,0,0,0-.131.436,4.453,4.453,0,0,0-.079.455c-.009.155-.03.311-.024.467s0,.316.012.475a9.974,9.974,0,0,0,.343,1.9",
    transform: "translate(27.956 21.005)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(71.198 61.843)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M48.541,44.686c-.814-2.368-1.574-2.456-1.574-2.456-.235,2,.341,2.724.341,2.724a2.137,2.137,0,0,0,.22.147,5.912,5.912,0,0,1,0-1.606s.449.052,1.015,1.19",
    transform: "translate(-46.911 -39.978)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M48.881,43.331a5.167,5.167,0,0,1,1.167,2.138.389.389,0,0,0-.05-.2,6.386,6.386,0,0,0-1.507-3.224,7.738,7.738,0,0,0,.61,3.381,5.653,5.653,0,0,1-.22-2.1",
    transform: "translate(-46.108 -40.073)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M51.264,44.071c-.352-1.921-1.034-2.324-1.034-2.324a9.511,9.511,0,0,0,.238,2.538,8.26,8.26,0,0,1-.035-1.222s.631.373.959,2.161c0,0,.014.056.036.14l.278-.073c-.149-.012-.443-1.22-.443-1.22",
    transform: "translate(-45.198 -40.229)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M51.478,42.388a5.593,5.593,0,0,0-.126,2.571,2.944,2.944,0,0,1,.2-1.323,7.886,7.886,0,0,1,.516,1.232c.232-.094.181-.2.181-.2a7.6,7.6,0,0,0-.773-2.275",
    transform: "translate(-44.66 -39.897)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M52.21,43.735a3.1,3.1,0,0,1,.206-.936,4.7,4.7,0,0,1,.744,2.119l.109-.018a5.386,5.386,0,0,0-.826-3.447,5.569,5.569,0,0,0-.234,2.283",
    transform: "translate(-44.177 -40.381)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M54.463,43.953l-.114-.272a2.232,2.232,0,0,0-1.061-1.108,4.4,4.4,0,0,0,.244,1.465,1.688,1.688,0,0,1,.217.206c.293.047.713-.291.713-.291",
    transform: "translate(-43.61 -39.801)",
    fill: "#d0b86c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M54.344,40.747a3.622,3.622,0,0,0-.217,1.431c.08.036.552.323.769,2.233l.379-.247c-.176-3.224-.932-3.416-.932-3.416",
    transform: "translate(-43.176 -40.746)",
    fill: "#d0b86c"
  }))))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M37.579,41.684a5.871,5.871,0,0,0,1.6.46,9.138,9.138,0,0,0,1.882.1,10.859,10.859,0,0,0,2.387-.411,13.935,13.935,0,0,0,2.638-1.109c.923-.5,1.9-1.035,2.928-1.55s2.093-1.052,3.207-1.536,2.266-.941,3.439-1.351a31.4,31.4,0,0,1,3.591-.97,20.237,20.237,0,0,1,3.6-.413c.3,0,.59-.006.88-.009s.562.015.841.024c.559.026,1.1.059,1.63.1,1.052.076,2.044.179,2.953.276s1.735.17,2.466.188a8.047,8.047,0,0,0,1.876-.153,5.421,5.421,0,0,0,1.152-.4c.131-.061.225-.118.29-.155s.1-.053.1-.053l-.088.07c-.058.047-.143.115-.263.2a4.791,4.791,0,0,1-1.116.586,7.52,7.52,0,0,1-1.931.407,22.825,22.825,0,0,1-2.529.059c-.915-.012-1.9-.032-2.95-.05-.524-.009-1.061-.006-1.6,0l-.83.011-.823.039a23.454,23.454,0,0,0-3.4.489,33.885,33.885,0,0,0-3.433.965c-1.14.384-2.264.815-3.363,1.276s-2.173.932-3.207,1.408l-2.988,1.387a12.769,12.769,0,0,1-2.891.967,9.789,9.789,0,0,1-2.565.187,8.114,8.114,0,0,1-1.94-.34,6.279,6.279,0,0,1-1.16-.48,3.333,3.333,0,0,1-.379-.226",
    transform: "translate(19.456 17.979)",
    fill: "#2d154a"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M39.963,42.382l.461.1a5.271,5.271,0,0,1,1.231.552,16.2,16.2,0,0,1,1.714,1.194c.313.252.65.513,1,.8.17.144.346.294.527.443.087.071.191.168.266.222.093.074.19.15.287.225s.193.155.291.231.2.132.3.2a7.071,7.071,0,0,0,.63.4,15.42,15.42,0,0,0,1.4.736,16.127,16.127,0,0,0,3.249,1.02c.294.05.583.12.882.153s.6.067.9.1c.606.024,1.217.07,1.836.035a18.454,18.454,0,0,0,1.865-.15c.616-.127,1.242-.206,1.846-.395a19.462,19.462,0,0,0,3.52-1.281c.284-.152.568-.305.848-.452l.423-.223.384-.24c.255-.158.507-.316.759-.474q.362-.266.724-.531c.493-.337.909-.753,1.36-1.109.413-.4.841-.769,1.208-1.178.19-.2.373-.4.555-.6l.51-.607c.348-.387.637-.8.943-1.178.566-.783,1.078-1.518,1.5-2.189s.8-1.263,1.1-1.748.563-.862.741-1.111c.194-.241.3-.366.3-.366s-.083.14-.238.4-.332.678-.577,1.2A36.588,36.588,0,0,1,70.5,40.788,22.222,22.222,0,0,1,68.6,43.4c-.36.451-.783.864-1.2,1.308a18.318,18.318,0,0,1-1.392,1.234c-.246.194-.493.4-.751.592l-.817.549-.416.278-.416.235-.842.464c-.343.165-.618.281-.933.426s-.607.281-.927.387l-.955.34c-.317.114-.651.187-.977.279a19,19,0,0,1-1.99.4,18.407,18.407,0,0,1-2.014.141,15.528,15.528,0,0,1-7.32-1.688,14.315,14.315,0,0,1-1.448-.877,8.01,8.01,0,0,1-.653-.487l-.313-.25c-.093-.083-.184-.168-.272-.25-.742-.686-1.339-1.328-1.92-1.879a19.181,19.181,0,0,0-1.534-1.354,5.992,5.992,0,0,0-1.106-.7l-.443-.162",
    transform: "translate(20.69 18.099)",
    fill: "#2d154a"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M37.453,38.037a8.287,8.287,0,0,1,.51.894c.141.273.293.595.442.946s.266.744.4,1.129c.112.393.228.785.314,1.158s.162.722.211,1.026a8.446,8.446,0,0,1,.123,1.017,8.03,8.03,0,0,1-.478-.918c-.132-.279-.267-.606-.4-.961s-.26-.735-.386-1.119c-.055-.194-.111-.386-.165-.577s-.094-.386-.153-.566c-.1-.366-.188-.712-.25-1.012a8.875,8.875,0,0,1-.164-1.017",
    transform: "translate(19.39 19.693)",
    fill: "#2d154a"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M39.065,37.752a7.909,7.909,0,0,1,.367.949,16.974,16.974,0,0,1,.548,2.138,16.53,16.53,0,0,1,.275,2.189,8.027,8.027,0,0,1,0,1.018,8.4,8.4,0,0,1-.367-.95,17.258,17.258,0,0,1-.546-2.138,17.009,17.009,0,0,1-.275-2.19,7.829,7.829,0,0,1,0-1.015",
    transform: "translate(20.218 19.546)",
    fill: "#2d154a"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M40.3,38.1a7.612,7.612,0,0,1,.266.9,18.012,18.012,0,0,1,.346,1.985c.044.363.076.725.1,1.07.006.172.012.337.024.489s.02.305.024.44a7.164,7.164,0,0,1-.015.938,6.778,6.778,0,0,1-.348-.868,6.622,6.622,0,0,1-.253-.923c-.065-.338-.124-.7-.168-1.07a10.389,10.389,0,0,1-.083-1.081c-.006-.346-.006-.671.009-.949a6.552,6.552,0,0,1,.1-.93",
    transform: "translate(20.805 19.727)",
    fill: "#2d154a"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M58.814,33.965s.073.12.191.332a10.043,10.043,0,0,1,.445.9c.085.19.178.395.267.613s.2.449.276.7c.172.49.332,1.02.492,1.547.073.267.149.534.22.8a7.432,7.432,0,0,1,.165.783c.093.51.165.991.217,1.4.111.821.127,1.377.127,1.377s-.231-.515-.487-1.3c-.132-.392-.275-.848-.41-1.342s-.3-1.015-.454-1.539-.3-1.053-.411-1.554c-.131-.493-.26-.953-.349-1.358s-.162-.742-.217-.977-.073-.379-.073-.379",
    transform: "translate(30.45 17.585)",
    fill: "#2d154a"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M60.35,33.692s.193.414.416,1.043c.114.316.234.683.346,1.081s.235.824.349,1.249c.1.431.2.858.279,1.267.093.4.179.774.234,1.1a10.023,10.023,0,0,1,.149,1.114,9.618,9.618,0,0,1-.5-1c-.07-.153-.144-.322-.212-.5s-.155-.366-.214-.568c-.131-.4-.243-.826-.361-1.255-.1-.433-.214-.864-.273-1.279s-.123-.8-.155-1.131a8.35,8.35,0,0,1-.055-1.122",
    transform: "translate(31.244 17.444)",
    fill: "#2d154a"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M61.91,33.51s.165.332.363.833c.1.249.206.54.314.851s.226.645.328.98c.055.167.108.334.162.5s.091.331.147.486.1.307.14.452.077.288.117.411a6.4,6.4,0,0,1,.243.873,6.64,6.64,0,0,1-.578-.713c-.15-.228-.3-.511-.455-.817a4.209,4.209,0,0,1-.2-.484c-.062-.167-.124-.335-.187-.507s-.1-.348-.146-.518-.091-.345-.117-.51a7.906,7.906,0,0,1-.126-.92,4.7,4.7,0,0,1,0-.915",
    transform: "translate(32.042 17.349)",
    fill: "#2d154a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(45.497 43.769)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M34.928,32.576c-.055-1.465-1.566-4.153-3.331-3.684-1.809.48-1.856,2.752-1.322,4.16A6.393,6.393,0,0,0,32.2,36.074a3.864,3.864,0,0,0,2.186.853,37.257,37.257,0,0,1,.595-4.068.963.963,0,0,1-.053-.284",
    transform: "translate(-29.977 -28.838)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(98.243 35.009)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M70.366,24.659a2.716,2.716,0,0,0-4.306-.856,6.945,6.945,0,0,0-1.33,4.049c.548,1.311,1.076,2.633,1.6,3.954.162.407.314.82.46,1.231,2.741-1.683,5.022-5.365,3.571-8.378",
    transform: "translate(-64.73 -23.066)",
    fill: "#8ea2d1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(46.322 46.31)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M32.06,30.512a1.07,1.07,0,0,1-.282.024,1.219,1.219,0,0,0-.851.2,2.876,2.876,0,0,0,0,2.943c.272.519.694,1.157,1.336,1.251s1.3-.112,1.342-.894c.024-.451.023-.885.021-1.311a4.712,4.712,0,0,0-1.563-2.211",
    transform: "translate(-30.521 -30.512)",
    fill: "#7281a6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(99.36 37.447)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M69.235,28.29a3.4,3.4,0,0,0-.311-3.307,1.4,1.4,0,0,0-1.8.044,3.744,3.744,0,0,0-.461.624,12.19,12.19,0,0,0-1.2,4.108c.112.284.228.571.345.854a3.236,3.236,0,0,0,3.424-2.324",
    transform: "translate(-65.467 -24.673)",
    fill: "#7281a6"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(70.706 30.199)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M47.184,20.97a1.094,1.094,0,0,0-.123-.923c-.091-.147-.266-.238-.34-.02q-.016.048-.032.091a.321.321,0,0,0-.043.12.938.938,0,0,0-.059.29,1.828,1.828,0,0,0,.222.754c.042.093.167.212.273.134a.394.394,0,0,0,.094-.364c0-.027.006-.056.008-.082",
    transform: "translate(-46.587 -19.897)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M64.28,29.855a2.4,2.4,0,0,0-.127-.478c-.039-.1-.12-.27-.256-.249-.073-.041-.152-.024-.2.1l0,.017a.218.218,0,0,0-.058.077,1.547,1.547,0,0,0-.053,1.084,4.053,4.053,0,0,0,.044.59c.023.156.229.437.332.168,0-.012,0-.023.009-.033a.107.107,0,0,0,.064-.015.105.105,0,0,0,.121-.061l.011-.03a.15.15,0,0,0,.093-.109.988.988,0,0,0,.02-.187,1.691,1.691,0,0,0,.006-.874",
    transform: "translate(-37.826 -15.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(26.281 19.057)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M64.4,32.825a.46.46,0,0,0-.143-.346.13.13,0,0,0-.2.09.494.494,0,0,0-.012.065.229.229,0,0,0-.053.021c-.134.073-.09.352-.029.464-.009.155.038.431.179.457a.178.178,0,0,0,.1.1c.091.026.143-.087.149-.159l0-.068v-.03a2.081,2.081,0,0,0,0-.59",
    transform: "translate(-63.902 -32.454)",
    fill: "#fff"
  })))))))), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M64.364,35.3a.391.391,0,0,0-.068-.08c-.027-.076-.055-.15-.087-.223-.044-.09-.188-.2-.261-.071a1.661,1.661,0,0,0-.141.364.335.335,0,0,0-.1.185,3.2,3.2,0,0,0,.172,1.808.453.453,0,0,0,.211.243.1.1,0,0,0,.1.006.562.562,0,0,1,.035.049c.1.114.2.077.253-.047a2.272,2.272,0,0,0-.112-2.233",
    transform: "translate(32.953 18.05)",
    fill: "#fff"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M35.912,34.715a3.318,3.318,0,0,0-.168-.522c-.041-.1-.223-.375-.332-.165-.026.052-.039.1-.062.155-.111-.149-.29-.173-.287.134,0,.172.017.341.027.508a1.765,1.765,0,0,0,.141,1.26c.023.194.047.389.068.583s.229.65.393.291a3.358,3.358,0,0,0,.153-.405c.077.038.159,0,.194-.1a2.074,2.074,0,0,0-.127-1.736",
    transform: "translate(18.137 17.578)",
    fill: "#fff"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(54.684 59.009)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M36.731,39.27c-.012-.038-.021-.076-.036-.111-.049-.129-.112-.181-.17-.184l-.024-.029c-.055-.058-.158-.111-.208-.011a1.19,1.19,0,0,0-.049.121c-.079-.046-.164-.021-.188.138a2.014,2.014,0,0,0,.05.867,1.975,1.975,0,0,0,.294.559,1.273,1.273,0,0,0,.042.143c.036.1.091.137.14.123.071.077.167.1.22-.035a.042.042,0,0,1,.006-.021.223.223,0,0,0,.1-.159c.006-.087,0-.17.006-.257a1.757,1.757,0,0,0-.184-1.144",
    transform: "translate(-36.03 -38.88)",
    fill: "#fff"
  }))))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(64.725 51.753)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M43.3,34.313l0-.03h0c0-.018-.006-.038-.011-.059-.061-.184-.217-.153-.229.023-.039.009-.065.061-.071.131-.083-.108-.2-.076-.24.068-.068.021-.118.114-.094.272.041.284.077.568.121.851.011.094.088.29.216.269a.117.117,0,0,0,.064-.041c.012.036.023.074.036.112.049.138.217.212.237.011a4.493,4.493,0,0,0-.023-1.606",
    transform: "translate(-42.646 -34.098)",
    fill: "#fff"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(68.158 43.268)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M45.578,28.887a.486.486,0,0,0-.008-.064.114.114,0,0,0,0-.023h0c-.02-.117-.071-.255-.184-.287a.108.108,0,0,0-.143.077l-.021-.023c-.123-.09-.206.044-.225.152a.206.206,0,0,0-.085.149.536.536,0,0,0,.064.319,1.823,1.823,0,0,0-.052.307.539.539,0,0,0,.111.266.52.52,0,0,0,.1.335c.091.112.206.083.257-.047a2.747,2.747,0,0,0,.185-.974c0-.029,0-.061,0-.093s0-.062,0-.094",
    transform: "translate(-44.908 -28.508)",
    fill: "#fff"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(68.909 68.768)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M46.326,46.388h0a1.272,1.272,0,0,0-.083-.332c-.02-.062-.047-.126-.07-.19a.547.547,0,0,0-.042-.127.537.537,0,0,0-.017-.067l0-.029A.4.4,0,0,0,46.1,45.6v0a.27.27,0,0,0-.158-.2.1.1,0,0,0-.1.035v0l-.018,0a.554.554,0,0,0-.058-.076c-.158-.188-.2.185-.14.294l.006.008a.866.866,0,0,0,0,.09c-.012-.009-.024-.021-.035-.027-.232-.135-.231.313-.109.48l0,.006a1.333,1.333,0,0,1,.106.1.663.663,0,0,0,.22.216c.017.015.03.03.049.044.124.123.194.194.37.161.138-.03.138-.2.1-.345",
    transform: "translate(-45.403 -45.309)",
    fill: "#fff"
  }))))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M12.087,63.239a9.857,9.857,0,0,0-1.193-.05q-.826,0-2.084.059l-.093,0-.243-.07C7.162,62.808,5.11,61.359,2.2,58.75l-.064-.058-.044-.073C.628,56.173.1,54.016.51,52.2A3.7,3.7,0,0,1,.7,50.355l.176-.618c.666-2.33,3.29-3.92,8.023-4.866l.137-.027.132.039c.02,0,.071,0,.137,0a34.52,34.52,0,0,0,3.8-.451l.121-.018,1.572.449.087.067a16.61,16.61,0,0,0,1.349,1l.449.124a4.393,4.393,0,0,0,.346-.678l.082-.191.185-.093a2.354,2.354,0,0,1,1.017-.311h.079l.188.036.091.026.077.055a1.8,1.8,0,0,1,.78,2.073l-.214.744c-1.471,3.268-2.123,4.137-2.6,4.357a1.623,1.623,0,0,1-1.088.624l-.134.026-.656-.187-.065-.039c-.47-.288-.733-.958-.838-2.158a5.442,5.442,0,0,0-.949-.76c-.912-.074-1.767-.127-2.413-.127a4.015,4.015,0,0,0-1.187.112l-.068.08a6.85,6.85,0,0,0-1.328,2.607c-.106,2.545.48,2.791.548,2.809l.164.049.111.127a21.7,21.7,0,0,0,3.553,2.826c.094-.058.49-.217,1.421-.7l.2-.1.668.191c.739.211.8,1.185.249,4.011l-.44,1.548c-.158.549-.8.68-1.012.722l-.181.036-1.176-.53",
    transform: "translate(0.194 22.997)",
    fill: "#fff"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M13.375,45.2l1.346.384a13.028,13.028,0,0,0,1.471,1.072l.757.217a.122.122,0,0,0,.041.006q.287,0,.748-1.072a1.926,1.926,0,0,1,.76-.25.407.407,0,0,1,.111.015,1.229,1.229,0,0,1,.559,1.449l-.214.744q-1.814,4.014-2.392,4.013a.192.192,0,0,1-.042,0c-.082.29-.355.48-.815.571l-.449-.127q-.471-.289-.583-1.943a5.813,5.813,0,0,0-1.316-1.028q-1.594-.159-2.6-.159-1.578,0-1.688.392A7.377,7.377,0,0,0,7.631,52.3q-.153,3.2.938,3.514a22.815,22.815,0,0,0,3.823,3.034.149.149,0,0,0,.039,0,6.953,6.953,0,0,0,1.8-.782l.449.127q.474.137-.153,3.356l-.428,1.5c-.042.144-.235.252-.578.32l-1.008-.454a6.363,6.363,0,0,0-1.43-.1q-.836,0-2.11.059l-.153-.042Q7,62.314,2.773,58.525.585,54.864,1.322,52.284q-.269-.075.121-1.588l.172-.6q.895-3.13,7.587-4.465a1.19,1.19,0,0,0,.293.026,34.345,34.345,0,0,0,3.881-.457m.074-1.163-.244.038a32.178,32.178,0,0,1-3.711.443l-.05,0-.194-.056-.272.055C4.017,45.5,1.25,47.225.52,49.781l-.172.6A4.883,4.883,0,0,0,.12,52.417c-.389,1.929.175,4.177,1.676,6.692l.088.149.129.115c3.02,2.7,5.084,4.152,6.5,4.556l.155.044.179.05.185-.008q1.243-.059,2.057-.059a8.088,8.088,0,0,1,1.07.047l.9.407.334.15.358-.073A1.679,1.679,0,0,0,15.2,63.365l.428-1.5.014-.047.009-.049c.484-2.485.721-4.274-.65-4.667l-.451-.127-.436-.124-.4.209c-.548.287-.9.451-1.111.545a18.877,18.877,0,0,1-3.166-2.535l-.223-.258-.226-.065a4.9,4.9,0,0,1-.222-2.261,6.255,6.255,0,0,1,1.128-2.208,5.3,5.3,0,0,1,.873-.053c.578,0,1.334.044,2.249.131.1.07.272.206.568.466.14,1.273.474,1.993,1.085,2.366l.132.08.147.042.449.127.264.076.269-.053a2.25,2.25,0,0,0,1.352-.735c.656-.4,1.378-1.534,2.715-4.492l.033-.076.024-.08.212-.744a2.36,2.36,0,0,0-1-2.7l-.156-.109-.182-.052a1.513,1.513,0,0,0-.425-.059,2.879,2.879,0,0,0-1.272.372l-.37.187-.164.381c-.035.08-.067.152-.1.214-.146-.1-.47-.34-1.176-.886l-.173-.135-.212-.061L13.688,44.1Z",
    transform: "translate(0 22.799)",
    fill: "#231f20"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M20.351,65.718a14.866,14.866,0,0,1-3.06-.281c-3.457-.741-5.526-3.189-6.147-7.273a26.233,26.233,0,0,1,.827-7.029c.446-2.085,2.313-3.524,5.547-4.275l.124-.029.124.026a1.772,1.772,0,0,0,.256.011c.586,0,1.8-.087,3.6-.261.1-.006.182-.009.267-.009a6.369,6.369,0,0,1,1.31.156c4.275.917,6.687,2.712,7.171,5.335.537,1.179.566,2.844.087,5.084-1.052,4.905-4.256,7.775-9.522,8.533Zm-3.06-11.7A4.448,4.448,0,0,0,19.6,59.16a5.438,5.438,0,0,0,3.369-1.688,6.853,6.853,0,0,0,.932-1.868c.064-1.629-.091-3.734-1.266-3.986l-.455-.1a5.178,5.178,0,0,0-1.091-.121,4.305,4.305,0,0,0-3.758,2.418Z",
    transform: "translate(5.754 24.126)",
    fill: "#fff"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M22.091,47.362a5.755,5.755,0,0,1,1.19.144q6.131,1.314,6.743,4.951.763,1.582.077,4.791-1.5,7.005-9.047,8.088c-.173,0-.343.006-.51.006a14.263,14.263,0,0,1-2.94-.267q-4.824-1.036-5.7-6.8a26.178,26.178,0,0,1,.821-6.822q.6-2.793,5.121-3.841a2.1,2.1,0,0,0,.376.023q.908,0,3.658-.263c.07,0,.141-.008.214-.008m-2.43,12.574a5.992,5.992,0,0,0,3.907-1.864,7.779,7.779,0,0,0,1.088-2.155q.189-4.255-1.7-4.661l-.457-.1a5.791,5.791,0,0,0-1.21-.135A4.9,4.9,0,0,0,16.995,53.8l-.065.3q-.808,3.77,2.732,5.839m6.516-2.9.208-.269.162-.757.021-.8-.313-.067-.328,1.527a.311.311,0,0,0,.249.366m-6.045,4.336a4.308,4.308,0,0,1-.92-.1,4.865,4.865,0,0,1-2.387-1.466l-.067.313a3.319,3.319,0,0,0,2.322,1.767l.914.2a2.067,2.067,0,0,0,.439.046,6.387,6.387,0,0,0,3.592-1.733,5.789,5.789,0,0,0,1.369-1.929l.033-.158-.156-.033q-2.563,3.1-5.139,3.1m1.959-15.147c-.1,0-.193,0-.284.009q-2.741.262-3.588.261a1.5,1.5,0,0,1-.181-.006l-.249-.053-.2.065c-3.468.806-5.479,2.39-5.975,4.711a26.855,26.855,0,0,0-.842,7.156l0,.038.006.039c.66,4.342,2.878,6.948,6.59,7.743a15.388,15.388,0,0,0,3.178.293c.176,0,.355,0,.536-.006l.068,0,.068-.009c5.528-.794,8.891-3.814,10-8.976a8.958,8.958,0,0,0-.1-5.376c-.555-2.834-3.11-4.758-7.6-5.719a6.8,6.8,0,0,0-1.428-.17m-4.025,8a3.743,3.743,0,0,1,3.222-2.066,4.762,4.762,0,0,1,.971.109l.457.1c.451.1.9,1.038.807,3.383a7.361,7.361,0,0,1-.844,1.6,4.9,4.9,0,0,1-2.747,1.419,3.848,3.848,0,0,1-1.891-4.43Z",
    transform: "translate(5.558 23.932)",
    fill: "#231f20"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M27.82,71.221l-2.137-.146.076-.457a1.309,1.309,0,0,0-.2-.087,12.451,12.451,0,0,1-1.7-.124l-.282-.046-.639-1.234.168-.275c.858-1.4,1.014-1.692,1.04-1.754a52.154,52.154,0,0,1,2.011-7.674,12.562,12.562,0,0,1,.062-3.032,4.041,4.041,0,0,1-.6-2.2l.052-.317c.165-.993,1.663-.993,2.227-.993.361,0,.78.02,1.254.059a2.015,2.015,0,0,1,.751-.1,36.506,36.506,0,0,1,4.165.422l.282.038.138.249a3.867,3.867,0,0,1,.279,1.908Q33.859,60.038,31.938,67a5.853,5.853,0,0,0,1.223,2.817l.165.2-.146.873c-.079.484-.581.753-1.064.952l-.149.061Zm6.106-18.49-.713-.335a2,2,0,0,1-1.319.43,3.551,3.551,0,0,1-.572-.049c-.238-.041-.363-.124-.83-.824l-.964.691-2.076-.34c-.489-.08-.75-.587-.941-1.072l-.058-.147.027-.158a7.437,7.437,0,0,1,.232-.736c-.952-1.6-1.024-2.176-.967-2.53l.076-.46c.331-2.008,2.1-3.131,5.253-3.336l.747.108c2.586.425,4.271,1.48,5.01,3.137l.049.109.008,1.065-.033.255a6.828,6.828,0,0,1-.941,1.952,1.862,1.862,0,0,0,.237.574l.1.175-.032.2A1.587,1.587,0,0,1,35,52.863l-.111.026Zm-1.4-3.438a3.258,3.258,0,0,0,.518.047c.656,0,.833-.263.9-.657l.179-1.094-.024-.023a5.514,5.514,0,0,0-2.031,1.645l.009.008ZM29.38,48.3c.053.009.152.014.152.014.126,0,.216,0,.267-.314,0,.011-.006.015-.011.015a.853.853,0,0,0-.343-.118l-.179-.029c-.012.012-.027.026-.044.046l-.053.323c.011.009.024.023.041.035Z",
    transform: "translate(11.875 22.71)",
    fill: "#fff"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M31.333,44.628l.619.1q3.592.59,4.58,2.808l.008.947-.026.158a8.585,8.585,0,0,1-.946,1.887,1.727,1.727,0,0,0,.307,1.009,1.041,1.041,0,0,1-.78.967l-.777-.127L33.3,51.9a1.331,1.331,0,0,1-1.185.552,2.893,2.893,0,0,1-.48-.042,5.173,5.173,0,0,1-.769-1.072l-1.257.9-1.843-.3c-.158-.026-.326-.264-.505-.718.014-.077.112-.378.3-.9a5.159,5.159,0,0,1-1.031-2.372l.076-.461q.423-2.579,4.728-2.859m1.937,5.477a1.287,1.287,0,0,0,1.46-1.135l.2-1.223q.036-.223-.384-.536l-.317-.052q-2.429,1.371-2.6,2.41l.411.379.619.1a3.784,3.784,0,0,0,.61.055m-3.515-1.024q.7,0,.829-.791-.059-.633-.823-.757l-.316-.052-.032,0c-.135,0-.3.129-.5.387l-.1.606c-.024.15.1.329.386.537l.316.052a1.581,1.581,0,0,0,.244.021m.369,4.526a36.456,36.456,0,0,1,4.087.416,3.487,3.487,0,0,1,.208,1.615q-.9,4.489-2.84,11.526a6.416,6.416,0,0,0,1.366,3.212l-.1.618c-.026.159-.266.331-.719.518l-3.989-.656-1.565-.108q.057-.341-.688-.586a12.379,12.379,0,0,1-1.71-.118l-.358-.7a21.438,21.438,0,0,0,1.09-1.862,53.4,53.4,0,0,1,2.076-7.865,10.1,10.1,0,0,1,.042-3.142,3.977,3.977,0,0,1-.619-1.994l.052-.316q.087-.517,1.665-.516c.4,0,.868.024,1.41.074.012-.08.211-.12.595-.12m1.266-10.123-.131.009c-4.3.279-5.515,2.227-5.776,3.809l-.076.463c-.087.521.042,1.193.9,2.682a3.693,3.693,0,0,0-.17.581l-.053.311.115.294a2.96,2.96,0,0,0,.59,1,1.713,1.713,0,0,0-1.463,1.343l-.052.317a4.239,4.239,0,0,0,.581,2.4,14.564,14.564,0,0,0-.068,2.89,54.683,54.683,0,0,0-1.987,7.557c-.087.159-.323.568-.964,1.61l-.335.548.294.571.36.694.263.508.565.093a11.438,11.438,0,0,0,1.339.12l-.083.51,1.249.087,1.51.1,3.937.647.319.053.3-.124c.379-.155,1.267-.522,1.408-1.386l.1-.616.083-.51-.329-.4a5.162,5.162,0,0,1-1.079-2.427c1.263-4.6,2.2-8.417,2.791-11.362l.02-.1,0-.1a4.738,4.738,0,0,0-.272-2.04l.067-.015A2.169,2.169,0,0,0,37,51.724l.065-.392-.194-.348c-.053-.1-.09-.172-.115-.229a6.39,6.39,0,0,0,.883-1.926l.026-.161.015-.1v-.1l-.008-.947,0-.238-.1-.217c-.821-1.843-2.65-3.01-5.436-3.466l-.618-.1Z",
    transform: "translate(11.652 22.513)",
    fill: "#231f20"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M48.407,70.819c-.334-.036-.595-.247-1.106-1.278-.36.413-.633.578-.924.578l-.763-.082-.146-.168A20.584,20.584,0,0,1,42.113,63.7l-.049-.127.017-.135c.03-.285-.1-1.316-2.022-4.752l-.042-.076s-.079-.36-.106-.474L39.7,60.041a35.652,35.652,0,0,1-1.05,5.417,4.473,4.473,0,0,1,.527,2.041l-.032.3c-.124,1.1-1.821,1.264-3.465,1.284l-1.767-.193c-.5-.055-1.272-.093-2.283-.108l-.335-.006-.507-.95.112-1.017.181-.146c1.4-1.147,1.6-1.732,1.622-1.929a2.952,2.952,0,0,0-.3-.842l-.1-.223.093-.225a6.432,6.432,0,0,0,.474-1.673l1.147-10.305,1.381-.958c.22-1.155.774-1.407,1.214-1.407l.216.024a12.131,12.131,0,0,1,2.2.771,2.2,2.2,0,0,1,.729-.132l.19.011.159.017c.923.1,1.047,1.387,1.076,2.128.949,1.064,2.158,3.521,3.688,7.49.115.282.216.525.3.732.7-4.412,1.079-6.177,1.4-6.881-.065-.12-.173-.308-.354-.595l-.106-.168.058-.516c.106-.947,1.389-1.075,2.63-1.075a31.74,31.74,0,0,1,3.365.231l.27.03.146.228a4.836,4.836,0,0,1,.521,2.029l-.035.425-.033.294-.26.143c-.663.363-.779.75-.807,1.011a28.837,28.837,0,0,0-.836,4.6l-.448,4.017a2.25,2.25,0,0,1-.413,1.028l-.109,2.327c-.121.434-.2.7-.238.844a3.133,3.133,0,0,1,.141,1.369l-.035.307c-.055.5-.565.8-1,1.008l-.146.067Z",
    transform: "translate(15.939 25.424)",
    fill: "#fff"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M36.812,49.868l.058,0q2.274.656,2.251.882a2.007,2.007,0,0,1,.836-.222.851.851,0,0,1,.126.008l.159.017q.53.059.578,1.8,1.355,1.334,3.718,7.461a8.737,8.737,0,0,0,1.011,2.14l.193-.287q1.25-8.107,1.676-8.108h.006a3.3,3.3,0,0,0-.521-1l.036-.319Q47,51.673,49,51.673a31.087,31.087,0,0,1,3.3.228,4.5,4.5,0,0,1,.433,1.779l-.035.305a1.885,1.885,0,0,0-1.1,1.448,28.209,28.209,0,0,0-.835,4.6l-.448,4.017a1.83,1.83,0,0,1-.408.894l-.117,2.5a9.192,9.192,0,0,0-.263.911,2.547,2.547,0,0,1,.167,1.266l-.033.305c-.018.168-.246.354-.68.555l-.319-.035q-.237-.027-.917-1.512l-.319-.036q-.615.845-.859.844l-.014,0L46.1,69.69a19.943,19.943,0,0,1-3.251-6q.125-1.129-2.09-5.092Q40.423,57,40,56.959c-.208,0-.32.094-.34.27l-.328,2.943a34.888,34.888,0,0,1-1.084,5.515,5.314,5.314,0,0,1,.562,1.943l-.033.305q-.084.742-2.906.777l-1.7-.19q-.783-.087-2.337-.112l-.267-.5.068-.61q1.73-1.418,1.827-2.307a2.763,2.763,0,0,0-.343-1.138,7.024,7.024,0,0,0,.513-1.821l1.119-10.049,1.367-.949q.157-1.168.691-1.169m0-1.138h0c-.515,0-1.372.226-1.721,1.636l-.985.683-.426.3-.056.515L32.5,61.908a5.934,5.934,0,0,1-.434,1.518l-.185.454.2.445a4.366,4.366,0,0,1,.231.595,4.73,4.73,0,0,1-1.4,1.5l-.358.293-.052.461-.068.609-.039.352.167.311.267.5.316.592.669.011c.993.017,1.744.052,2.23.106l1.7.188.07.008h.071c1.242-.015,3.826-.047,4.022-1.788l.033-.31a4.486,4.486,0,0,0-.493-2.135,36.172,36.172,0,0,0,1-5.192c1.261,2.425,1.269,3.07,1.264,3.143l-.014.241.08.281a21.117,21.117,0,0,0,3.456,6.344l.291.337.443.05.463.052.064.006.077,0a1.371,1.371,0,0,0,.768-.24,1.6,1.6,0,0,0,1.2.936l.319.036.319.035.29-.135c.335-.158,1.231-.575,1.328-1.462l.035-.3a3.747,3.747,0,0,0-.114-1.442c.038-.121.093-.3.162-.521l.044-.141.008-.147.1-2.172a2.722,2.722,0,0,0,.417-1.147l.448-4.016a27.186,27.186,0,0,1,.8-4.414l.027-.094.012-.1c.009-.094.033-.313.515-.575l.519-.284.067-.589.033-.3.014-.121-.012-.121a5.235,5.235,0,0,0-.607-2.278l-.293-.457-.539-.059A32.152,32.152,0,0,0,49,50.535c-.9,0-3.02,0-3.2,1.581l-.035.317-.044.4.212.337c.085.135.152.246.2.335a33.1,33.1,0,0,0-1.008,4.725c-1.6-3.986-2.566-5.573-3.2-6.333-.055-.892-.294-2.325-1.572-2.468l-.158-.018a2.321,2.321,0,0,0-.253-.014,2.608,2.608,0,0,0-.671.09,14.724,14.724,0,0,0-2.1-.706l-.093-.026-.1-.011-.062-.008Z",
    transform: "translate(15.739 25.229)",
    fill: "#231f20"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M53.437,68.935q-2.261,0-5.188-.042l-.592-.009.023-.436a6.22,6.22,0,0,0-1.694-.619l-.258-.068-.313-.684.043-.864,2.43-1.921a3.054,3.054,0,0,1-.352-.548l-.074-.138.042-.833.144-.153c.783-.821,3.655-3.2,8.775-7.279l-7.164.047-.393-.094L48.8,56.665c-.024.486-.486.809-.933,1.061l-.144.082-.484-.026c-.5-.026-.812-.5-1.055-.961l-.073-.138.09-1.715a18.746,18.746,0,0,0-.135-3.48c.044-1.029,1.345-1.21,3.579-1.21.747,0,1.629.026,2.65.077q.936.048,3.765.047h.263a29.487,29.487,0,0,0,3.278.474,2.361,2.361,0,0,1,1.008-.253l1.02.05c.572.029.842.627.93.824l.056.126-.039.8-.551.627a4.932,4.932,0,0,0,.642.974l.138.17-.052,1.04-.127.146a21.426,21.426,0,0,1-3.533,3.345c-3.095,2.925-4.426,4.307-4.993,4.96l2.808.143a24.82,24.82,0,0,0,3.2-1.906l1-.537.182.024c2.208.288,2.477,1.537,2.439,2.255-.056,1.149-.234,4.571-2.366,4.781-.568.32-2.333.49-7.915.49",
    transform: "translate(23.513 26.031)",
    fill: "#fff"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M49.838,51.041q1.106,0,2.62.077.945.048,3.8.049l.263,0a25.584,25.584,0,0,0,3.4.481,1.968,1.968,0,0,1,.889-.261l.059,0,.932.049c.15.008.3.172.442.49l-.023.466-.653.742a4.8,4.8,0,0,0,.861,1.446l-.032.625a20.791,20.791,0,0,1-3.439,3.257q-5.571,5.259-5.6,5.79l.3.162,3.424.176h.009a15.976,15.976,0,0,0,3.526-2l.8-.428q2.017.264,1.946,1.663-.219,4.25-2.009,4.25l-.079,0q-.025.485-7.627.483-2.256,0-5.178-.041.025-.469-2.123-1.044l-.144-.316.024-.466,2.6-2.058.015-.305c-.168-.009-.366-.228-.593-.659l.023-.466q1.2-1.261,9.6-7.924a.271.271,0,0,0-.29-.322l-8.111.053-.765-.2-.176.311-.087,1.706c-.009.159-.223.358-.645.595l-.32-.017c-.159-.009-.354-.228-.58-.657l.079-1.559a19.008,19.008,0,0,0-.138-3.588q.03-.562,3.016-.563m0-1.138h0c-1.717,0-4.066,0-4.153,1.644l0,.108.015.106a18.121,18.121,0,0,1,.127,3.372l-.079,1.56L45.728,57l.146.276c.193.364.642,1.219,1.53,1.264l.317.017.331.017.287-.161c.354-.2,1.181-.663,1.225-1.53l.038-.738,5.38-.035c-4.342,3.471-6.818,5.54-7.546,6.306l-.291.307-.021.42-.023.466-.017.313.147.278c.023.046.053.1.088.164L45.506,65.8l-.405.32-.026.515-.024.466-.014.279.117.255.144.314.223.484.515.14a9.681,9.681,0,0,1,1.255.407l-.035.659,1.182.017q2.932.043,5.2.042c5.049,0,7.191-.1,8.1-.507,1.659-.237,2.585-2.017,2.753-5.3.036-.736-.175-2.489-2.935-2.849l-.363-.047-.322.172-.8.428-.041.021-.039.026a26.791,26.791,0,0,1-3.029,1.808l-1.421-.073c.766-.792,2.037-2.049,4.14-4.037a22.118,22.118,0,0,0,3.573-3.391l.252-.3.02-.387.032-.625.023-.44-.279-.34a5.033,5.033,0,0,1-.39-.537l.156-.178.261-.3.021-.4.023-.466.015-.275-.114-.252A1.664,1.664,0,0,0,61.847,50.3l-.93-.049-.029,0-.088,0a2.813,2.813,0,0,0-1.108.244,26.936,26.936,0,0,1-2.958-.443l-.108-.021h-.375c-1.876,0-3.134-.015-3.737-.046-1.023-.052-1.923-.079-2.677-.079",
    transform: "translate(23.317 25.837)",
    fill: "#231f20"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M66.532,70.739c-3.5,0-6.031-1.943-7.51-5.773a26.213,26.213,0,0,1-.71-7.042c-.014-2.132,1.5-3.942,4.494-5.373l.114-.055h.127a26.707,26.707,0,0,0,3.717-1.079,5.916,5.916,0,0,1,1.571-.2h0c4.432,0,7.126,1.232,8.152,3.661.782,1.037,1.169,2.656,1.182,4.946.033,5.016-2.474,8.51-7.454,10.387a15.729,15.729,0,0,1-3.623.525Zm-2.4-11.145A4.449,4.449,0,0,0,67.5,64.112a5.435,5.435,0,0,0,2.925-2.377,6.865,6.865,0,0,0,.507-2.025c-.287-1.6-.891-3.62-2.088-3.62v-.569l-.006.569-.467,0c-2.094.015-3.482,1.091-4.237,3.289Z",
    transform: "translate(30.19 26.518)",
    fill: "#fff"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M68.676,51.983q6.142,0,7.508,3.378,1.088,1.38,1.111,4.662.046,7.162-7.086,9.85a15.116,15.116,0,0,1-3.426.489h-.056q-4.892,0-6.982-5.409a26.2,26.2,0,0,1-.671-6.839q-.02-2.855,4.169-4.857a26.894,26.894,0,0,0,3.887-1.1,5.266,5.266,0,0,1,1.4-.17h.144M67.682,64.9a5.991,5.991,0,0,0,3.41-2.664,7.781,7.781,0,0,0,.6-2.339q-.733-4.184-2.658-4.184h-.009l-.469,0q-3.563.023-4.805,3.765l0,.307q.025,3.857,3.928,5.112m5.732-4.239h0l.144-.308,0-.774-.152-.786-.32,0,.011,1.562c.036.2.144.305.319.305M67.508,66.3a4.894,4.894,0,0,1-2.624-.915l0,.319a3.325,3.325,0,0,0,2.623,1.223h.027l.933-.006q1.548-.009,3.573-2.516a5.8,5.8,0,0,0,.92-2.181l0-.159H72.8q-2.16,4.216-5.268,4.236h-.024m1.169-15.458h-.152a6.322,6.322,0,0,0-1.707.214,30.83,30.83,0,0,1-3.624,1.064l-.253,0-.185.108c-3.213,1.534-4.834,3.515-4.817,5.89a26.816,26.816,0,0,0,.722,7.17l.011.036.015.035c1.572,4.074,4.277,6.138,8.042,6.138a16.332,16.332,0,0,0,3.752-.521l.067-.017.064-.024c5.226-1.97,7.859-5.644,7.824-10.923a8.946,8.946,0,0,0-1.255-5.227c-1.141-2.618-4-3.945-8.5-3.945m-3.784,8.827a3.654,3.654,0,0,1,3.671-2.815l.466,0c.464,0,1.1.824,1.521,3.13a7.424,7.424,0,0,1-.481,1.739A4.907,4.907,0,0,1,67.695,63.7a3.847,3.847,0,0,1-2.8-3.919Z",
    transform: "translate(29.996 26.324)",
    fill: "#231f20"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M72.608,71.867a4.938,4.938,0,0,1-1.849-1.29l-.121-.143-.042-.653c-.026-.378.126-.637,1.791-1.729.1-2.865-.017-7.589-.345-14.051a8.088,8.088,0,0,1-.287-1.931l-.02-.285.955-.815.659-.044a.917.917,0,0,1,.651.282c.14-.448.395-.82.87-.851.124-.009.243-.014.358-.014a2.526,2.526,0,0,1,2,.744l.713-.153.411-.032c.42,0,.642.074,3.268,4.307a2.893,2.893,0,0,0,.674.533c.291-.305,1.094-1.258,3.295-4.177.653-.794,2.073-1.249,4.468-1.443a2.819,2.819,0,0,1,1.123-1.568l.115-.067.6-.041c1.006,0,1.443,1.267,1.67,4.67.152,2.277.132,6.507-.058,12.573,1.692.555,2.116.947,2.222,1.381l.067.871-.074.143c-.719,1.374-1.568,2.1-2.521,2.164l-3.741.249c-.087.021-.454.144-1.067.358l-.073.026-.968.065-.112-.041a2.175,2.175,0,0,1-1.272-2.149l-.015-.22.138-.173a2.9,2.9,0,0,1,1.651-.848,1.461,1.461,0,0,1-.669-1.024c-.118-1.776-.188-3.564-.206-5.312-.141-.915-.252-1.858-.328-2.768-.319.338-.965,1.084-2.266,2.727l-.156.2-2.586.172-.146-.079a16.392,16.392,0,0,1-2.36-1.638l.484,7.274-.27.345c.416.1,1.137.252,2.38.452l.226.035.578.765.042.636c.059.889-1,1.383-3.77,1.742-.505.276-1.923.5-5.808.87l-.146.014Z",
    transform: "translate(36.548 25.083)",
    fill: "#fff"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M92.146,49.209q.769,0,1.046,4.14.232,3.488-.073,12.946,2.142.66,2.252,1.106l.041.613q-.936,1.787-2.055,1.861l-3.74.249a10.609,10.609,0,0,0-1.217.389l-.773.052q-.808-.294-.9-1.651a3.089,3.089,0,0,1,1.821-.75l.14-.316-.021-.32q-.81-.508-.833-.88-.178-2.648-.206-5.28-.266-1.787-.373-3.41a1.26,1.26,0,0,0-.455-.131l-.021,0a17.627,17.627,0,0,0-2.759,3.151l-2.169.146a18.112,18.112,0,0,1-2.95-2.143c-.209.05-.31.158-.3.328l.518,7.772a3.464,3.464,0,0,0-.56.812,12.3,12.3,0,0,0,3.163.725l.337.446.032.466q.048.731-3.5,1.169.02.305-5.559.839A4.349,4.349,0,0,1,71.388,70.4l-.032-.464q-.014-.214,1.78-1.377.18-4.3-.337-14.482a6.95,6.95,0,0,1-.284-1.853l.593-.507.466-.032h.006q.219,0,1,1.029.082-1.569.522-1.6c.111-.008.217-.012.319-.012a1.807,1.807,0,0,1,1.753.81l1.081-.234.307-.02h0q.262,0,2.767,4.04.833.849,1.272.85l.029,0q.266-.018,3.606-4.451.831-1,4.436-1.245a2.666,2.666,0,0,1,.99-1.616l.464-.032h.02m0-1.138h-.038l-.056,0-.466.032-.269.017-.231.135a3.112,3.112,0,0,0-1.235,1.524c-2.375.226-3.775.727-4.492,1.6-1.665,2.208-2.516,3.274-2.949,3.787-.055-.049-.114-.1-.181-.172-2.776-4.467-2.95-4.467-3.667-4.467h-.036l-.039,0-.307.02-.083,0-.082.018-.414.09a3.225,3.225,0,0,0-2.179-.692c-.126,0-.258,0-.395.014a1.363,1.363,0,0,0-1.075.622,1.25,1.25,0,0,0-.37-.055h-.039l-.047,0-.461.03-.376.026-.287.244-.593.508-.436.37.039.571a9.024,9.024,0,0,0,.29,2c.314,6.191.431,10.77.349,13.631-1.364.9-1.849,1.355-1.8,2.082l.03.464.026.372.24.285a5.467,5.467,0,0,0,2.06,1.446l.267.117.291-.029c3.409-.325,5.112-.518,5.922-.883,2.217-.288,4.275-.745,4.169-2.333l-.03-.466-.023-.34-.2-.27-.337-.446-.276-.366-.452-.073c-.709-.112-1.238-.209-1.633-.288l-.014-.2-.387-5.8a13.984,13.984,0,0,0,1.436.918l.291.159.331-.023,2.17-.144.5-.035.314-.395c.589-.745,1.04-1.3,1.383-1.714.056.487.121.983.2,1.486.02,1.733.09,3.5.206,5.265a1.606,1.606,0,0,0,.226.713,2.671,2.671,0,0,0-1.085.766l-.276.345.03.442a2.674,2.674,0,0,0,1.647,2.645l.225.082L87.7,71.7l.771-.052.155-.011.147-.052c.654-.229.908-.307,1-.332l3.659-.244c1.164-.077,2.169-.908,2.988-2.468l.149-.284-.021-.32-.041-.613-.008-.1-.023-.1c-.168-.684-.748-1.138-2.195-1.65.182-5.934.2-9.932.044-12.206-.225-3.375-.639-5.2-2.181-5.2",
    transform: "translate(36.354 24.888)",
    fill: "#231f20"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M92.068,69.939c-2.006,0-3.1-.592-3.252-1.759l-.39-1.366.323-.232a1.726,1.726,0,0,0,.675-.935q-.628-3.656-.68-4.049c-.361-3.589-.543-6.173-.542-7.7a11.194,11.194,0,0,0-.892-.844l-.161-.143-.067-.518c-.108-.827.859-1.483,3.553-2.39a1.228,1.228,0,0,1,.759-.314l1.853-.24,2.146-.738a4.492,4.492,0,0,1,.75-.067c2.031,0,3.894,1.281,5.541,3.8l.071.109.017.129c.1.813.279,1.779.516,2.87l.036.161-.058.155a9.4,9.4,0,0,0-.707,3.618,1.086,1.086,0,0,0,.454.117l1.319-.164c1.2,0,1.553,1.6,1.776,3.328.085.651-.234,1.71-3.233,4.644l-.062.061-.079.041a18.171,18.171,0,0,1-5.276,1.965l-2.316.3a16.575,16.575,0,0,1-2.075.152m3.507-5.669.047.354-.03.516a15.68,15.68,0,0,0,4.275-1.254l-.03-.231.379-.175s.058-.09.017-.4c-.076-.593-.762-.95-2.037-1.059l-.458-.038,0-.036-.824.106a4.385,4.385,0,0,0-1.65.76ZM93.591,53.693a31.792,31.792,0,0,0,.883,4.248c1.885-1.322,2.311-2.008,2.4-2.286a7.854,7.854,0,0,0-3.287-1.962",
    transform: "translate(45.081 25.187)",
    fill: "#fff"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M96.337,49.411q2.752,0,5.066,3.545.162,1.243.525,2.917a9.193,9.193,0,0,0-.712,4.168,1.917,1.917,0,0,0,.993.332,1.3,1.3,0,0,0,.153-.009l1.229-.159a.278.278,0,0,1,.05,0q.729,0,1.1,2.84.134,1.034-3.066,4.163a17.875,17.875,0,0,1-5.092,1.911l-2.316.3a15.751,15.751,0,0,1-2,.147q-2.525,0-2.688-1.261l-.3-1.065a2.289,2.289,0,0,0,.924-1.369q-.647-3.752-.7-4.148-.558-5.564-.536-7.786a4.9,4.9,0,0,0-1.085-1.109l-.039-.305q-.091-.7,3.378-1.85-.02-.157.442-.219l1.853-.238,2.255-.763a4.466,4.466,0,0,1,.566-.036m-4.895,4.045a1.072,1.072,0,0,0,.138-.009q-.046-.357.991-.76l-.021-.158-.5-.246-1.072.14-.423.364a.977.977,0,0,0,.889.669m3.022,5.414h.011l.158-.02Q97.8,56.7,97.66,55.632a8.361,8.361,0,0,0-4.228-2.425l-.159.021-.118.325q.861,5.316,1.31,5.317M95.7,65.935q5.04-1.07,4.952-1.744c.3-.138.411-.466.343-.987q-.173-1.35-2.554-1.553c-.008-.062-.1-.094-.272-.094a2.9,2.9,0,0,0-.355.027l-.782.1a5.712,5.712,0,0,0-2.216,1.067l.4,1.83.039.305-.058.8.5.244m.639-17.662h0a5.373,5.373,0,0,0-.712.047l-.112.014-.106.036-2.149.725-1.741.226a1.88,1.88,0,0,0-.98.376c-2.559.87-3.993,1.657-3.823,2.967l.039.3.055.425.32.282c.361.319.577.522.7.648.015,1.572.193,4.037.542,7.508.026.206.12.809.663,3.96a1.187,1.187,0,0,1-.423.521l-.645.466.216.766.279,1c.168,1.006.977,2.16,3.8,2.16a17.17,17.17,0,0,0,2.148-.156l2.316-.3a18.667,18.667,0,0,0,5.458-2.023l.158-.079.127-.124c2.991-2.928,3.521-4.165,3.4-5.122-.173-1.34-.5-3.832-2.227-3.832h-.073l-.123.012-1.128.146A9.963,9.963,0,0,1,103,56.265l.114-.311-.07-.322c-.235-1.076-.405-2.026-.508-2.823l-.033-.258-.143-.217c-1.759-2.7-3.784-4.061-6.019-4.061M95,57.19c-.123-.51-.284-1.278-.487-2.433a7.173,7.173,0,0,1,1.839,1.2A7.692,7.692,0,0,1,95,57.19m1.1,6.094a3.114,3.114,0,0,1,1.082-.467l.6-.077.566.049c.839.071,1.419.272,1.512.518l-.44.2.032.244a20.028,20.028,0,0,1-3.078.87l-.024-.184-.006-.049-.011-.047Z",
    transform: "translate(44.886 24.993)",
    fill: "#231f20"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M101.351,70.355l.071-.314c.358-1.6.41-1.929.416-2a52.093,52.093,0,0,1-.583-7.912,12.4,12.4,0,0,1-.924-2.888,4.02,4.02,0,0,1-1.278-1.885L99,55.043c-.175-1.031,1.273-1.577,2.937-2,.405-.343,1.594-.677,4.807-1.305l.279-.053.211.19a3.863,3.863,0,0,1,.882,1.714q.628,4.635,1.064,11.835a5.819,5.819,0,0,0,2.069,2.269l.219.137.149.871c.082.486-.31.9-.7,1.246l-.121.106-4.143.7-2.069.554-.077-.458a1.843,1.843,0,0,0-.261-.017,10.063,10.063,0,0,1-1.606.434l-.282.049Zm-1.3-17.37c-.351,0-.681-.216-1.111-.721l-.1-.118-.026-.153a7.423,7.423,0,0,1-.021-.777c-1.415-1.2-1.673-1.727-1.732-2.081l-.077-.46c-.338-2.006.97-3.641,3.888-4.858l.744-.138a10.809,10.809,0,0,1,1.792-.162,5.165,5.165,0,0,1,3.961,1.507l.08.088.354,1.006.05.25a6.712,6.712,0,0,1-.256,2.154,1.925,1.925,0,0,0,.41.466l.149.132.032.2a1.586,1.586,0,0,1-.684,1.744l-.1.061-.965.162-.783-.085a2.252,2.252,0,0,1-1.666.971l-.056,0c-.229,0-.39-.055-1-.513l-.688.967-2.075.351Zm.486-4.392.17-.027a.5.5,0,0,0,.284-.115.487.487,0,0,0,.015-.305c0,.018,0,.024-.012.024a1,1,0,0,0-.188-.023.935.935,0,0,0-.167.015l-.179.03c-.008.015-.017.035-.026.058l.055.322a.211.211,0,0,0,.049.021m3.02-.035.451-.076a1.839,1.839,0,0,0,1-.408.655.655,0,0,0,.137-.627l-.184-1.093-.032-.014a5.515,5.515,0,0,0-1.387,2.213Z",
    transform: "translate(50.182 22.53)",
    fill: "#fff"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M103.6,44.279a4.6,4.6,0,0,1,3.544,1.326l.313.894.027.158a8.436,8.436,0,0,1-.284,2.09,1.732,1.732,0,0,0,.618.858,1.042,1.042,0,0,1-.425,1.167l-.776.131L105.5,50.78q-.228.822-1.41,1.021l0,0a5.616,5.616,0,0,1-1.072-.766l-.9,1.261-1.843.31-.032,0c-.158,0-.382-.173-.677-.519-.014-.079-.017-.393-.011-.946q-1.651-1.371-1.742-1.911l-.077-.46q-.435-2.579,3.547-4.237l.618-.1a10.354,10.354,0,0,1,1.7-.153m.074,5.063.619-.1q1.842-.31,1.607-1.691l-.2-1.223c-.026-.15-.2-.278-.539-.382l-.316.052q-1.853,2.085-1.679,3.125l.511.225m-3,.032.316-.053a.825.825,0,0,0,.765-1.076.765.765,0,0,0-.762-.474,1.6,1.6,0,0,0-.26.023l-.316.053q-.212.036-.382.539l.1.6q.036.225.537.384m6.37,3.119a3.511,3.511,0,0,1,.719,1.462q.6,4.54,1.046,11.823a6.429,6.429,0,0,0,2.333,2.6l.1.618q.041.237-.513.722l-3.986.672-1.515.4q-.057-.332-.8-.332h-.044a11.836,11.836,0,0,1-1.657.442l-.565-.54a21.4,21.4,0,0,0,.428-2.114,53.439,53.439,0,0,1-.583-8.114,10.112,10.112,0,0,1-.977-2.987,3.967,3.967,0,0,1-1.231-1.686l-.053-.316q-.121-.71,2.765-1.413-.057-.341,4.526-1.237M103.6,43.141h0a11.485,11.485,0,0,0-1.89.17l-.616.1-.129.021-.121.052c-3.979,1.659-4.5,3.893-4.23,5.476l.076.46c.088.524.428,1.119,1.724,2.246a3.535,3.535,0,0,0,.03.612l.052.308.2.238a3,3,0,0,0,.882.757,1.687,1.687,0,0,0-.946,1.748l.053.316a4.215,4.215,0,0,0,1.325,2.078,14.546,14.546,0,0,0,.871,2.756,54.608,54.608,0,0,0,.568,7.794c-.03.179-.123.644-.39,1.835l-.141.628.464.443.566.54.413.4.563-.1a10.98,10.98,0,0,0,1.305-.32l.085.511,1.211-.323,1.463-.39,3.932-.663.319-.055.243-.212a2.041,2.041,0,0,0,.886-1.768l-.1-.618-.087-.51-.439-.27a5.161,5.161,0,0,1-1.808-1.946c-.293-4.752-.642-8.671-1.038-11.653l-.014-.1-.029-.094a4.733,4.733,0,0,0-.917-1.841l.059-.036a2.168,2.168,0,0,0,.946-2.322l-.067-.392-.3-.266c-.08-.073-.14-.132-.184-.179a6.329,6.329,0,0,0,.211-2.111l-.026-.158-.017-.1-.032-.093-.313-.892L108.138,45l-.162-.175a5.708,5.708,0,0,0-4.377-1.689",
    transform: "translate(49.988 22.336)",
    fill: "#231f20"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M111.4,67.193c-1.32,0-2.233-.147-2.384-.867l-.19-.9.22-.219a3.537,3.537,0,0,0,.757-3.486l-.481-2.284c-.8-3.779-1.286-4.758-1.465-5.007l-.448.094-.044-.563A5.443,5.443,0,0,1,107.4,52.6c-.111-.428-.422-.889-1.653-.918-.848-.211-1.345-.436-1.443-.9l-.062-.3c-.209-1,1.075-1.585,2.466-2.022a.834.834,0,0,1,.612-.49l.159-.033.873-.038c.955-.66,1.068-.684,1.19-.709,3.13-.451,6.775-1.114,10.871-1.976l.307-.064.219.222a7.484,7.484,0,0,1,1.613,2.009,3.534,3.534,0,0,1,.469,1.369l.1.455c.209.988.7,3.3-.633,3.579l-.443.093-.14-.042a1.965,1.965,0,0,1-1.248-1.067,55.672,55.672,0,0,0-5.872,2.454l.109.521a11.959,11.959,0,0,1,2.776-1.466h.05c.449,0,.818.2,1.531,1.041a1.537,1.537,0,0,1,.7.54l.088.106.2.955-.1.185a8.453,8.453,0,0,0-1.012,2.138l.058.325-.261.149-.121.1q.94-.162,2.041-.334a4.419,4.419,0,0,0,.657-1.852l.041-.194.53-.434.651-.137.114-.006c.669,0,1.317.631,2.475,3.773l.216.994c.176.833.118,2.3-2.228,2.8-2.712.993-5.236,1.8-7.422,2.365l-3.193.358c-.088.09-.282.3-.677.8l-.127.162-.26.053Zm4.787-7.877.557-.118c-.188,0-.384-.015-.589-.032Z",
    transform: "translate(53.958 23.376)",
    fill: "#fff"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M120.727,45.983a6.483,6.483,0,0,1,1.522,1.915q.187.112.411,1.181l.1.457q.576,2.741-.194,2.9l-.3.064a1.477,1.477,0,0,1-1.044-1.211l-.314.065a41.38,41.38,0,0,0-6.564,2.814l.226,1.07c.029.14.212.26.552.361a16.523,16.523,0,0,1,2.862-1.557l.032,0q.3,0,1.137,1.024a.247.247,0,0,1,.047,0c.14,0,.308.121.505.366l.131.613a7.2,7.2,0,0,0-1.079,2.45l-.267.22-.158.033a5.541,5.541,0,0,1-1.131.1,10.874,10.874,0,0,1-1.249-.079l-.2.521.126.6c.059.173.156.26.29.26a.444.444,0,0,0,.076-.008l.457-.1q1.71-.36,4.442-.786.672-.237,1.112-2.292l.267-.22.457-.1a.224.224,0,0,1,.055-.006q.688,0,1.941,3.4l.193.915q.351,1.669-1.789,2.12-4.178,1.521-7.447,2.372l-3.263.361a4.38,4.38,0,0,0-.909,1l-.144.03h-.018q-1.739,0-1.827-.416l-.126-.6a4.1,4.1,0,0,0,.914-4.008l-.481-2.284q-1.154-5.482-1.914-5.482a.2.2,0,0,0-.042,0,10.168,10.168,0,0,1,.058-1.279q-.3-1.4-2.213-1.443c-.568-.153-.868-.3-.9-.452l-.064-.3q-.148-.706,2.406-1.462c-.018-.214.061-.338.234-.376l.156-.032.947-.036a7.615,7.615,0,0,1,1.119-.712q4.683-.674,10.87-1.976m-4.074,16.126.156-.033q1.969-.414,1.874-.871l-.331-.08q-2.1.553-2.031.9l.331.08M121.1,44.74l-.612.129c-4.086.861-7.718,1.521-10.8,1.962a3.459,3.459,0,0,0-1.33.715l-.616.023-.1,0-.094.02-.156.032a1.414,1.414,0,0,0-.883.571c-1.226.395-2.952,1.129-2.638,2.617l.064.3c.19.906,1.184,1.173,1.718,1.316l.131.035.137,0c.809.02,1.018.235,1.091.413A5.153,5.153,0,0,0,107,54.288l.238,1.111.513-.108a25.92,25.92,0,0,1,1.205,4.471l.481,2.284a3.02,3.02,0,0,1-.6,2.966l-.442.436.127.607.126.6c.278,1.32,2.011,1.32,2.941,1.32h.117l.132-.024.144-.029.405-.085.257-.323c.243-.308.4-.5.5-.612l2.9-.32.083-.009.079-.021c2.186-.569,4.7-1.369,7.478-2.377,2.934-.657,2.723-2.8,2.586-3.453l-.193-.914-.017-.082-.029-.077c-1.143-3.1-1.9-4.146-3.01-4.146h-.118l-.172.03-.457.1-.272.058-.216.176-.267.22-.308.252-.083.39a5.169,5.169,0,0,1-.466,1.452c-.238.036-.472.074-.7.111a17.5,17.5,0,0,1,.858-1.7l.206-.372-.088-.414-.131-.613-.056-.269-.173-.214a2.236,2.236,0,0,0-.8-.66,5.432,5.432,0,0,0-.754-.748c.471-.187,1-.39,1.586-.616a2.536,2.536,0,0,0,1.314.906l.281.085.287-.059.3-.064c1.885-.4,1.317-3.1,1.075-4.251l-.1-.458a4.282,4.282,0,0,0-.528-1.534,8.483,8.483,0,0,0-1.7-2.122Z",
    transform: "translate(53.763 23.164)",
    fill: "#231f20"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M121.254,64.341a3.035,3.035,0,0,1-1.4-1.63l-.041-.152.006-.293a12.952,12.952,0,0,1,2.642-5.259l.111-.12.683-.184.135-.008a1.339,1.339,0,0,1,.933.524l.093.1.056.209.038.219-.008.64a11.894,11.894,0,0,0,2.709-.5c.88-.5.766-.92.729-1.058-.073-.273-.618-.436-1.459-.436a13.064,13.064,0,0,0-2.088.209l-.511.087-.064-.238c-.065,0-.152-.009-.27-.009a20.756,20.756,0,0,0-2.393.214l-.162.023-.149-.068a3.408,3.408,0,0,1-1.823-2.381l-.469-2.325a1.418,1.418,0,0,1-.3-.519l-.023-.085,0-.087c.175-4.5,3.122-7.555,8.757-9.073a5.933,5.933,0,0,1,1.527-.2,8.126,8.126,0,0,1,3.177.718,4.541,4.541,0,0,1,1.017-.123,3.028,3.028,0,0,1,1.99.692l.229.19-.026.3a8.837,8.837,0,0,1-1.152,4.357,6.216,6.216,0,0,1-1.252,3l-.117.152-.824.222-.182-.074a2.817,2.817,0,0,0-.4-.143,5.137,5.137,0,0,1-.516.73l-.115.144-.548.149-.131.006a1.7,1.7,0,0,1-1.1-.6l-.117-.111-.083-.311a5.331,5.331,0,0,1-.035-1.357l-.026-.1a2.078,2.078,0,0,0-.511-.047,12.636,12.636,0,0,0-2.038.231c-.888.492-1.864,1.214-1.668,1.94.091.335.724.528,1.736.528a13.87,13.87,0,0,0,1.882-.153h.044a11.581,11.581,0,0,1,5.171,1.1,3.413,3.413,0,0,1,2.834,2.38,1.762,1.762,0,0,1,.39.8l.2.747c.276,1.024-.355,2.211-1.929,3.627a6.312,6.312,0,0,1-3.772,2.53,18.649,18.649,0,0,1-3.148.358h-.006c-.4,0-1.474,0-1.941-.613l-1.817.5-.185-.083a1.617,1.617,0,0,0-.61-.159,2.239,2.239,0,0,1-1.223.952l-.247.067Z",
    transform: "translate(61.212 21.718)",
    fill: "#fff"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M128.714,42.711a7.678,7.678,0,0,1,3.127.747,4.15,4.15,0,0,1,1.067-.153,2.466,2.466,0,0,1,1.627.562q-.271,3.21-1.129,4.172a5.65,5.65,0,0,1-1.158,2.881l-.451.123a2.366,2.366,0,0,0-.858-.229.677.677,0,0,0-.165.02q.055.207-.555.965l-.3.079a.207.207,0,0,1-.055.008q-.237,0-.715-.449l-.041-.155A10.174,10.174,0,0,1,129.1,50l-.079-.3q-.093-.346-1.029-.346a13.5,13.5,0,0,0-2.228.255q-2.388,1.293-2.028,2.632.257.949,2.286.95a14.278,14.278,0,0,0,1.961-.159H128a10.894,10.894,0,0,1,4.939,1.082,2.86,2.86,0,0,1,2.53,2.219l.02,0c.1,0,.2.188.3.566l.2.747q.319,1.186-1.759,3.057a5.92,5.92,0,0,1-3.539,2.4,17.92,17.92,0,0,1-3,.338q-1.425,0-1.575-.557c-.023-.082-.067-.121-.137-.121a.216.216,0,0,0-.059.009l-1.946.524a2.1,2.1,0,0,0-.85-.209,1.221,1.221,0,0,0-.328.042,1.863,1.863,0,0,1-1.035.927,2.553,2.553,0,0,1-1.166-1.3l-.038-.141a12.37,12.37,0,0,1,2.515-5.028l.451-.123a.264.264,0,0,1,.059-.008c.138,0,.308.112.513.338l.038.141-.012,1.137a1.714,1.714,0,0,0,.574.079,12.238,12.238,0,0,0,2.858-.521q1.4-.76,1.131-1.754-.232-.856-2.009-.856a13.361,13.361,0,0,0-2.182.217q-.046-.168-.751-.168a20.735,20.735,0,0,0-2.468.22,2.861,2.861,0,0,1-1.509-2.013l-.49-2.437a1.145,1.145,0,0,1-.276-.408q.248-6.368,8.337-8.545a5.32,5.32,0,0,1,1.378-.178m0-1.138h0a6.46,6.46,0,0,0-1.674.217c-5.9,1.591-8.993,4.819-9.178,9.6l-.008.175.047.17a1.8,1.8,0,0,0,.314.613l.434,2.157a4,4,0,0,0,2.151,2.823l.3.135.323-.042.341-.044a14.407,14.407,0,0,0-2.3,4.93l-.087.3.082.3.038.141a3.556,3.556,0,0,0,1.636,1.958l.428.284.5-.132a2.628,2.628,0,0,0,1.313-.877,1.443,1.443,0,0,1,.14.055l.37.165.39-.1,1.311-.354a3.414,3.414,0,0,0,2.11.539,18.9,18.9,0,0,0,3.2-.357l.047-.009.047-.012a7.075,7.075,0,0,0,4.107-2.75c1.673-1.534,2.325-2.879,2-4.105l-.2-.747a2.569,2.569,0,0,0-.437-.95,3.927,3.927,0,0,0-3.157-2.632,11.051,11.051,0,0,0-2.019-.732c.046-.059.09-.118.134-.178l.3.129.378-.1.451-.121.37-.1.234-.3a6.78,6.78,0,0,0,1.345-3.123,9.67,9.67,0,0,0,1.176-4.532l.05-.592-.458-.379a3.583,3.583,0,0,0-2.352-.824,5,5,0,0,0-.961.1,8.58,8.58,0,0,0-3.233-.692M126.146,50.7a11.994,11.994,0,0,1,1.806-.2,3.817,3.817,0,0,0,.062,1.09l.039.144.046.167h-.175l-.1.011a13.228,13.228,0,0,1-1.8.149,2.809,2.809,0,0,1-1.191-.17c.018-.235.422-.677,1.317-1.185m-1.006,6.59a10.935,10.935,0,0,1,1.536-.129,3.026,3.026,0,0,1,.859.093,1.681,1.681,0,0,1-.414.319,16.208,16.208,0,0,1-1.847.4v-.018l0-.156-.041-.15L125.2,57.5Z",
    transform: "translate(61.017 21.524)",
    fill: "#231f20"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.15a4e8f570590581f3e708e98889c292.svg";
export { ForwardRef as ReactComponent };